<template>
  <div class="container">
    <b-modal :active.sync="printOrderBool" scroll="keep" @close="$emit('update:printOrderBool', false)">
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <p class="modal-card-title">
            {{ $translate('print') | capitalize }}
          </p>
        </header>
        <section class="modal-card-body" />
        <footer class="modal-card-foot">
          <button class="button" type="button" @click="$emit('update:printOrderBool', false)">
            {{ $translate('close') }}
          </button>
          <button class="button is-primary" type="button" @click="prepareMaterial()">
            {{ $translate('print') }}
          </button>
        </footer>
      </div>
    </b-modal>
  </div>
</template>
<script>
import imageHelper from '@/helpers/mixins/variables/imageHelper'
import materialTools from '@/helpers/mixins/materialTools'

import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'

export default {
  name: 'PrintOrder',
  mixins: [imageHelper, materialTools],
  props: ['printOrderBool', 'orders'],
  data() {
    return {
      checkModel: true,
      defaultFontSize: 5,
      falseCheck: [],
      trueCheck: [],
      arrayImageModel: [],
      arrayrowCounterAllacciatura: [],
      availablemoi: [],
      availablesupplan: [],
      availablepel: [],
      availablefode: [],
      availablepas: [],
      availablereinf: [],
      availablemez: [],
      availablepat: [],
      availablemat: [],
      availablesug: [],
      availablepun: [],
      availablemor: [],
      availablepelo: [],
      availablerivplan: [],
      availablepelFits: [],
      availableallacc: [],
      availablefodeFit: [],
      availablepasFits: [],
      availablepatFits: [],
      availablepelModular: [],
      availableripModular: [],
      availableMoiInsole: [],
      availableRicInsole: [],
      availableRieInsole: [],
      availableInsInsole: [],

      modelCounter: 0,
      allacciaCounter: 0,

      deliveryAddress: {
        street: '',
        city: '',
        postalCode: '',
        country: '',
      },
    }
  },
  methods: {
    printOrderTailored(order, index, firstPage, doc, totalPagesExp) {
      this.setOrderAddress(order)
      this.falseCheck = []
      this.trueCheck = []
      this.predispoCheck = []
      let provisional = false

      let materialprodstring = ''
      if (order.materialprod) {
        for (let key in order.materialprod) {
          materialprodstring += order.materialprod[key].qty + ' x ' + this.$translate(order.materialprod[key].name)
          materialprodstring += '\n'
        }
      }
      materialprodstring = materialprodstring.substring(0, materialprodstring.length - 1)

      let materialaccstring = ''
      if (order.materialacc) {
        for (let key in order.materialacc) {
          materialaccstring += order.materialacc[key].qty + ' x ' + this.$translate(order.materialacc[key].name)
          materialaccstring += '\n'
        }
      }
      materialaccstring = materialaccstring.substring(0, materialaccstring.length - 1)

      let printDate = ''
      if (order.history) {
        const sendordEntry = order.history.find(el => el.newStatus === 'sendord')
        if (sendordEntry) {
          printDate = new Date(sendordEntry.date).toLocaleDateString()
        }
      }

      if (order.statusOrder == 'compord' || order.statusOrder == 'invord' || order.statusOrder == 'sendord') {
        provisional = true
      }
      if (firstPage) {
        firstPage = false
      } else {
        doc.addPage()
      }

      doc.rect(350, 10, 204, 71)
      doc.addImage(this.getLogo(), 50, 10, 285, 71)
      if (provisional) {
        doc.text(398, 50, this.$translate('provisional'))
      } else {
        if (order.id_mercury) {
          doc.text(398, 50, order.id_mercury)
        }
      }

      autoTable(doc, {
        theme: 'grid',
        margin: { top: 100 },
        styles: { fillColor: [255, 255, 255] },
        bodyStyles: { cellPadding: 3 },
        rowPageBreak: 'avoid',

        columnStyles: {
          0: { cellWidth: 40 },
          1: { cellWidth: 40 },
          2: { cellWidth: 40 },
          3: { cellWidth: 40 },
          4: { cellWidth: 40 },
          5: { cellWidth: 40 },
          6: { cellWidth: 40 },
          7: { cellWidth: 40 },
          8: { cellWidth: 40 },
          9: { cellWidth: 40 },
          10: { cellWidth: 40 },
          11: { cellWidth: 40 },
        },
        didDrawPage: data => {
          if (data.pageNumber != 1) {
            this.AddHeader(doc, order)
          }

          // Footer
          var str = doc.internal.getNumberOfPages()
          if (typeof doc.putTotalPages === 'function') {
            str = str + '/' + totalPagesExp
          }

          doc.setFontSize(10)

          // jsPDF 1.4+ uses getWidth, <1.4 uses .width
          var pageSize = doc.internal.pageSize
          var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
          doc.text(str, data.settings.margin.left, pageHeight - 10)
        },
        willDrawCell: data => {
          let Cell = data.column.index + ':' + data.row.index

          if (data.cell && data.cell.text && data.cell.text[0] == 'X') {
            data.cell.text = []
            this.falseCheck.push(Cell)
          }
          if (data.cell && data.cell.text && data.cell.text[0] == 'V') {
            data.cell.text = []
            this.trueCheck.push(Cell)
          }
        },
        didDrawCell: data => {
          var dim = 0
          var textPos = {}
          let Cell = data.column.index + ':' + data.row.index

          if (this.falseCheck.includes(Cell)) {
            dim = data.cell.height - data.cell.padding('vertical')
            textPos = data.cell
            this.falseCheck.splice(this.falseCheck.indexOf(Cell), 1)
            doc.addImage(
              this.getCheckFalse(),
              textPos.x + data.cell.width / 2 - dim / 2,
              textPos.y + data.cell.height / 2 - dim / 2,
              10,
              10
            )
          }
          if (this.trueCheck.includes(Cell)) {
            dim = data.cell.height - data.cell.padding('vertical')
            textPos = data.cell
            this.trueCheck.splice(this.trueCheck.indexOf(Cell), 1)
            doc.addImage(
              this.getCheckTrue(),
              textPos.x + data.cell.width / 2 - dim / 2,
              textPos.y + data.cell.height / 2 - dim / 2,
              10,
              10
            )
          }

          if (data.column.index === 0 && data.row.index === 8 && data.cell.section === 'body') {
            // console.log(data);
            dim = data.cell.height - data.cell.padding('vertical')
            textPos = data.cell
            doc.addImage(
              this.getInfo(),
              textPos.x + data.cell.width / 2 - dim / 2,
              textPos.y + data.cell.height / 2 - dim / 2,
              dim,
              dim
            )
          }
          if (data.column.index === 0 && data.row.index === 16 && data.cell.section === 'body') {
            dim = data.cell.height - data.cell.padding('vertical')
            textPos = data.cell
            doc.addImage(
              this.getUser(),
              textPos.x + data.cell.width / 2 - dim / 2,
              textPos.y + data.cell.height / 2 - dim / 2,
              dim,
              dim
            )
          }
          if (data.column.index === 0 && data.row.index === 27 && data.cell.section === 'body') {
            dim = data.cell.height - data.cell.padding('vertical')
            textPos = data.cell
            doc.addImage(
              this.getAttach(),
              textPos.x + data.cell.width / 2 - dim / 2,
              textPos.y + data.cell.height / 2 - dim / 2,
              dim,
              dim
            )
          }
          if (data.column.index === 0 && data.row.index === 36 && data.cell.section === 'body') {
            dim = data.cell.height - data.cell.padding('vertical')
            textPos = data.cell
            doc.addImage(
              this.getShoe(),
              textPos.x + data.cell.width / 2 - dim / 2,
              textPos.y + data.cell.height / 2 - dim / 2,
              dim,
              dim
            )
          }

          if (data.column.index === 0 && data.row.index === 37 && data.cell.section === 'body') {
            if (this.arrayImageModel[this.modelCounter] != false) {
              dim = data.cell.height - data.cell.padding('vertical')
              textPos = data.cell
              doc.addImage(
                this.arrayImageModel[this.modelCounter],
                textPos.x +
                  data.cell.width / 2 -
                  (this.arrayImageModel[this.modelCounter].width *
                    (dim / this.arrayImageModel[this.modelCounter].height)) /
                    2,
                textPos.y + data.cell.height / 2 - dim / 2,
                this.arrayImageModel[this.modelCounter].width * (dim / this.arrayImageModel[this.modelCounter].height),
                dim
              )
            }
            this.modelCounter++
          }
        },

        body: [
          [this.titleRow('order')],
          [this.hrForTable()],
          [
            this.fieldLabel('orderType', 2),
            this.field(this.$options.filters.capitalize(this.$translate(order.orderType)), 6),
            this.fieldLabel('date', 2),
            this.field(printDate, 2),
          ],
          [this.hrForTableNoWidth()],
          [
            this.fieldLabel('orderTypeMain', 2),
            this.field(
              this.$options.filters.capitalize(this.$translate(order.orderTypeMain)) +
                (order.orderTypeVariant
                  ? '\n' + this.$options.filters.capitalize(this.$translate(order.orderTypeVariant))
                  : '') +
                (order.orderTypeSubVariant
                  ? '\n' + this.$options.filters.capitalize(this.$translate(order.orderTypeSubVariant))
                  : ''),
              6
            ),
            this.fieldLabel('formcode', 2),
            this.field(order.formcode ? order.formcode : '', 2),
          ],
          [
            this.fieldLabel('deliverySelected', 2),
            this.field(
              this.$options.filters.capitalize(this.$translate(order.deliverySelected)) +
                (order.deliverySelectedSub
                  ? '\n' + this.$options.filters.capitalize(this.$translate(order.deliverySelectedSub))
                  : ''),

              6
            ),
            this.fieldLabel('expected_delivery_date', 2),
            this.field(order.deliveryDate != undefined ? new Date(order.deliveryDate).toLocaleDateString() : '', 2),
          ],
          [
            this.fieldLabel('last_in', 2),
            this.field(order.footmeasurements.last_in ? 'V' : 'X', 2),
            this.fieldLabel('without_junction', 2),
            this.field(order.footmeasurements.without_junction ? 'V' : 'X', 2),
            this.fieldLabel('pairSelected', 2),
            this.field(
              order.pair === 'right'
                ? this.$translate('pairRight')
                : order.pair === 'left'
                ? this.$translate('pairLeft')
                : this.$translate('pairBoth'),
              2
            ),
          ],
          [this.hrForTableNoWidth()],
          [
            {
              content: '',
              styles: {
                halign: 'center',
                valign: 'middle',
              },
            },
            this.titleRow('generalInfo', 1),
          ],
          [this.hrForTable()],
          [
            this.fieldLabel('cod', 1),
            this.field(order.company.mercurio_id ? order.company.mercurio_id : '', 1),
            this.fieldLabel('customer', 1),
            this.field(order.company.name, 5),
            this.fieldLabel('shop', 1),
            this.field(order.shop.name, 3),
          ],
          [
            this.fieldLabel('delivery_address', 2),
            this.field(
              this.deliveryAddress.street +
                ' ' +
                this.deliveryAddress.city +
                ' ' +
                this.deliveryAddress.postalCode +
                ' ' +
                this.$translate(this.deliveryAddress.country),
              6
            ),
            this.fieldLabel('tec', 1),
            this.field(order.tec, 3),
          ],
          [
            this.fieldLabel('primaryCode', 2),
            this.field(order.primaryCode, 4),
            this.fieldLabel('secondaryCode', 2),
            this.field(order.secondaryCode ? order.secondaryCode : '', 4),
          ],
          [
            this.fieldLabel('prec_pair_print', 2),
            this.field(order.prec_pair ? order.prec_pair : '', 4),
            this.fieldLabel('prec_order_print', 2),
            this.field(order.prec_order ? order.prec_order : '', 4),
          ],
          [
            this.fieldLabel('subtitle_form_order_production', 2),
            this.field(materialprodstring ? materialprodstring : '', 4),
            this.fieldLabel('subtitle_form_order_companion', 2),
            this.field(materialaccstring ? materialaccstring : '', 4),
          ],
          [this.hrForTableNoWidth()],
          [
            {
              content: '',
              styles: {
                halign: 'center',
                valign: 'middle',
              },
            },
            this.titleRow('patient', 1),
          ],
          [this.hrForTable()],
          [
            this.fieldLabel('sex', 1),
            this.field(this.$translate(order.patient.gender), 1),
            this.fieldLabel('patient', 1),
            this.field(order.patient.name + ' ' + order.patient.surname, 5),
            this.fieldLabel('alias', 1),
            this.field(order.patient.alias, 3),
          ],
          [
            this.fieldLabel('authorization', 2),
            this.field(order.ASLprotocol != null ? order.ASLprotocol : '', 2),
            this.fieldLabel('prec_pair', 2),
            this.field(order.prec_pair != null ? order.prec_pair : '', 2),
            this.fieldLabel('rif_history', 2),
            this.field('', 2),
          ],
          [this.hrForTable()],
          [
            this.field(this.$options.filters.capitalize(this.$translate('left')), 6),
            this.field(this.$options.filters.capitalize(this.$translate('right')), 6),
          ],
          [
            this.fieldLabel('pathologies', 3),
            this.field(
              order.pathologiesLeft && order.pathologiesLeft.length != 0 ? order.pathologiesLeft.join(',') : '',
              3,
              2
            ),
            this.fieldLabel('pathologies', 3),
            this.field(
              order.pathologiesRight && order.pathologiesRight.length != 0 ? order.pathologiesRight.join(',') : '',
              3,
              2
            ),
          ],
          [this.field('', 3), this.field('', 3)],
          [
            this.fieldLabel('block_F_E', 3),
            this.field(order.footmeasurements && order.footmeasurements.block_F_E_sx ? 'V' : 'X', 3),
            this.fieldLabel('block_F_E', 3),
            this.field(order.footmeasurements && order.footmeasurements.block_F_E_dx ? 'V' : 'X', 3),
          ],
          [
            this.fieldLabel('block_P_S', 3),
            this.field(order.footmeasurements && order.footmeasurements.block_P_S_sx ? 'V' : 'X', 3),
            this.fieldLabel('block_P_S', 3),
            this.field(order.footmeasurements && order.footmeasurements.block_P_S_dx ? 'V' : 'X', 3),
          ],
          [this.hrForTableNoWidth()],
          [
            {
              content: '',
              styles: {
                halign: 'center',
                valign: 'middle',
              },
            },
            this.titleRow('attach', 1),
          ],
          [
            this.field(this.$options.filters.capitalize(this.$translate('left')), 6),
            this.field(this.$options.filters.capitalize(this.$translate('right')), 6),
          ],
          [
            this.fieldLabel(order.attachment && order.attachment.scan_stl_sx ? 'V' : 'X', 1),
            this.fieldLabel('scan_duna', 2),
            this.field(
              order.attachment && order.attachment.scan_stl_sx
                ? order.id_mercury
                  ? order.id_mercury + '_scan_stl_sx'
                  : order.id + '_scan_stl_sx'
                : '',
              3
            ),
            this.fieldLabel(order.attachment && order.attachment.scan_stl_dx ? 'V' : 'X', 1),
            this.fieldLabel('scan_duna', 2),
            this.field(
              order.attachment && order.attachment.scan_stl_dx
                ? order.id_mercury
                  ? order.id_mercury + '_scan_stl_dx'
                  : order.id + '_scan_stl_dx'
                : '',
              3
            ),
          ],
          [
            this.fieldLabel(order.attachment && order.attachment.scan_pln_sx ? 'V' : 'X', 1),
            this.fieldLabel('plan', 2),
            this.field(
              order.attachment && order.attachment.scan_pln_sx
                ? order.id_mercury
                  ? order.id_mercury + '_scan_pln_sx'
                  : order.id + '_scan_pln_sx'
                : '',
              3
            ),
            this.fieldLabel(order.attachment && order.attachment.scan_pln_dx ? 'V' : 'X', 1),
            this.fieldLabel('plan', 2),
            this.field(
              order.attachment && order.attachment.scan_pln_dx
                ? order.id_mercury
                  ? order.id_mercury + '_scan_pln_dx'
                  : order.id + '_scan_pln_dx'
                : '',
              3
            ),
          ],
          [
            this.fieldLabel(order.attachment && order.attachment.scan_fms_sx ? 'V' : 'X', 1),
            this.fieldLabel('mesu', 2),
            this.field(
              order.attachment && order.attachment.scan_fms_sx
                ? order.id_mercury
                  ? order.id_mercury + '_scan_fms_sx'
                  : order.id + '_scan_fms_sx'
                : '',
              3
            ),
            this.fieldLabel(order.attachment && order.attachment.scan_fms_dx ? 'V' : 'X', 1),
            this.fieldLabel('mesu', 2),
            this.field(
              order.attachment && order.attachment.scan_fms_dx
                ? order.id_mercury
                  ? order.id_mercury + '_scan_fms_dx'
                  : order.id + '_scan_fms_dx'
                : '',
              3
            ),
          ],
          [
            this.fieldLabel(order.attachment && order.attachment.scan_no_duna_sx ? 'V' : 'X', 1),
            this.fieldLabel('scan', 2),
            this.field(
              order.attachment && order.attachment.scan_no_duna_sx
                ? order.id_mercury
                  ? order.id_mercury + '_scan_no_duna_sx'
                  : order.id + '_scan_no_duna_sx'
                : '',
              3
            ),
            this.fieldLabel(order.attachment && order.attachment.scan_no_duna_dx ? 'V' : 'X', 1),
            this.fieldLabel('scan', 2),
            this.field(
              order.attachment && order.attachment.scan_no_duna_dx
                ? order.id_mercury
                  ? order.id_mercury + '_scan_no_duna_dx'
                  : order.id + '_scan_no_duna_dx'
                : '',
              3
            ),
          ],
          [
            this.fieldLabel(order.attachment && order.attachment.grap_sx ? 'V' : 'X', 1),
            this.fieldLabel('grap', 2),
            this.field(
              order.attachment && order.attachment.grap_sx
                ? order.id_mercury
                  ? order.id_mercury + '_grap_sx'
                  : order.id + '_grap_sx'
                : '',
              3
            ),
            this.fieldLabel(order.attachment && order.attachment.grap_dx ? 'V' : 'X', 1),
            this.fieldLabel('scan_duna', 2),
            this.field(
              order.attachment && order.attachment.grap_dx
                ? order.id_mercury
                  ? order.id_mercury + '_grap_dx'
                  : order.id + '_grap_dx'
                : '',
              3
            ),
          ],
          [
            this.fieldLabel(order.attachment && order.attachment.attach_sx ? 'V' : 'X', 1),
            this.fieldLabel('attach', 2),
            this.field(
              order.attachment && order.attachment.attach_sx
                ? order.id_mercury
                  ? order.id_mercury + '_attach_sx'
                  : order.id + '_attach_sx'
                : '',
              3
            ),
            this.fieldLabel(order.attachment && order.attachment.attach_dx ? 'V' : 'X', 1),
            this.fieldLabel('attach', 2),
            this.field(
              order.attachment && order.attachment.attach_dx
                ? order.id_mercury
                  ? order.id_mercury + '_attach_dx'
                  : order.id + '_attach_dx'
                : '',
              3
            ),
          ],
          [this.hrForTableNoWidth()],
          [
            {
              content: '',
              styles: {
                halign: 'center',
                valign: 'middle',
              },
            },
            this.titleRow('shoe', 1),
          ],
          [
            this.field('', 6, 8),
            this.fieldLabel('shoeType', 3),
            this.field(
              order.shoeType
                ? this.$options.filters.capitalize(this.$translate(order.shoeType))
                : order.mod && order.mod.shoeType
                ? this.$options.filters.capitalize(this.$translate(order.mod.shoeType))
                : '',
              3
            ),
          ],
          [
            this.fieldLabel('catalogType', 3),
            this.field(
              order.catalogType
                ? this.$options.filters.capitalize(this.$translate(order.catalogType))
                : order.mod && order.mod.catalogType
                ? this.$options.filters.capitalize(this.$translate(order.mod.catalogType))
                : '',
              3
            ),
          ],
          [
            this.fieldLabel('model', 3),
            this.field(this.getModel(order), 3),
            //  order.mod && order.mod.name
            //    ? this.$options.filters.capitalize(order.mod.name)
            //    : "",
            //  3
            //),
          ],

          [
            this.fieldLabel('catalog', 2),
            this.field(
              order.mod &&
                (!order.mod.custom || (order.mod.custom && order.mod.from_duna_catalog)) &&
                order.mod.catalog_pag != null
                ? order.mod.catalog_spec
                : '',
              2
            ),
            this.fieldLabel('catalog_pag', 1),
            this.field(
              order.mod &&
                (!order.mod.custom || (order.mod.custom && order.mod.from_duna_catalog)) &&
                order.mod.catalog_pag != null
                ? order.mod.catalog_pag
                : '',
              1
            ),
          ],
          [
            this.fieldLabel('color_bool', 3),
            this.field(
              order.mod &&
                (!order.mod.custom || (order.mod.custom && order.mod.from_duna_catalog)) &&
                order.mod.color_bool != null
                ? order.mod.color_bool
                  ? 'V'
                  : 'X'
                : '',

              3
            ),
          ],
          [this.hrForTable()],
          [
            this.fieldLabel('note', 2),
            this.field(
              order.mod &&
                (!order.mod.custom || (order.mod.custom && order.mod.from_duna_catalog)) &&
                order.mod.model_spec != null
                ? order.mod.model_spec
                : order.mod.selectedCatalog &&
                  order.mod.selectedCatalog == 'from_samples' &&
                  order.mod.code_from_samples != null
                ? '12' + order.mod.code_from_samples + '0'
                : order.mod.selectedCatalog &&
                  order.mod.selectedCatalog == 'from_duna_site' &&
                  order.mod.model_from_duna_site != null &&
                  order.mod.color_from_duna_site != null
                ? order.mod.model_from_duna_site + ' ' + order.mod.color_from_duna_site
                : '' + order.note != 'undefined'
                ? ' -NOTE: ' + order.note
                : '',
              4,
              2
            ),
          ],

          [this.field('', 2)],
        ],
      })

      doc.addPage()
      autoTable(doc, {
        theme: 'grid',
        margin: { top: 100 },
        styles: { fillColor: [255, 255, 255] },
        bodyStyles: { cellPadding: 3 },
        rowPageBreak: 'avoid',

        columnStyles: {
          0: { cellWidth: 40 },
          1: { cellWidth: 40 },
          2: { cellWidth: 40 },
          3: { cellWidth: 40 },
          4: { cellWidth: 40 },
          5: { cellWidth: 40 },
          6: { cellWidth: 40 },
          7: { cellWidth: 40 },
          8: { cellWidth: 40 },
          9: { cellWidth: 40 },
          10: { cellWidth: 40 },
          11: { cellWidth: 40 },
        },
        didDrawPage: data => {
          this.AddHeader(doc, order)

          // Footer
          var str = doc.internal.getNumberOfPages()
          if (typeof doc.putTotalPages === 'function') {
            str = str + '/' + totalPagesExp
          }
          doc.setFontSize(10)

          // jsPDF 1.4+ uses getWidth, <1.4 uses .width
          var pageSize = doc.internal.pageSize
          var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
          doc.text(str, data.settings.margin.left, pageHeight - 10)
        },
        willDrawCell: data => {
          let Cell = data.column.index + ':' + data.row.index

          if (data.cell && data.cell.text && data.cell.text[0] == 'X') {
            data.cell.text = []
            this.falseCheck.push(Cell)
          }
          if (data.cell && data.cell.text && data.cell.text[0] == 'V') {
            data.cell.text = []
            this.trueCheck.push(Cell)
          }
          if (data.cell && data.cell.text && data.cell.text[0] == 'P') {
            data.cell.text = []
            this.predispoCheck.push(Cell)
          }

          if (
            (data.row.index === 7 ||
              data.row.index === 8 ||
              data.row.index === 9 ||
              data.row.index === 10 ||
              data.row.index === 11 ||
              data.row.index === 12 ||
              data.row.index === 13 ||
              data.row.index === 14 ||
              data.row.index === 15 ||
              data.row.index === 16 ||
              data.row.index === 17 ||
              data.row.index === 18 ||
              data.row.index === 19 ||
              data.row.index === 20 ||
              data.row.index === 21 ||
              data.row.index === 22 ||
              data.row.index === 23) &&
            data.cell.section === 'body'
          ) {
            let diff = data.cell.height - 30
            data.cell.minCellHeight = 30
            data.cell.height = 30
            data.row.height = 30
            data.cell.y -= diff / 2
          }
        },
        didDrawCell: data => {
          var dim = 0
          var textPos = {}
          let Cell = data.column.index + ':' + data.row.index

          if (this.falseCheck.includes(Cell)) {
            dim = data.cell.height - data.cell.padding('vertical')
            textPos = data.cell
            this.falseCheck.splice(this.falseCheck.indexOf(Cell), 1)
            doc.addImage(
              this.getCheckFalse(),
              textPos.x + data.cell.width / 2 - dim / 2,
              textPos.y + data.cell.height / 2 - dim / 2,
              10,
              10
            )
          }
          if (this.trueCheck.includes(Cell)) {
            dim = data.cell.height - data.cell.padding('vertical')
            textPos = data.cell
            this.trueCheck.splice(this.trueCheck.indexOf(Cell), 1)
            doc.addImage(
              this.getCheckTrue(),
              textPos.x + data.cell.width / 2 - dim / 2,
              textPos.y + data.cell.height / 2 - dim / 2,
              10,
              10
            )
          }

          if (this.predispoCheck.includes(Cell)) {
            dim = data.cell.height - data.cell.padding('vertical')
            textPos = data.cell
            this.predispoCheck.splice(this.predispoCheck.indexOf(Cell), 1)
            doc.addImage(
              this.getPredisspo(),
              textPos.x + data.cell.width / 2 - dim / 2,
              textPos.y + data.cell.height / 2 - dim / 2,
              dim * 2,
              dim
            )
          }

          if (data.column.index === 0 && data.row.index === 0 && data.cell.section === 'body') {
            dim = data.cell.height - data.cell.padding('vertical')
            textPos = data.cell
            doc.addImage(
              this.getMesaurement(),
              textPos.x + data.cell.width / 2 - dim / 2,
              textPos.y + data.cell.height / 2 - dim / 2,
              dim,
              dim
            )
          }

          if (data.column.index === 0 && data.row.index === 7 && data.cell.section === 'body') {
            textPos = data.cell

            doc.addImage(
              this.getLongImage(),
              textPos.x + data.cell.width / 2 - 60.84 / 2,
              textPos.y + data.cell.height / 2 - 18,
              60.84,
              24
            )
          }

          if (data.column.index === 6 && data.row.index === 7 && data.cell.section === 'body') {
            textPos = data.cell

            doc.addImage(
              this.getLongImage(),
              textPos.x + data.cell.width / 2 - 60.84 / 2,
              textPos.y + data.cell.height / 2 - 18,
              60.84,
              24
            )
          }

          if (data.column.index === 0 && data.row.index === 8 && data.cell.section === 'body') {
            textPos = data.cell

            doc.addImage(
              this.getLargeImage(),
              textPos.x + data.cell.width / 2 - 60.84 / 2,
              textPos.y + data.cell.height / 2 - 18,
              60.84,
              24
            )
          }

          if (data.column.index === 6 && data.row.index === 8 && data.cell.section === 'body') {
            textPos = data.cell

            doc.addImage(
              this.getLargeImage(),
              textPos.x + data.cell.width / 2 - 60.84 / 2,
              textPos.y + data.cell.height / 2 - 18,
              60.84,
              24
            )
          }

          if (data.column.index === 0 && data.row.index === 9 && data.cell.section === 'body') {
            textPos = data.cell

            doc.addImage(
              this.getCircMetaImage(),
              textPos.x + data.cell.width / 2 - 60.84 / 2,
              textPos.y + data.cell.height / 2 - 18,
              60.84,
              24
            )
          }

          if (data.column.index === 6 && data.row.index === 9 && data.cell.section === 'body') {
            textPos = data.cell

            doc.addImage(
              this.getCircMetaImage(),
              textPos.x + data.cell.width / 2 - 60.84 / 2,
              textPos.y + data.cell.height / 2 - 18,
              60.84,
              24
            )
          }

          if (data.column.index === 0 && data.row.index === 10 && data.cell.section === 'body') {
            textPos = data.cell

            doc.addImage(
              this.getCircRetroMetaImage(),
              textPos.x + data.cell.width / 2 - 60.84 / 2,
              textPos.y + data.cell.height / 2 - 18,
              60.84,
              24
            )
          }

          if (data.column.index === 6 && data.row.index === 10 && data.cell.section === 'body') {
            textPos = data.cell

            doc.addImage(
              this.getCircRetroMetaImage(),
              textPos.x + data.cell.width / 2 - 60.84 / 2,
              textPos.y + data.cell.height / 2 - 18,
              60.84,
              24
            )
          }

          if (data.column.index === 0 && data.row.index === 11 && data.cell.section === 'body') {
            textPos = data.cell

            doc.addImage(
              this.getCircColloImage(),
              textPos.x + data.cell.width / 2 - 43.2 / 2,
              textPos.y + data.cell.height / 2 - 18,
              43.2,
              24
            )
          }

          if (data.column.index === 6 && data.row.index === 11 && data.cell.section === 'body') {
            textPos = data.cell

            doc.addImage(
              this.getCircColloImage(),
              textPos.x + data.cell.width / 2 - 43.2 / 2,
              textPos.y + data.cell.height / 2 - 18,
              43.2,
              24
            )
          }

          if (data.column.index === 0 && data.row.index === 12 && data.cell.section === 'body') {
            textPos = data.cell

            doc.addImage(
              this.getCircPassata(),
              textPos.x + data.cell.width / 2 - 43.2 / 2,
              textPos.y + data.cell.height / 2 - 18,
              43.2,
              24
            )
          }

          if (data.column.index === 6 && data.row.index === 12 && data.cell.section === 'body') {
            textPos = data.cell

            doc.addImage(
              this.getCircPassata(),
              textPos.x + data.cell.width / 2 - 43.2 / 2,
              textPos.y + data.cell.height / 2 - 18,
              43.2,
              24
            )
          }

          if (data.column.index === 0 && data.row.index === 13 && data.cell.section === 'body') {
            textPos = data.cell

            doc.addImage(
              this.getCircMalleoliImage(),
              textPos.x + data.cell.width / 2 - 43.2 / 2,
              textPos.y + data.cell.height / 2 - 18,
              43.2,
              24
            )
          }

          if (data.column.index === 6 && data.row.index === 13 && data.cell.section === 'body') {
            textPos = data.cell

            doc.addImage(
              this.getCircMalleoliImage(),
              textPos.x + data.cell.width / 2 - 43.2 / 2,
              textPos.y + data.cell.height / 2 - 18,
              43.2,
              24
            )
          }

          if (data.column.index === 0 && data.row.index === 17 && data.cell.section === 'body') {
            textPos = data.cell

            doc.addImage(
              this.getCircTermineTomaiaImage(),
              textPos.x + data.cell.width / 2 - 43.2 / 2,
              textPos.y + data.cell.height / 2 - 18,
              43.2,
              24
            )
          }

          if (data.column.index === 6 && data.row.index === 17 && data.cell.section === 'body') {
            textPos = data.cell

            doc.addImage(
              this.getCircTermineTomaiaImage(),
              textPos.x + data.cell.width / 2 - 43.2 / 2,
              textPos.y + data.cell.height / 2 - 18,
              43.2,
              24
            )
          }

          if (data.column.index === 0 && data.row.index === 16 && data.cell.section === 'body') {
            textPos = data.cell

            doc.addImage(
              this.getAltezzaTermineTomaiaImage(),
              textPos.x + data.cell.width / 2 - 17.28 / 2,
              textPos.y + data.cell.height / 2 - 18,
              17.28,
              24
            )
          }

          if (data.column.index === 6 && data.row.index === 16 && data.cell.section === 'body') {
            textPos = data.cell

            doc.addImage(
              this.getAltezzaTermineTomaiaImage(),
              textPos.x + data.cell.width / 2 - 17.28 / 2,
              textPos.y + data.cell.height / 2 - 18,
              17.28,
              24
            )
          }
          if (data.column.index === 0 && data.row.index === 18 && data.cell.section === 'body') {
            textPos = data.cell

            doc.addImage(
              this.getAltezzaTotFormaImage(),
              textPos.x + data.cell.width / 2 - 17.28 / 2,
              textPos.y + data.cell.height / 2 - 18,
              17.28,
              24
            )
          }

          if (data.column.index === 6 && data.row.index === 18 && data.cell.section === 'body') {
            textPos = data.cell

            doc.addImage(
              this.getAltezzaTotFormaImage(),
              textPos.x + data.cell.width / 2 - 17.28 / 2,
              textPos.y + data.cell.height / 2 - 18,
              17.28,
              24
            )
          }

          if (data.column.index === 0 && data.row.index === 21 && data.cell.section === 'body') {
            textPos = data.cell

            doc.addImage(
              this.getHighPointImage(),
              textPos.x + data.cell.width / 2 - 60.84 / 2,
              textPos.y + data.cell.height / 2 - 18,
              60.84,
              24
            )
          }

          if (data.column.index === 6 && data.row.index === 21 && data.cell.section === 'body') {
            textPos = data.cell

            doc.addImage(
              this.getHighPointImage(),
              textPos.x + data.cell.width / 2 - 60.84 / 2,
              textPos.y + data.cell.height / 2 - 18,
              60.84,
              24
            )
          }

          if (data.column.index === 0 && data.row.index === 24 && data.cell.section === 'body') {
            dim = data.cell.height - data.cell.padding('vertical')
            textPos = data.cell
            doc.addImage(
              this.getMesaurement(),
              textPos.x + data.cell.width / 2 - dim / 2,
              textPos.y + data.cell.height / 2 - dim / 2,
              dim,
              dim
            )
          }
        },

        body:
          order.plan_realization == 'reali_proper'
            ? [
                [
                  {
                    content: '',
                    styles: {
                      halign: 'center',
                      valign: 'middle',
                    },
                  },
                  this.titleRow('forma', 1),
                ],

                [this.hrForTable()],
                [
                  this.fieldLabel('c_style', 3),
                  this.field(order.footmeasurements ? this.$translate(order.footmeasurements.c_style) : '', 3),
                  this.fieldLabel('type', 3),
                  this.field(order.footmeasurements ? this.$translate(order.footmeasurements.c_form) : '', 3),
                ],
                [
                  this.fieldLabel('point', 3),
                  this.field(order.footmeasurements ? this.$translate(order.footmeasurements.c_point) : '', 3),
                  this.fieldLabel('c_pair', 3),
                  this.field(order.footmeasurements ? this.$translate(order.footmeasurements.c_pair) : '', 3),
                ],
                [this.hrForTable()],
                [
                  this.field('SX', 2),
                  this.fieldLabel('measure', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.measure_sx != null
                      ? order.footmeasurements.measure_sx
                      : '',
                    2
                  ),
                  this.field('DX', 2),
                  this.fieldLabel('measure', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.measure_dx != null
                      ? order.footmeasurements.measure_dx
                      : '',
                    2
                  ),
                ],
                [
                  this.fieldLabel('image', 2),
                  this.fieldLabel('mesu', 2),
                  this.fieldLabel('foot', 1),
                  this.fieldLabel('last', 1),
                  this.fieldLabel('image', 2),
                  this.fieldLabel('mesu', 2),
                  this.fieldLabel('foot', 1),
                  this.fieldLabel('last', 1),
                ],
                [
                  this.field('', 2),
                  this.fieldLabel('f_long_form', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_long_formfoot_sx != null
                      ? order.footmeasurements.f_long_formfoot_sx
                      : '',
                    1
                  ),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_long_formplan_sx != null
                      ? order.footmeasurements.f_long_formplan_sx
                      : '',
                    1
                  ),
                  this.field('', 2),
                  this.fieldLabel('f_long_form', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_long_formfoot_dx != null
                      ? order.footmeasurements.f_long_formfoot_dx
                      : '',
                    1
                  ),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_long_formplan_dx != null
                      ? order.footmeasurements.f_long_formplan_dx
                      : '',
                    1
                  ),
                ],
                [
                  this.field('', 2),
                  this.fieldLabel('f_large_form', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_large_formfoot_sx != null
                      ? order.footmeasurements.f_large_formfoot_sx
                      : '',
                    1
                  ),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_large_formplan_sx != null
                      ? order.footmeasurements.f_large_formplan_sx
                      : '',
                    1
                  ),
                  this.field('', 2),
                  this.fieldLabel('f_large_form', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_large_formfoot_dx != null
                      ? order.footmeasurements.f_large_formfoot_dx
                      : '',
                    1
                  ),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_large_formplan_dx != null
                      ? order.footmeasurements.f_large_formplan_dx
                      : '',
                    1
                  ),
                ],
                [
                  this.field('', 2),
                  this.fieldLabel('f_circ_meta', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_circ_metafoot_sx != null
                      ? order.footmeasurements.f_circ_metafoot_sx
                      : '',
                    1
                  ),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_circ_metaplan_sx != null
                      ? order.footmeasurements.f_circ_metaplan_sx
                      : '',
                    1
                  ),
                  this.field('', 2),
                  this.fieldLabel('f_circ_meta', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_circ_metafoot_dx != null
                      ? order.footmeasurements.f_circ_metafoot_dx
                      : '',
                    1
                  ),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_circ_metaplan_dx != null
                      ? order.footmeasurements.f_circ_metaplan_dx
                      : '',
                    1
                  ),
                ],
                [
                  this.field('', 2),
                  this.fieldLabel('f_circ_retrometa', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_circ_retrometafoot_sx != null
                      ? order.footmeasurements.f_circ_retrometafoot_sx
                      : '',
                    1
                  ),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_circ_retrometaplan_sx != null
                      ? order.footmeasurements.f_circ_retrometaplan_sx
                      : '',
                    1
                  ),
                  this.field('', 2),
                  this.fieldLabel('f_circ_retrometa', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_circ_retrometafoot_dx != null
                      ? order.footmeasurements.f_circ_retrometafoot_dx
                      : '',
                    1
                  ),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_circ_retrometaplan_dx != null
                      ? order.footmeasurements.f_circ_retrometaplan_dx
                      : '',
                    1
                  ),
                ],
                [
                  this.field('', 2),
                  this.fieldLabel('f_circ_neck', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_circ_neckfoot_sx != null
                      ? order.footmeasurements.f_circ_neckfoot_sx
                      : '',
                    1
                  ),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_circ_neckplan_sx != null
                      ? order.footmeasurements.f_circ_neckplan_sx
                      : '',
                    1
                  ),
                  this.field('', 2),
                  this.fieldLabel('f_circ_neck', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_circ_neckfoot_dx != null
                      ? order.footmeasurements.f_circ_neckfoot_dx
                      : '',
                    1
                  ),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_circ_neckplan_dx != null
                      ? order.footmeasurements.f_circ_neckplan_dx
                      : '',
                    1
                  ),
                ],
                [
                  this.field('', 2),
                  this.fieldLabel('f_circ_pass', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_circ_passfoot_sx != null
                      ? order.footmeasurements.f_circ_passfoot_sx
                      : '',
                    1
                  ),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_circ_passplan_sx != null
                      ? order.footmeasurements.f_circ_passplan_sx
                      : '',
                    1
                  ),
                  this.field('', 2),
                  this.fieldLabel('f_circ_pass', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_circ_passfoot_dx != null
                      ? order.footmeasurements.f_circ_passfoot_dx
                      : '',
                    1
                  ),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_circ_passplan_dx != null
                      ? order.footmeasurements.f_circ_passplan_dx
                      : '',
                    1
                  ),
                ],
                [
                  this.field('', 2),
                  this.fieldLabel('f_circ_mall', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_circ_mallfoot_sx != null
                      ? order.footmeasurements.f_circ_mallfoot_sx
                      : '',
                    1
                  ),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_circ_mallplan_sx != null
                      ? order.footmeasurements.f_circ_mallplan_sx
                      : '',
                    1
                  ),
                  this.field('', 2),
                  this.fieldLabel('f_circ_mall', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_circ_mallfoot_dx != null
                      ? order.footmeasurements.f_circ_mallfoot_dx
                      : '',
                    1
                  ),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_circ_mallplan_dx != null
                      ? order.footmeasurements.f_circ_mallplan_dx
                      : '',
                    1
                  ),
                ],
                [
                  this.field('', 2),
                  this.fieldLabel('high_ankle', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.high_ankle_sx != null
                      ? order.footmeasurements.high_ankle_sx
                      : '',
                    1
                  ),
                  this.field('#', 1),
                  this.field('', 2),
                  this.fieldLabel('high_ankle', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.high_ankle_dx != null
                      ? order.footmeasurements.high_ankle_dx
                      : '',
                    1
                  ),
                  this.field('#', 1),
                ],
                [
                  this.field('', 2),
                  this.fieldLabel('circ_leg', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.circ_leg_sx != null
                      ? order.footmeasurements.circ_leg_sx
                      : '',
                    1
                  ),
                  this.field('#', 1),
                  this.field('', 2),
                  this.fieldLabel('circ_leg', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.circ_leg_dx != null
                      ? order.footmeasurements.circ_leg_dx
                      : '',
                    1
                  ),
                  this.field('#', 1),
                ],
                [
                  this.field('', 2),
                  this.fieldLabel('high_leg', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.high_leg_sx != null
                      ? order.footmeasurements.high_leg_sx
                      : '',
                    1
                  ),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_high_term_tomplan_sx != null
                      ? order.footmeasurements.f_high_term_tomplan_sx
                      : '',
                    1
                  ),
                  this.field('', 2),
                  this.fieldLabel('high_leg', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.high_leg_dx != null
                      ? order.footmeasurements.high_leg_dx
                      : '',
                    1
                  ),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_high_term_tomplan_dx != null
                      ? order.footmeasurements.f_high_term_tomplan_dx
                      : '',
                    1
                  ),
                ],
                [
                  this.field('', 2),
                  this.fieldLabel('termtom', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_circ_term_tomfoot_sx != null
                      ? order.footmeasurements.f_circ_term_tomfoot_sx
                      : '',
                    1
                  ),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_circ_term_tomplan_sx != null
                      ? order.footmeasurements.f_circ_term_tomplan_sx
                      : '',
                    1
                  ),
                  this.field('', 2),
                  this.fieldLabel('termtom', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_circ_term_tomfoot_dx != null
                      ? order.footmeasurements.f_circ_term_tomfoot_dx
                      : '',
                    1
                  ),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_circ_term_tomplan_dx != null
                      ? order.footmeasurements.f_circ_term_tomplan_dx
                      : '',
                    1
                  ),
                ],
                [
                  this.field('', 2),
                  this.fieldLabel('f_high_tot', 2),
                  this.field('#', 1),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_high_totplan_sx != null
                      ? order.footmeasurements.f_high_totplan_sx
                      : '',
                    1
                  ),
                  this.field('', 2),
                  this.fieldLabel('f_high_tot', 2),
                  this.field('#', 1),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_high_totplan_dx != null
                      ? order.footmeasurements.f_high_totplan_dx
                      : '',
                    1
                  ),
                ],
                [
                  this.field('', 2),
                  this.fieldLabel('circ_end_tom', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.circ_end_tom_sx != null
                      ? order.footmeasurements.circ_end_tom_sx
                      : '',
                    1
                  ),
                  this.field('#', 1),
                  this.field('', 2),
                  this.fieldLabel('circ_end_tom', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.circ_end_tom_dx != null
                      ? order.footmeasurements.circ_end_tom_dx
                      : '',
                    1
                  ),
                  this.field('#', 1),
                ],
                [
                  this.field('', 2),
                  this.fieldLabel('high_tom', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.high_tom_sx != null
                      ? order.footmeasurements.high_tom_sx
                      : '',
                    1
                  ),
                  this.field('#', 1),
                  this.field('', 2),
                  this.fieldLabel('high_tom', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.high_tom_dx != null
                      ? order.footmeasurements.high_tom_dx
                      : '',
                    1
                  ),
                  this.field('#', 1),
                ],
                [
                  this.field('', 2),
                  this.fieldLabel('Toe Height', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.high_fings_sx != null
                      ? order.footmeasurements.high_fings_sx
                      : '',
                    1
                  ),
                  this.field('#', 1),
                  this.field('', 2),
                  this.fieldLabel('Toe Height', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.high_fings_dx != null
                      ? order.footmeasurements.high_fings_dx
                      : '',
                    1
                  ),
                  this.field('#', 1),
                ],
                [
                  this.field('', 2),
                  this.fieldLabel('high_heel', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.high_heel_sx != null
                      ? order.footmeasurements.high_heel_sx
                      : '',
                    1
                  ),
                  this.field('#', 1),
                  this.field('', 2),
                  this.fieldLabel('high_heel', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.high_heel_dx != null
                      ? order.footmeasurements.high_heel_dx
                      : '',
                    1
                  ),
                  this.field('#', 1),
                ],
                //FINE FORMA
                //INIZIO PREDISPOSIZIONE DELLA FORMA

                [
                  {
                    content: '',
                    styles: {
                      halign: 'center',
                      valign: 'middle',
                    },
                  },
                  this.titleRow('spacepred', 1),
                ],
                [this.fieldLabel('left', 6), this.fieldLabel('right', 6)],
                [
                  this.field('P', 2),
                  this.fieldLabel('heel', 1),
                  this.field(
                    order.footmeasurements && order.footmeasurements.tacc_sx != null
                      ? order.footmeasurements.tacc_sx
                      : '',
                    1
                  ),
                  this.fieldLabel('plant', 1),
                  this.field(
                    order.footmeasurements && order.footmeasurements.plant_sx != null
                      ? order.footmeasurements.plant_sx
                      : '',
                    1
                  ),
                  this.field('P', 2),
                  this.fieldLabel('heel', 1),
                  this.field(
                    order.footmeasurements && order.footmeasurements.tacc_dx != null
                      ? order.footmeasurements.tacc_dx
                      : '',
                    1
                  ),
                  this.fieldLabel('plant', 1),
                  this.field(
                    order.footmeasurements && order.footmeasurements.plant_dx != null
                      ? order.footmeasurements.plant_dx
                      : '',
                    1
                  ),
                ],
                //FINE PREDISPOSIZIONE DELLA FORMA
              ]
            : order.plan_realization == 'reali_duna'
            ? [
                [
                  {
                    content: '',
                    styles: {
                      halign: 'center',
                      valign: 'middle',
                    },
                  },
                  this.titleRow('forma', 1),
                ],

                [this.hrForTable()],
                [
                  this.fieldLabel('c_style', 3),
                  this.field(order.footmeasurements ? this.$translate(order.footmeasurements.c_style) : '', 3),
                  this.fieldLabel('type', 3),
                  this.field(order.footmeasurements ? this.$translate(order.footmeasurements.c_form) : '', 3),
                ],
                [
                  this.fieldLabel('point', 3),
                  this.field(order.footmeasurements ? this.$translate(order.footmeasurements.c_point) : '', 3),
                  this.fieldLabel('c_pair', 3),
                  this.field(order.footmeasurements ? this.$translate(order.footmeasurements.c_pair) : '', 3),
                ],
                [this.hrForTable()],
                [
                  this.field('SX', 2),
                  this.fieldLabel('measure', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.measure_sx != null
                      ? order.footmeasurements.measure_sx
                      : '',
                    2
                  ),
                  this.field('DX', 2),
                  this.fieldLabel('measure', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.measure_dx != null
                      ? order.footmeasurements.measure_dx
                      : '',
                    2
                  ),
                ],
                [
                  this.fieldLabel('image', 2),
                  this.fieldLabel('mesu', 2),
                  this.fieldLabel('foot', 1),
                  this.fieldLabel('last', 1),
                  this.fieldLabel('image', 2),
                  this.fieldLabel('mesu', 2),
                  this.fieldLabel('foot', 1),
                  this.fieldLabel('last', 1),
                ],
                [
                  this.field('', 2),
                  this.fieldLabel('f_long_form', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_long_formfoot_sx != null
                      ? order.footmeasurements.f_long_formfoot_sx
                      : '',
                    1
                  ),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_long_formplan_sx != null
                      ? order.footmeasurements.f_long_formplan_sx
                      : '',
                    1
                  ),
                  this.field('', 2),
                  this.fieldLabel('f_long_form', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_long_formfoot_dx != null
                      ? order.footmeasurements.f_long_formfoot_dx
                      : '',
                    1
                  ),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_long_formplan_dx != null
                      ? order.footmeasurements.f_long_formplan_dx
                      : '',
                    1
                  ),
                ],
                [
                  this.field('', 2),
                  this.fieldLabel('f_large_form', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_large_formfoot_sx != null
                      ? order.footmeasurements.f_large_formfoot_sx
                      : '',
                    1
                  ),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_large_formplan_sx != null
                      ? order.footmeasurements.f_large_formplan_sx
                      : '',
                    1
                  ),
                  this.field('', 2),
                  this.fieldLabel('f_large_form', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_large_formfoot_dx != null
                      ? order.footmeasurements.f_large_formfoot_dx
                      : '',
                    1
                  ),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_large_formplan_dx != null
                      ? order.footmeasurements.f_large_formplan_dx
                      : '',
                    1
                  ),
                ],
                [
                  this.field('', 2),
                  this.fieldLabel('f_circ_meta', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_circ_metafoot_sx != null
                      ? order.footmeasurements.f_circ_metafoot_sx
                      : '',
                    1
                  ),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_circ_metaplan_sx != null
                      ? order.footmeasurements.f_circ_metaplan_sx
                      : '',
                    1
                  ),
                  this.field('', 2),
                  this.fieldLabel('f_circ_meta', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_circ_metafoot_dx != null
                      ? order.footmeasurements.f_circ_metafoot_dx
                      : '',
                    1
                  ),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_circ_metaplan_dx != null
                      ? order.footmeasurements.f_circ_metaplan_dx
                      : '',
                    1
                  ),
                ],
                [
                  this.field('', 2),
                  this.fieldLabel('f_circ_retrometa', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_circ_retrometafoot_sx != null
                      ? order.footmeasurements.f_circ_retrometafoot_sx
                      : '',
                    1
                  ),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_circ_retrometaplan_sx != null
                      ? order.footmeasurements.f_circ_retrometaplan_sx
                      : '',
                    1
                  ),
                  this.field('', 2),
                  this.fieldLabel('f_circ_retrometa', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_circ_retrometafoot_dx != null
                      ? order.footmeasurements.f_circ_retrometafoot_dx
                      : '',
                    1
                  ),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_circ_retrometaplan_dx != null
                      ? order.footmeasurements.f_circ_retrometaplan_dx
                      : '',
                    1
                  ),
                ],
                [
                  this.field('', 2),
                  this.fieldLabel('f_circ_neck', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_circ_neckfoot_sx != null
                      ? order.footmeasurements.f_circ_neckfoot_sx
                      : '',
                    1
                  ),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_circ_neckplan_sx != null
                      ? order.footmeasurements.f_circ_neckplan_sx
                      : '',
                    1
                  ),
                  this.field('', 2),
                  this.fieldLabel('f_circ_neck', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_circ_neckfoot_dx != null
                      ? order.footmeasurements.f_circ_neckfoot_dx
                      : '',
                    1
                  ),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_circ_neckplan_dx != null
                      ? order.footmeasurements.f_circ_neckplan_dx
                      : '',
                    1
                  ),
                ],
                [
                  this.field('', 2),
                  this.fieldLabel('f_circ_pass', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_circ_passfoot_sx != null
                      ? order.footmeasurements.f_circ_passfoot_sx
                      : '',
                    1
                  ),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_circ_passplan_sx != null
                      ? order.footmeasurements.f_circ_passplan_sx
                      : '',
                    1
                  ),
                  this.field('', 2),
                  this.fieldLabel('f_circ_pass', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_circ_passfoot_dx != null
                      ? order.footmeasurements.f_circ_passfoot_dx
                      : '',
                    1
                  ),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_circ_passplan_dx != null
                      ? order.footmeasurements.f_circ_passplan_dx
                      : '',
                    1
                  ),
                ],
                [
                  this.field('', 2),
                  this.fieldLabel('f_circ_mall', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_circ_mallfoot_sx != null
                      ? order.footmeasurements.f_circ_mallfoot_sx
                      : '',
                    1
                  ),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_circ_mallplan_sx != null
                      ? order.footmeasurements.f_circ_mallplan_sx
                      : '',
                    1
                  ),
                  this.field('', 2),
                  this.fieldLabel('f_circ_mall', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_circ_mallfoot_dx != null
                      ? order.footmeasurements.f_circ_mallfoot_dx
                      : '',
                    1
                  ),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_circ_mallplan_dx != null
                      ? order.footmeasurements.f_circ_mallplan_dx
                      : '',
                    1
                  ),
                ],
                [
                  this.field('', 2),
                  this.fieldLabel('high_ankle', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.high_ankle_sx != null
                      ? order.footmeasurements.high_ankle_sx
                      : '',
                    1
                  ),
                  this.field('#', 1),
                  this.field('', 2),
                  this.fieldLabel('high_ankle', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.high_ankle_dx != null
                      ? order.footmeasurements.high_ankle_dx
                      : '',
                    1
                  ),
                  this.field('#', 1),
                ],
                [
                  this.field('', 2),
                  this.fieldLabel('circ_leg', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.circ_leg_sx != null
                      ? order.footmeasurements.circ_leg_sx
                      : '',
                    1
                  ),
                  this.field('#', 1),
                  this.field('', 2),
                  this.fieldLabel('circ_leg', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.circ_leg_dx != null
                      ? order.footmeasurements.circ_leg_dx
                      : '',
                    1
                  ),
                  this.field('#', 1),
                ],
                [
                  this.field('', 2),
                  this.fieldLabel('high_leg', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.high_leg_sx != null
                      ? order.footmeasurements.high_leg_sx
                      : '',
                    1
                  ),
                  this.field('#', 1),
                  this.field('', 2),
                  this.fieldLabel('high_leg', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.high_leg_dx != null
                      ? order.footmeasurements.high_leg_dx
                      : '',
                    1
                  ),
                  this.field('#', 1),
                ],
                [
                  this.field('', 2),
                  this.fieldLabel('termtom', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_circ_term_tomfoot_sx != null
                      ? order.footmeasurements.f_circ_term_tomfoot_sx
                      : '',
                    1
                  ),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_circ_term_tomplan_sx != null
                      ? order.footmeasurements.f_circ_term_tomplan_sx
                      : '',
                    1
                  ),
                  this.field('', 2),
                  this.fieldLabel('termtom', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_circ_term_tomfoot_dx != null
                      ? order.footmeasurements.f_circ_term_tomfoot_dx
                      : '',
                    1
                  ),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_circ_term_tomplan_dx != null
                      ? order.footmeasurements.f_circ_term_tomplan_dx
                      : '',
                    1
                  ),
                ],
                [
                  this.field('', 2),
                  this.fieldLabel('f_high_tot', 2),
                  this.field('#', 1),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_high_totplan_sx != null
                      ? order.footmeasurements.f_high_totplan_sx
                      : '',
                    1
                  ),
                  this.field('', 2),
                  this.fieldLabel('f_high_tot', 2),
                  this.field('#', 1),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_high_totplan_dx != null
                      ? order.footmeasurements.f_high_totplan_dx
                      : '',
                    1
                  ),
                ],
                [
                  this.field('', 2),
                  this.fieldLabel('circ_end_tom', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.circ_end_tom_sx != null
                      ? order.footmeasurements.circ_end_tom_sx
                      : '',
                    1
                  ),
                  this.field('#', 1),
                  this.field('', 2),
                  this.fieldLabel('circ_end_tom', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.circ_end_tom_dx != null
                      ? order.footmeasurements.circ_end_tom_dx
                      : '',
                    1
                  ),
                  this.field('#', 1),
                ],
                [
                  this.field('', 2),
                  this.fieldLabel('high_tom', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.high_tom_sx != null
                      ? order.footmeasurements.high_tom_sx
                      : '',
                    1
                  ),
                  this.field('#', 1),
                  this.field('', 2),
                  this.fieldLabel('high_tom', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.high_tom_dx != null
                      ? order.footmeasurements.high_tom_dx
                      : '',
                    1
                  ),
                  this.field('#', 1),
                ],
                [
                  this.field('', 2),
                  this.fieldLabel('Toe Height', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.high_fings_sx != null
                      ? order.footmeasurements.high_fings_sx
                      : '',
                    1
                  ),
                  this.field('#', 1),
                  this.field('', 2),
                  this.fieldLabel('Toe Height', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.high_fings_dx != null
                      ? order.footmeasurements.high_fings_dx
                      : '',
                    1
                  ),
                  this.field('#', 1),
                ],
                [
                  this.field('', 2),
                  this.fieldLabel('high_heel', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.high_heel_sx != null
                      ? order.footmeasurements.high_heel_sx
                      : '',
                    1
                  ),
                  this.field('#', 1),
                  this.field('', 2),
                  this.fieldLabel('high_heel', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.high_heel_dx != null
                      ? order.footmeasurements.high_heel_dx
                      : '',
                    1
                  ),
                  this.field('#', 1),
                ],
                //INIZIO PLANTARE REALIZZAZIONE DUNA
                [this.hrForTableNoWidth()],
                [
                  {
                    content: '',
                    styles: {
                      halign: 'center',
                      valign: 'middle',
                    },
                  },
                  this.titleRow('plantare', 1),
                ],
                [
                  this.fieldLabel('left', 3),
                  {
                    content: order.isDunaInsoleDisabledSx ? 'X' : 'V',
                    colSpan: 1,
                    styles: {
                      font: 'Calibri',
                      fillColor: '#E0E0E0',
                      halign: 'center',
                      valign: 'middle',
                    },
                  },
                  this.fieldLabel('', 4),
                  {
                    content: order.isDunaInsoleDisabledDx ? 'X' : 'V',
                    colSpan: 1,
                    styles: {
                      font: 'Calibri',
                      fillColor: '#E0E0E0',
                      halign: 'center',
                      valign: 'middle',
                    },
                  },
                  this.fieldLabel('right', 3),
                ],
                [
                  this.field(
                    order.footmeasurements && order.footmeasurements.plantar_type_sx != null
                      ? this.$translate(order.footmeasurements.plantar_type_sx)
                      : '',
                    4
                  ),
                  this.fieldLabel('type', 4),
                  this.field(
                    order.footmeasurements && order.footmeasurements.plantar_type_dx != null
                      ? this.$translate(order.footmeasurements.plantar_type_dx)
                      : '',
                    4
                  ),
                ],
                [
                  this.field(
                    this.printMaterialComplete(
                      this.availablemoi,
                      order.footmeasurements.base_mat_sx,
                      order.footmeasurements.base_matvar_sx
                    ),
                    4
                  ),
                  this.fieldLabel('Moi', 4),
                  this.field(
                    this.printMaterialComplete(
                      this.availablemoi,
                      order.footmeasurements.base_mat_dx,
                      order.footmeasurements.base_matvar_dx
                    ),
                    4
                  ),
                ],
                [
                  this.field(
                    this.printMaterialComplete(
                      this.availablesupplan,
                      order.footmeasurements.surface_mat_sx,
                      order.footmeasurements.surface_matvar_sx
                    ),
                    4
                  ),
                  this.fieldLabel('Sup_plan', 4),
                  this.field(
                    this.printMaterialComplete(
                      this.availablesupplan,
                      order.footmeasurements.surface_mat_dx,
                      order.footmeasurements.surface_matvar_dx
                    ),
                    4
                  ),
                ],

                [
                  this.field(
                    order.footmeasurements && order.footmeasurements.thick_cen_heel_sx != null
                      ? order.footmeasurements.thick_cen_heel_sx
                      : '',
                    4
                  ),
                  this.fieldLabel('thick_cen_heel', 4),
                  this.field(
                    order.footmeasurements && order.footmeasurements.thick_cen_heel_dx != null
                      ? order.footmeasurements.thick_cen_heel_dx
                      : '',
                    4
                  ),
                ],
                [
                  this.field(
                    order.footmeasurements && order.footmeasurements.thick_pla_sx != null
                      ? order.footmeasurements.thick_pla_sx
                      : '',
                    4
                  ),
                  this.fieldLabel('thick_pla', 4),
                  this.field(
                    order.footmeasurements && order.footmeasurements.thick_pla_dx != null
                      ? order.footmeasurements.thick_pla_dx
                      : '',
                    4
                  ),
                ],
                [
                  this.field(
                    order.footmeasurements && order.footmeasurements.thick_poi_sx != null
                      ? order.footmeasurements.thick_poi_sx
                      : '',
                    4
                  ),
                  this.fieldLabel('thick_poi', 4),
                  this.field(
                    order.footmeasurements && order.footmeasurements.thick_poi_dx != null
                      ? order.footmeasurements.thick_poi_dx
                      : '',
                    4
                  ),
                ],
                [
                  this.field(
                    order.footmeasurements && order.footmeasurements.height_col_med_sx != null
                      ? order.footmeasurements.height_col_med_sx
                      : '',
                    4
                  ),
                  this.fieldLabel('avvolgenza_mediale', 4),
                  this.field(
                    order.footmeasurements && order.footmeasurements.height_col_med_dx != null
                      ? order.footmeasurements.height_col_med_dx
                      : '',
                    4
                  ),
                ],

                [
                  this.field(
                    order.footmeasurements && order.footmeasurements.height_col_lat_sx != null
                      ? order.footmeasurements.height_col_lat_sx
                      : '',
                    4
                  ),
                  this.fieldLabel('avvolgenza_laterale', 4),
                  this.field(
                    order.footmeasurements && order.footmeasurements.height_col_lat_dx != null
                      ? order.footmeasurements.height_col_lat_dx
                      : '',
                    4
                  ),
                ],

                [
                  this.fieldLabel('MED', 2),
                  this.fieldLabel('LAT', 2),
                  this.fieldLabel('pla_til_heel', 4, 2),
                  this.fieldLabel('MED', 2),
                  this.fieldLabel('LAT', 2),
                ],

                [
                  this.field(
                    order.footmeasurements && order.footmeasurements.pla_til_heel_sx > 0
                      ? order.footmeasurements.pla_til_heel_sx
                      : '',
                    2
                  ),
                  this.field(
                    order.footmeasurements && order.footmeasurements.pla_til_heel_sx < 0
                      ? -order.footmeasurements.pla_til_heel_sx
                      : '',
                    2
                  ),
                  this.field(
                    order.footmeasurements && order.footmeasurements.pla_til_heel_dx > 0
                      ? order.footmeasurements.pla_til_heel_dx
                      : '',
                    2
                  ),
                  this.field(
                    order.footmeasurements && order.footmeasurements.pla_til_heel_dx < 0
                      ? -order.footmeasurements.pla_til_heel_dx
                      : '',
                    2
                  ),
                ],
                [
                  this.fieldLabel('MED', 2),
                  this.fieldLabel('LAT', 2),
                  this.fieldLabel('pla_til_poi', 4, 2),
                  this.fieldLabel('MED', 2),
                  this.fieldLabel('LAT', 2),
                ],
                [
                  this.field(
                    order.footmeasurements && order.footmeasurements.pla_til_poi_sx > 0
                      ? order.footmeasurements.pla_til_poi_sx
                      : '',
                    2
                  ),
                  this.field(
                    order.footmeasurements && order.footmeasurements.pla_til_poi_sx < 0
                      ? -order.footmeasurements.pla_til_poi_sx
                      : '',
                    2
                  ),
                  this.field(
                    order.footmeasurements && order.footmeasurements.pla_til_poi_dx > 0
                      ? order.footmeasurements.pla_til_poi_dx
                      : '',
                    2
                  ),
                  this.field(
                    order.footmeasurements && order.footmeasurements.pla_til_poi_dx < 0
                      ? -order.footmeasurements.pla_til_poi_dx
                      : '',
                    2
                  ),
                ],

                [
                  this.field(
                    order.footmeasurements &&
                      order.footmeasurements.artificial_point_sx == 'y' &&
                      order.footmeasurements.artificil_point_sx_optional != null
                      ? this.$translate(order.footmeasurements.artificil_point_sx_optional)
                      : '',
                    4
                  ),
                  this.fieldLabel('artificial_point', 4),
                  this.field(
                    order.footmeasurements &&
                      order.footmeasurements.artificial_point_dx == 'y' &&
                      order.footmeasurements.artificil_point_dx_optional != null
                      ? this.$translate(order.footmeasurements.artificil_point_dx_optional)
                      : '',
                    4
                  ),
                ],
                [
                  this.field(
                    order.footmeasurements && order.footmeasurements.scari_meso_sx != null
                      ? this.$translate(order.footmeasurements.scari_meso_sx)
                      : '',
                    2
                  ),
                  this.field('', 1),
                  this.field('mm', 1),
                  this.fieldLabel('scari_meso', 4),
                  this.field(
                    order.footmeasurements && order.footmeasurements.scari_meso_dx != null
                      ? this.$translate(order.footmeasurements.scari_meso_dx)
                      : '',
                    2
                  ),
                  this.field('', 1),
                  this.field('mm', 1),
                ],
                [
                  this.field(
                    order.footmeasurements && order.footmeasurements.scari_retro_sx != null
                      ? this.$translate(order.footmeasurements.scari_retro_sx)
                      : '',
                    2
                  ),
                  this.field('', 1),
                  this.field('mm', 1),
                  this.fieldLabel('scari_retro', 4),
                  this.field(
                    order.footmeasurements && order.footmeasurements.scari_retro_dx != null
                      ? this.$translate(order.footmeasurements.scari_retro_dx)
                      : '',
                    2
                  ),
                  this.field('', 1),
                  this.field('mm', 1),
                ],
                [
                  this.field(order.secondplantsx ? 'sì' : 'no', 4),
                  this.fieldLabel('realizzazione_ii_paio', 4),
                  this.field(order.secondplantdx ? 'sì' : 'no', 4),
                ],
                [
                  this.field(
                    order.footmeasurements.base_mat_sx2 && order.footmeasurements.base_matvar_sx2
                      ? this.printMaterialComplete(
                          this.availablemoi,
                          order.footmeasurements.base_mat_sx2,
                          order.footmeasurements.base_matvar_sx2
                        )
                      : '',
                    4
                  ),
                  this.fieldLabel('Moi', 4),
                  this.field(
                    order.footmeasurements.base_mat_dx2 && order.footmeasurements.base_matvar_dx2
                      ? this.printMaterialComplete(
                          this.availablemoi,
                          order.footmeasurements.base_mat_dx2,
                          order.footmeasurements.base_matvar_dx2
                        )
                      : '',
                    4
                  ),
                ],
                [
                  this.field(
                    order.footmeasurements.surface_mat_sx2 && order.footmeasurements.surface_matvar_sx2
                      ? this.printMaterialComplete(
                          this.availablesupplan,
                          order.footmeasurements.surface_mat_sx2,
                          order.footmeasurements.surface_matvar_sx2
                        )
                      : '',
                    4
                  ),
                  this.fieldLabel('Sup_plan', 4),
                  this.field(
                    order.footmeasurements.surface_mat_dx2 && order.footmeasurements.surface_matvar_dx2
                      ? this.printMaterialComplete(
                          this.availablesupplan,
                          order.footmeasurements.surface_mat_dx2,
                          order.footmeasurements.surface_matvar_dx2
                        )
                      : '',
                    4
                  ),
                ],
                //FINE PLANTARE REALIZZAZIONE DUNA
              ]
            : [
                [
                  {
                    content: '',
                    styles: {
                      halign: 'center',
                      valign: 'middle',
                    },
                  },
                  this.titleRow('forma', 1),
                ],

                [this.hrForTable()],
                [
                  this.fieldLabel('c_style', 3),
                  this.field(order.footmeasurements ? this.$translate(order.footmeasurements.c_style) : '', 3),
                  this.fieldLabel('type', 3),
                  this.field(order.footmeasurements ? this.$translate(order.footmeasurements.c_form) : '', 3),
                ],
                [
                  this.fieldLabel('point', 3),
                  this.field(order.footmeasurements ? this.$translate(order.footmeasurements.c_point) : '', 3),
                  this.fieldLabel('c_pair', 3),
                  this.field(order.footmeasurements ? this.$translate(order.footmeasurements.c_pair) : '', 3),
                ],
                [this.hrForTable()],
                [
                  this.field('SX', 2),
                  this.fieldLabel('measure', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.measure_sx != null
                      ? order.footmeasurements.measure_sx
                      : '',
                    2
                  ),
                  this.field('DX', 2),
                  this.fieldLabel('measure', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.measure_dx != null
                      ? order.footmeasurements.measure_dx
                      : '',
                    2
                  ),
                ],
                [
                  this.fieldLabel('image', 2),
                  this.fieldLabel('mesu', 2),
                  this.fieldLabel('foot', 1),
                  this.fieldLabel('last', 1),
                  this.fieldLabel('image', 2),
                  this.fieldLabel('mesu', 2),
                  this.fieldLabel('foot', 1),
                  this.fieldLabel('last', 1),
                ],
                [
                  this.field('', 2),
                  this.fieldLabel('f_long_form', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_long_formfoot_sx != null
                      ? order.footmeasurements.f_long_formfoot_sx
                      : '',
                    1
                  ),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_long_formplan_sx != null
                      ? order.footmeasurements.f_long_formplan_sx
                      : '',
                    1
                  ),
                  this.field('', 2),
                  this.fieldLabel('f_long_form', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_long_formfoot_dx != null
                      ? order.footmeasurements.f_long_formfoot_dx
                      : '',
                    1
                  ),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_long_formplan_dx != null
                      ? order.footmeasurements.f_long_formplan_dx
                      : '',
                    1
                  ),
                ],
                [
                  this.field('', 2),
                  this.fieldLabel('f_large_form', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_large_formfoot_sx != null
                      ? order.footmeasurements.f_large_formfoot_sx
                      : '',
                    1
                  ),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_large_formplan_sx != null
                      ? order.footmeasurements.f_large_formplan_sx
                      : '',
                    1
                  ),
                  this.field('', 2),
                  this.fieldLabel('f_large_form', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_large_formfoot_dx != null
                      ? order.footmeasurements.f_large_formfoot_dx
                      : '',
                    1
                  ),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_large_formplan_dx != null
                      ? order.footmeasurements.f_large_formplan_dx
                      : '',
                    1
                  ),
                ],
                [
                  this.field('', 2),
                  this.fieldLabel('f_circ_meta', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_circ_metafoot_sx != null
                      ? order.footmeasurements.f_circ_metafoot_sx
                      : '',
                    1
                  ),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_circ_metaplan_sx != null
                      ? order.footmeasurements.f_circ_metaplan_sx
                      : '',
                    1
                  ),
                  this.field('', 2),
                  this.fieldLabel('f_circ_meta', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_circ_metafoot_dx != null
                      ? order.footmeasurements.f_circ_metafoot_dx
                      : '',
                    1
                  ),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_circ_metaplan_dx != null
                      ? order.footmeasurements.f_circ_metaplan_dx
                      : '',
                    1
                  ),
                ],
                [
                  this.field('', 2),
                  this.fieldLabel('f_circ_retrometa', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_circ_retrometafoot_sx != null
                      ? order.footmeasurements.f_circ_retrometafoot_sx
                      : '',
                    1
                  ),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_circ_retrometaplan_sx != null
                      ? order.footmeasurements.f_circ_retrometaplan_sx
                      : '',
                    1
                  ),
                  this.field('', 2),
                  this.fieldLabel('f_circ_retrometa', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_circ_retrometafoot_dx != null
                      ? order.footmeasurements.f_circ_retrometafoot_dx
                      : '',
                    1
                  ),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_circ_retrometaplan_dx != null
                      ? order.footmeasurements.f_circ_retrometaplan_dx
                      : '',
                    1
                  ),
                ],
                [
                  this.field('', 2),
                  this.fieldLabel('f_circ_neck', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_circ_neckfoot_sx != null
                      ? order.footmeasurements.f_circ_neckfoot_sx
                      : '',
                    1
                  ),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_circ_neckplan_sx != null
                      ? order.footmeasurements.f_circ_neckplan_sx
                      : '',
                    1
                  ),
                  this.field('', 2),
                  this.fieldLabel('f_circ_neck', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_circ_neckfoot_dx != null
                      ? order.footmeasurements.f_circ_neckfoot_dx
                      : '',
                    1
                  ),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_circ_neckplan_dx != null
                      ? order.footmeasurements.f_circ_neckplan_dx
                      : '',
                    1
                  ),
                ],
                [
                  this.field('', 2),
                  this.fieldLabel('f_circ_pass', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_circ_passfoot_sx != null
                      ? order.footmeasurements.f_circ_passfoot_sx
                      : '',
                    1
                  ),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_circ_passplan_sx != null
                      ? order.footmeasurements.f_circ_passplan_sx
                      : '',
                    1
                  ),
                  this.field('', 2),
                  this.fieldLabel('f_circ_pass', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_circ_passfoot_dx != null
                      ? order.footmeasurements.f_circ_passfoot_dx
                      : '',
                    1
                  ),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_circ_passplan_dx != null
                      ? order.footmeasurements.f_circ_passplan_dx
                      : '',
                    1
                  ),
                ],
                [
                  this.field('', 2),
                  this.fieldLabel('f_circ_mall', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_circ_mallfoot_sx != null
                      ? order.footmeasurements.f_circ_mallfoot_sx
                      : '',
                    1
                  ),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_circ_mallplan_sx != null
                      ? order.footmeasurements.f_circ_mallplan_sx
                      : '',
                    1
                  ),
                  this.field('', 2),
                  this.fieldLabel('f_circ_mall', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_circ_mallfoot_dx != null
                      ? order.footmeasurements.f_circ_mallfoot_dx
                      : '',
                    1
                  ),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_circ_mallplan_dx != null
                      ? order.footmeasurements.f_circ_mallplan_dx
                      : '',
                    1
                  ),
                ],
                [
                  this.field('', 2),
                  this.fieldLabel('high_ankle', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.high_anklefoot_sx != null
                      ? order.footmeasurements.high_anklefoot_sx
                      : '',
                    1
                  ),
                  this.field('#', 1),
                  this.field('', 2),
                  this.fieldLabel('high_ankle', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.high_anklefoot_dx != null
                      ? order.footmeasurements.high_anklefoot_dx
                      : '',
                    1
                  ),
                  this.field('#', 1),
                ],
                [
                  this.field('', 2),
                  this.fieldLabel('circ_leg', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.circ_legfoot_sx != null
                      ? order.footmeasurements.circ_legfoot_sx
                      : '',
                    1
                  ),
                  this.field('#', 1),
                  this.field('', 2),
                  this.fieldLabel('circ_leg', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.circ_legfoot_dx != null
                      ? order.footmeasurements.circ_legfoot_dx
                      : '',
                    1
                  ),
                  this.field('#', 1),
                ],
                [
                  this.field('', 2),
                  this.fieldLabel('high_leg', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.high_legfoot_sx != null
                      ? order.footmeasurements.high_legfoot_sx
                      : '',
                    1
                  ),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_high_term_tomplan_sx != null
                      ? order.footmeasurements.f_high_term_tomplan_sx
                      : '',
                    1
                  ),
                  this.field('', 2),
                  this.fieldLabel('high_leg', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.high_legfoot_dx != null
                      ? order.footmeasurements.high_legfoot_dx
                      : '',
                    1
                  ),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_high_term_tomplan_dx != null
                      ? order.footmeasurements.f_high_term_tomplan_dx
                      : '',
                    1
                  ),
                ],
                [
                  this.field('', 2),
                  this.fieldLabel('termtom', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.termtomfoot_sx != null
                      ? order.footmeasurements.termtomfoot_sx
                      : '',
                    1
                  ),
                  this.field(
                    order.footmeasurements && order.footmeasurements.termtomplan_sx != null
                      ? order.footmeasurements.termtomplan_sx
                      : '',
                    1
                  ),
                  this.field('', 2),
                  this.fieldLabel('termtom', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.termtomfoot_dx != null
                      ? order.footmeasurements.termtomfoot_dx
                      : '',
                    1
                  ),
                  this.field(
                    order.footmeasurements && order.footmeasurements.termtomplan_dx != null
                      ? order.footmeasurements.termtomplan_dx
                      : '',
                    1
                  ),
                ],
                [
                  this.field('', 2),
                  this.fieldLabel('f_high_term_tom', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_high_term_tomfoot_sx != null
                      ? order.footmeasurements.f_high_term_tomfoot_sx
                      : '',
                    1
                  ),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_high_term_tomplan_sx != null
                      ? order.footmeasurements.f_high_term_tomplan_sx
                      : '',
                    1
                  ),
                  this.field('', 2),
                  this.fieldLabel('f_high_term_tom', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_high_term_tomfoot_dx != null
                      ? order.footmeasurements.f_high_term_tomfoot_dx
                      : '',
                    1
                  ),
                  this.field(
                    order.footmeasurements && order.footmeasurements.f_high_term_tomplan_dx != null
                      ? order.footmeasurements.f_high_term_tomplan_dx
                      : '',
                    1
                  ),
                ],
                [
                  this.field('', 2),
                  this.fieldLabel('f_long_form', 2),
                  this.field('#', 1),
                  this.field(
                    order.footmeasurements && order.footmeasurements.foot_long_sx != null
                      ? order.footmeasurements.foot_long_sx
                      : '',
                    1
                  ),
                  this.field('', 2),
                  this.fieldLabel('f_long_form', 2),
                  this.field('#', 1),
                  this.field(
                    order.footmeasurements && order.footmeasurements.foot_long_dx != null
                      ? order.footmeasurements.foot_long_dx
                      : '',
                    1
                  ),
                ],
                [
                  this.field('', 2),
                  this.fieldLabel('circ_end_tom', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.circ_end_tom_sx != null
                      ? order.footmeasurements.circ_end_tom_sx
                      : '',
                    1
                  ),
                  this.field('#', 1),
                  this.field('', 2),
                  this.fieldLabel('circ_end_tom', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.circ_end_tom_dx != null
                      ? order.footmeasurements.circ_end_tom_dx
                      : '',
                    1
                  ),
                  this.field('#', 1),
                ],
                [
                  this.field('', 2),
                  this.fieldLabel('high_tom', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.high_tom_sx != null
                      ? order.footmeasurements.high_tom_sx
                      : '',
                    1
                  ),
                  this.field('#', 1),
                  this.field('', 2),
                  this.fieldLabel('high_tom', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.high_tom_dx != null
                      ? order.footmeasurements.high_tom_dx
                      : '',
                    1
                  ),
                  this.field('#', 1),
                ],
                [
                  this.field('', 2),
                  this.fieldLabel('Toe Height', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.high_fings_sx != null
                      ? order.footmeasurements.high_fings_sx
                      : '',
                    1
                  ),
                  this.field('#', 1),
                  this.field('', 2),
                  this.fieldLabel('Toe Height', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.high_fings_dx != null
                      ? order.footmeasurements.high_fings_dx
                      : '',
                    1
                  ),
                  this.field('#', 1),
                ],
                [
                  this.field('', 2),
                  this.fieldLabel('high_heel', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.high_heel_sx != null
                      ? order.footmeasurements.high_heel_sx
                      : '',
                    1
                  ),
                  this.field('#', 1),
                  this.field('', 2),
                  this.fieldLabel('high_heel', 2),
                  this.field(
                    order.footmeasurements && order.footmeasurements.high_heel_dx != null
                      ? order.footmeasurements.high_heel_dx
                      : '',
                    1
                  ),
                  this.field('#', 1),
                ],
              ],
      })
      doc.addPage()
      const [tailoredPelCount] = this.getModelAndRipCount(order)
      const tailoredPelRows = []
      for (let i = 1; i <= tailoredPelCount; i++) {
        tailoredPelRows.push([
          this.fieldLabelMultipleString(['pelltitle', String(i)], 4, 1, ' '),
          this.field(
            this.printMaterialComplete(
              this.availablepel,
              order.mod ? order.mod[`pell${i}mat`] : undefined,
              order.mod ? order.mod[`pell${i}var`] : undefined
            ),
            8
          ),
        ])
      }
      const pelDelta = tailoredPelRows.length - 3
      autoTable(doc, {
        theme: 'grid',
        margin: { top: 100 },
        styles: { fillColor: [255, 255, 255] },
        bodyStyles: { cellPadding: 3 },
        rowPageBreak: 'avoid',

        columnStyles: {
          0: { cellWidth: 40 },
          1: { cellWidth: 40 },
          2: { cellWidth: 40 },
          3: { cellWidth: 40 },
          4: { cellWidth: 40 },
          5: { cellWidth: 40 },
          6: { cellWidth: 40 },
          7: { cellWidth: 40 },
          8: { cellWidth: 40 },
          9: { cellWidth: 40 },
          10: { cellWidth: 40 },
          11: { cellWidth: 40 },
        },
        didDrawPage: data => {
          this.AddHeader(doc, order)

          var str = doc.internal.getNumberOfPages()
          if (typeof doc.putTotalPages === 'function') {
            str = str + '/' + totalPagesExp
          }
          doc.setFontSize(10)

          var pageSize = doc.internal.pageSize
          var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
          doc.text(str, data.settings.margin.left, pageHeight - 10)
        },
        didParseCell: data => {
          if (
            data.column.index === 0 &&
            data.row.index === 17 + 21 + pelDelta + this.arrayrowCounterAllacciatura[this.allacciaCounter] &&
            data.cell.section === 'body'
          ) {
            if (this.arrayrowCounterAllacciatura[this.allacciaCounter] == 8) {
              data.cell.styles.minCellHeight = 30
            }
          }
        },
        willDrawCell: data => {
          let Cell = data.column.index + ':' + data.row.index

          if (data.cell && data.cell.text && data.cell.text[0] == 'X') {
            data.cell.text = []
            this.falseCheck.push(Cell)
          }
          if (data.cell && data.cell.text && data.cell.text[0] == 'V') {
            data.cell.text = []
            this.trueCheck.push(Cell)
          }
        },
        didDrawCell: data => {
          var dim = 0
          var textPos = {}
          let Cell = data.column.index + ':' + data.row.index

          if (this.falseCheck.includes(Cell)) {
            dim = data.cell.height - data.cell.padding('vertical')
            textPos = data.cell
            this.falseCheck.splice(this.falseCheck.indexOf(Cell), 1)
            doc.addImage(
              this.getCheckFalse(),
              textPos.x + data.cell.width / 2 - dim / 2,
              textPos.y + data.cell.height / 2 - dim / 2,
              10,
              10
            )
          }
          if (this.trueCheck.includes(Cell)) {
            dim = data.cell.height - data.cell.padding('vertical')
            textPos = data.cell
            this.trueCheck.splice(this.trueCheck.indexOf(Cell), 1)
            doc.addImage(
              this.getCheckTrue(),
              textPos.x + data.cell.width / 2 - dim / 2,
              textPos.y + data.cell.height / 2 - dim / 2,
              10,
              10
            )
          }

          if (data.column.index === 0 && data.row.index === 97 - 97 && data.cell.section === 'body') {
            dim = data.cell.height - data.cell.padding('vertical')
            textPos = data.cell
            doc.addImage(
              this.getMesaurement(),
              textPos.x + data.cell.width / 2 - dim / 2,
              textPos.y + data.cell.height / 2 - dim / 2,
              dim,
              dim
            )
          }

          if (
            data.column.index === 0 &&
            data.row.index === 17 + 6 + 3 + pelDelta + this.arrayrowCounterAllacciatura[this.allacciaCounter] &&
            data.cell.section === 'body'
          ) {
            dim = data.cell.height - data.cell.padding('vertical')
            textPos = data.cell
            doc.addImage(
              this.getCaratteristicheTecniche(),
              textPos.x + data.cell.width / 2 - dim / 2,
              textPos.y + data.cell.height / 2 - dim / 2,
              dim,
              dim
            )
          }

          if (
            data.column.index === 0 &&
            data.row.index === 46 + 6 + 3 + pelDelta + this.arrayrowCounterAllacciatura[this.allacciaCounter] &&
            data.cell.section === 'body'
          ) {
            dim = data.cell.height - data.cell.padding('vertical')
            textPos = data.cell
            doc.addImage(
              this.getGuardolo(),
              textPos.x + data.cell.width / 2 - dim / 2,
              textPos.y + data.cell.height / 2 - dim / 2,
              dim,
              dim
            )
          }

          if (
            data.column.index === 0 &&
            data.row.index === 50 + 6 + 3 + pelDelta + this.arrayrowCounterAllacciatura[this.allacciaCounter] &&
            data.cell.section === 'body'
          ) {
            dim = data.cell.height - data.cell.padding('vertical')
            textPos = data.cell
            doc.addImage(
              this.getMesaurement(),
              textPos.x + data.cell.width / 2 - dim / 2,
              textPos.y + data.cell.height / 2 - dim / 2,
              dim,
              dim
            )
          }

          if (
            data.column.index === 0 &&
            data.row.index ===
              50 + 28 + 6 + 3 + 1 + pelDelta + this.arrayrowCounterAllacciatura[this.allacciaCounter] &&
            data.cell.section === 'body'
          ) {
            this.allacciaCounter++
            dim = data.cell.height - data.cell.padding('vertical')
            textPos = data.cell
            doc.addImage(
              this.getMesaurement(),
              textPos.x + data.cell.width / 2 - dim / 2,
              textPos.y + data.cell.height / 2 - dim / 2,
              dim,
              dim
            )
          }
        },

        body: [
          [
            {
              content: '',
              styles: {
                halign: 'center',
                valign: 'middle',
              },
            },
            this.titleRow('model_details', 1),
          ],
          [this.hrForTable()],
          [this.fieldLabelMultipleString(['tomaio', 'fodera'], 12, 1, '/', true)],
          [this.fieldLabel('materials', 12)],
          ...tailoredPelRows,
          [
            this.fieldLabel('puncture', 2, 5),
            this.field(this.$translate(order.mod ? (order.mod.passing ? order.mod.passing : '') : ''), 4, 5),
            this.fieldLabel('components_to_drill', 2, 5),
            this.field(this.$translate('mask'), 3),
            this.field(
              order.mod
                ? order.mod.components_to_drill
                  ? order.mod.components_to_drill.includes('mask') //'mask' in order.mod.components_to_drill
                    ? 'V'
                    : 'X'
                  : 'X'
                : 'X',
              1
            ),
          ],
          [
            this.field(this.$translate('bowl'), 3),
            this.field(
              order.mod
                ? order.mod.components_to_drill
                  ? order.mod.components_to_drill.includes('bowl') //'bowl' in order.mod.components_to_drill
                    ? 'V'
                    : 'X'
                  : 'X'
                : 'X',
              1
            ),
          ],
          [
            this.field(this.$translate('quarter'), 3),
            this.field(
              order.mod
                ? order.mod.components_to_drill
                  ? order.mod.components_to_drill.includes('quarter') //'quarter' in order.mod.components_to_drill
                    ? 'V'
                    : 'X'
                  : 'X'
                : 'X',
              1
            ),
          ],
          [
            this.field(this.$translate('gambetti'), 3),
            this.field(
              order.mod
                ? order.mod.components_to_drill
                  ? order.mod.components_to_drill.includes('gambetti') //'gambetti' in order.mod.components_to_drill
                    ? 'V'
                    : 'X'
                  : 'X'
                : 'X',
              1
            ),
          ],
          [
            this.field(this.$translate('like_photo'), 3),
            this.field(
              order.mod
                ? order.mod.components_to_drill
                  ? order.mod.like_photo //'like_photo' in order.mod.components_to_drill
                    ? 'V'
                    : 'X'
                  : 'X'
                : 'X',
              1
            ),
          ],
          [
            this.fieldLabel('seams', 2),
            this.field(
              order.mod ? (order.mod.seams ? (order.mod.matching ? this.$translate(order.mod.matching) : '') : '') : '',
              4
            ),
            this.fieldLabel('type', 2),
            this.field(
              order.mod
                ? order.mod.seams
                  ? order.mod.notmatchingstring
                    ? order.mod.notmatchingstring
                    : ''
                  : ''
                : '',
              4
            ),
          ],
          [
            this.fieldLabel('fodanttitle', 4),
            this.field(
              this.printMaterialComplete(
                this.availablefode,
                order.mod ? order.mod.fodantmat : undefined,
                order.mod ? order.mod.fodantvar : undefined
              ),
              8
            ),
          ],

          [
            this.fieldLabel('fodpostitle', 4),
            this.field(
              this.printMaterialComplete(
                this.availablefode,
                order.mod ? order.mod.fodposmat : undefined,
                order.mod ? order.mod.fodposvar : undefined
              ),
              8
            ),
          ],
          [this.fieldLabel('SX', 4), this.fieldLabel('mesu', 4), this.fieldLabel('DX', 4)],
          [
            this.field(
              order.footmeasurements && order.footmeasurements.high_post_tom_sx != null
                ? order.footmeasurements.high_post_tom_sx
                : '',

              4
            ),
            this.fieldLabel('high_post_tom', 4),
            this.field(
              order.footmeasurements && order.footmeasurements.high_post_tom_dx != null
                ? order.footmeasurements.high_post_tom_dx
                : '',
              4
            ),
          ],
          [
            this.field(
              order.footmeasurements && order.footmeasurements.high_lat_tom_sx != null
                ? order.footmeasurements.high_lat_tom_sx
                : '',

              4
            ),
            this.fieldLabel('high_lat_tom', 4),
            this.field(
              order.footmeasurements && order.footmeasurements.high_lat_tom_dx != null
                ? order.footmeasurements.high_lat_tom_dx
                : '',
              4
            ),
          ],
          [
            this.field(
              order.footmeasurements && order.footmeasurements.high_med_tom_sx != null
                ? order.footmeasurements.high_med_tom_sx
                : '',
              4
            ),
            this.fieldLabel('high_med_tom', 4),
            this.field(
              order.footmeasurements && order.footmeasurements.high_med_tom_dx != null
                ? order.footmeasurements.high_med_tom_dx
                : '',
              4
            ),
          ],
          [
            this.field(
              order.footmeasurements && order.footmeasurements.start_lacing_sx != null
                ? order.footmeasurements.start_lacing_sx
                : '',
              4
            ),
            this.fieldLabel('start_lacing', 4),
            this.field(
              order.footmeasurements && order.footmeasurements.start_lacing_dx != null
                ? order.footmeasurements.start_lacing_dx
                : '',
              4
            ),
          ],
          [this.hrForTable()],
          [this.fieldLabel('allacciaturatitle', 12)],
        ]
          .concat(this.allacciatureTable(order))
          .concat([
            [
              this.fieldLabel('var_ling', 2, 3),
              this.field(this.$translate('vlecr_med_stop'), 6),
              this.field(
                order.mod && order.mod.var_ling_sx && order.mod.var_ling_sx.includes('vlecr_med_stop') ? 'V' : 'X',
                2
              ),
              this.field(
                order.mod && order.mod.var_ling_dx && order.mod.var_ling_dx.includes('vlecr_med_stop') ? 'V' : 'X',
                2
              ),
            ],
            [
              this.field(this.$translate('ling_soff'), 6),
              this.field(
                order.mod && order.mod.var_ling_sx && order.mod.var_ling_sx.includes('ling_soff') ? 'V' : 'X',
                2
              ),
              this.field(
                order.mod && order.mod.var_ling_dx && order.mod.var_ling_dx.includes('ling_soff') ? 'V' : 'X',
                2
              ),
            ],
            [
              this.field(this.$translate('ling_rigi'), 6),
              this.field(
                order.mod && order.mod.var_ling_sx && order.mod.var_ling_sx.includes('ling_rigi') ? 'V' : 'X',
                2
              ),
              this.field(
                order.mod && order.mod.var_ling_dx && order.mod.var_ling_dx.includes('ling_rigi') ? 'V' : 'X',
                2
              ),
            ],
            [this.hrForTable()],
            [
              {
                content: '',
                styles: {
                  halign: 'center',
                  valign: 'middle',
                },
              },
              this.titleRow('caratteristiche_tecniche', 1),
            ],
            [this.hrForTable()],
            [this.fieldLabel('imbott', 12, 1, true)],
            [this.fieldLabel('left', 4), this.fieldLabel('', 4), this.fieldLabel('right', 4)],
            [
              this.field(order.masch_sx ? order.masch_sx : '', 4),
              this.fieldLabel('imbottitura_mascherina', 4),
              this.field(order.masch_dx ? order.masch_dx : '', 4),
            ],
            [
              this.field(order.ling_sx ? order.ling_sx : '', 4),
              this.fieldLabel('imbottitura_linguetta', 4),
              this.field(order.ling_dx ? order.ling_dx : '', 4),
            ],
            [
              this.field(order.imb_gamb_sx ? order.imb_gamb_sx : '', 4),
              this.fieldLabel('imb_gamb', 4),
              this.field(order.imb_gamb_dx ? order.imb_gamb_dx : '', 4),
            ],
            [
              this.field(order.mallmed_sx ? order.mallmed_sx : '', 4),
              this.fieldLabel('imbottitura_malleolo_mediale', 4),
              this.field(order.mallmed_dx ? order.mallmed_dx : '', 4),
            ],
            [
              this.field(order.malllat_sx ? order.malllat_sx : '', 4),
              this.fieldLabel('imbottitura_malleolo_laterale', 4),
              this.field(order.malllat_dx ? order.malllat_dx : '', 4),
            ],
            [
              this.field(order.termtom_sx ? order.termtom_sx : '', 4),
              this.fieldLabel('imbottitura_termine_tomaia', 4),
              this.field(order.termtom_dx ? order.termtom_dx : '', 4),
            ],
            [this.hrForTable()],
            [this.fieldLabel('PaS', 12, 1, true)],
            [
              this.field('', 2, 4),
              this.field(order.typecontr_sx ? this.$translate(order.typecontr_sx) : '', 3),
              this.fieldLabel('type', 2),
              this.field(order.typecontr_dx ? this.$translate(order.typecontr_dx) : '', 3),
              this.field('', 2, 4),
            ],
            [
              this.field(
                order.typecontr_sx == 'Noone'
                  ? ''
                  : this.printMaterialComplete(this.availablepas, order.tipocontr_sx, order.tipocontr_var_sx),

                3
              ),
              this.fieldLabel('contrmat', 2),
              this.field(
                order.typecontr_dx == 'Noone'
                  ? ''
                  : this.printMaterialComplete(this.availablepas, order.tipocontr_dx, order.tipocontr_var_dx),
                3
              ),
            ],
            [
              this.field(
                order.typecontr_sx == 'Noone'
                  ? ''
                  : order.tiporinfcontr_sx
                  ? this.$translate(order.tiporinfcontr_sx)
                  : '',
                3
              ),
              this.fieldLabel('rinfcontr', 2),
              this.field(
                order.typecontr_dx == 'Noone'
                  ? ''
                  : order.tiporinfcontr_dx
                  ? this.$translate(order.tiporinfcontr_dx)
                  : '',
                3
              ),
            ],
            [
              // this.field("", 3),
              this.field(
                order.tiporinfcontr_sx == 'Noone'
                  ? ''
                  : this.printMaterialComplete(this.availablereinf, order.matrinfcontr_sx, order.matrinfcontr_var_sx),

                3
              ),
              this.fieldLabel('materiale_rinforzo', 2),
              this.field(
                order.tiporinfcontr_dx == 'Noone'
                  ? ''
                  : this.printMaterialComplete(this.availablereinf, order.matrinfcontr_dx, order.matrinfcontr_var_dx),
                3
              ),
              // this.field("", 3),
            ],
            [this.hrForTable()],
            [this.fieldLabel('Mez', 12, 1, true)],
            [this.fieldLabel('left', 4), this.fieldLabel('', 4), this.fieldLabel('right', 4)],
            [
              this.field(this.$translate(order.tipopunt_sx), 4),
              this.fieldLabel('type', 4),
              this.field(this.$translate(order.tipopunt_dx), 4),
            ],
            [
              this.field(
                order.tipopunt_sx != 'tipopunt1'
                  ? this.printMaterialComplete(this.availablemez, order.tipopunt_mat_sx, order.tipopunt_mat_var_sx)
                  : '',

                4
              ),
              this.fieldLabel('punmat', 4),
              this.field(
                order.tipopunt_dx != 'tipopunt1'
                  ? this.printMaterialComplete(this.availablemez, order.tipopunt_mat_dx, order.tipopunt_mat_var_dx)
                  : '',
                4
              ),
            ],
            [this.hrForTable()],
            [this.fieldLabel('Pat', 12, 1, true)],
            [this.fieldLabel('left', 4), this.fieldLabel('', 4), this.fieldLabel('right', 4)],
            [
              this.field(
                this.printMaterialComplete(this.availablepat, order.tiposott_sx, order.tiposott_var_sx),

                4
              ),
              this.fieldLabel('matsotto', 4),
              this.field(
                this.printMaterialComplete(this.availablepat, order.tiposott_dx, order.tiposott_var_dx),

                4
              ),
            ],
            [
              this.field(order.tiporinfsott_sx ? this.$translate(order.tiporinfsott_sx) : '', 4),
              this.fieldLabel('rinfsotto', 4),
              this.field(order.tiporinfsott_dx ? this.$translate(order.tiporinfsott_dx) : '', 4),
            ],
            [
              this.field(
                order.footmeasurements &&
                  (order.footmeasurements.thick_plant_sx || order.footmeasurements.thick_tacc_sx)
                  ? 'V'
                  : 'X',
                4
              ),
              this.fieldLabel('sol_vant', 4),
              this.field(
                order.footmeasurements &&
                  (order.footmeasurements.thick_plant_dx || order.footmeasurements.thick_tacc_dx)
                  ? 'V'
                  : 'X',
                4
              ),
            ],
            [
              this.field(
                order.footmeasurements && order.footmeasurements.thick_tacc_sx
                  ? order.footmeasurements.thick_tacc_sx
                  : '',
                4
              ),
              this.fieldLabel('thick_cen_heel', 4),
              this.field(
                order.footmeasurements && order.footmeasurements.thick_tacc_dx
                  ? order.footmeasurements.thick_tacc_dx
                  : '',
                4
              ),
            ],
            [
              this.field(
                order.footmeasurements && order.footmeasurements.thick_plant_sx
                  ? order.footmeasurements.thick_plant_sx
                  : '',
                4
              ),
              this.fieldLabel('thick_pla', 4),
              this.field(
                order.footmeasurements && order.footmeasurements.thick_plant_dx
                  ? order.footmeasurements.thick_plant_dx
                  : '',
                4
              ),
            ],
            [
              {
                content: '',
                styles: {
                  halign: 'center',
                  valign: 'middle',
                },
              },
              this.titleRowMultipleString(['rifinitura0', 'rifinitura1'], '/', 1),
            ],
            [this.hrForTable()],
            [
              this.fieldLabel('type', 2),
              this.field(order.mod && order.mod.riftype ? this.$translate(order.mod.riftype) : '', 2),
              this.fieldLabel('mountag', 2),
              this.field(order.mod && order.mod.mountag ? this.$translate(order.mod.mountag) : '', 2),
              this.fieldLabel('taccvar', 2),
              this.field(
                order.mod && order.mod.riftype == 'rifinitura0'
                  ? this.printMaterialComplete(this.availablemat, order.mod.guardmat, order.mod.guardvar)
                  : order.mod && order.mod.riftype == 'rifinitura1'
                  ? this.printMaterialComplete(this.availablesug, order.mod.fascmat, order.mod.fascvar)
                  : '',
                2
              ),
            ],
            [this.hrForTable()],
            [
              {
                content: '',
                styles: {
                  halign: 'center',
                  valign: 'middle',
                },
              },
              this.titleRow('fondo', 1),
            ],
            [this.hrForTable()],
            [
              this.fieldLabel('tacc', 2),
              this.field(order.mod && order.mod.tacc ? this.$translate(order.mod.tacc) : '', 4),
              this.fieldLabel('taccvar', 2),
              this.field(order.mod && order.mod.taccvar ? this.$translate(order.mod.taccvar) : '', 4),
            ],
            [
              this.fieldLabel('punt_risv', 2),
              this.field(order.mod && order.mod.punt_risv ? 'V' : 'X', 1),
              this.fieldLabel('Pun', 3),
              this.field(
                this.printMaterialComplete(
                  this.availablepun,
                  order.mod ? order.mod.battmat : undefined,
                  order.mod ? order.mod.battvar : undefined
                ),
                6
              ),
            ],
            [
              this.fieldLabel('heel_zep', 2),
              this.field(
                this.printMaterialComplete(
                  this.availablemor,
                  order.mod ? order.mod.tacczepp : undefined,
                  order.mod ? order.mod.tacczeppvar : undefined
                ),
                4
              ),
              this.fieldLabel('intetitle', 2),
              this.field(
                this.printMaterialComplete(
                  this.availablemor,
                  order.mod ? order.mod.intemat : undefined,
                  order.mod ? order.mod.intevar : undefined
                ),
                4
              ),
            ],
            [this.hrForTable()],
            [this.fieldLabel('caratt_agg_fondo', 12, 1, true)],
            [this.fieldLabel('left', 4), this.fieldLabel('', 4), this.fieldLabel('right', 4)],
            [
              this.field(order.mod && order.mod.pos_batt_sx ? this.$translate(order.mod.pos_batt_sx) : '', 4),
              this.fieldLabel('pos_batt', 4),
              this.field(order.mod && order.mod.pos_batt_dx ? this.$translate(order.mod.pos_batt_dx) : '', 4),
            ],
            [
              this.field(order.mod && order.mod.dir_deamb_sx ? this.$translate(order.mod.dir_deamb_sx) : '', 4),
              this.fieldLabel('dir_deamb', 4),
              this.field(order.mod && order.mod.dir_deamb_dx ? this.$translate(order.mod.dir_deamb_dx) : '', 4),
            ],
            [
              this.field(order.mod && order.mod.smuss_post_sx ? this.$translate(order.mod.smuss_post_sx) : '', 4),
              this.fieldLabel('sumss_post', 4),
              this.field(order.mod && order.mod.smuss_post_dx ? this.$translate(order.mod.smuss_post_dx) : '', 4),
            ],
            [
              this.field(order.mod && order.mod.camp_M_sx ? this.$translate(order.mod.camp_M_sx) : '', 3),
              this.field(
                order.mod && order.mod.camp_num_M_sx ? this.$translate(order.mod.camp_num_M_sx) + ' mm' : 'mm',
                1
              ),
              this.fieldLabel('camp_M', 4),
              this.field(order.mod && order.mod.camp_M_dx ? this.$translate(order.mod.camp_M_dx) : '', 3),
              this.field(
                order.mod && order.mod.camp_num_M_dx ? this.$translate(order.mod.camp_num_M_dx) + ' mm' : 'mm',
                1
              ),
            ],
            [
              this.field(order.mod && order.mod.camp_L_sx ? this.$translate(order.mod.camp_L_sx) : '', 3),
              this.field(
                order.mod && order.mod.camp_num_L_sx ? this.$translate(order.mod.camp_num_L_sx) + ' mm' : 'mm',
                1
              ),
              this.fieldLabel('camp_L', 4),
              this.field(order.mod && order.mod.camp_L_dx ? this.$translate(order.mod.camp_L_dx) : '', 3),
              this.field(
                order.mod && order.mod.camp_num_L_dx ? this.$translate(order.mod.camp_num_L_dx) + ' mm' : 'mm',
                1
              ),
            ],
            [
              this.field(order.mod && order.mod.impr_ground_sx ? this.$translate(order.mod.impr_ground_sx) : '', 4),
              this.fieldLabel('impr_ground', 4),
              this.field(order.mod && order.mod.impr_ground_dx ? this.$translate(order.mod.impr_ground_dx) : '', 4),
            ],
            [
              this.field(order.mod && order.mod.ammmm_sx ? 'V' : 'X', 4),
              this.fieldLabel('ammmm', 4),
              this.field(order.mod && order.mod.ammmm_dx ? 'V' : 'X', 4),
            ],
            [
              this.field(order.mod && order.mod.suola_finn_sx ? 'V' : 'X', 4),
              this.fieldLabel('suola_finn', 4),
              this.field(order.mod && order.mod.suola_finn_dx ? 'V' : 'X', 4),
            ],
            [this.hrForTable()],
            [this.fieldLabel('dimensioniFondo', 12, 1, true)],
            [this.fieldLabel('left', 4), this.fieldLabel('', 4), this.fieldLabel('right', 4)],
            [
              this.field(
                order.footmeasurements && order.footmeasurements.high_heel_zep_sx
                  ? order.footmeasurements.high_heel_zep_sx
                  : '',
                4
              ),
              this.fieldLabel('high_heel_zep', 4),
              this.field(
                order.footmeasurements && order.footmeasurements.high_heel_zep_dx
                  ? order.footmeasurements.high_heel_zep_dx
                  : '',
                4
              ),
            ],
            [
              this.field(
                order.footmeasurements && order.footmeasurements.ext_high_heel_sx
                  ? order.footmeasurements.ext_high_heel_sx
                  : '',
                4
              ),
              this.fieldLabel('ext_high_heel', 4),
              this.field(
                order.footmeasurements && order.footmeasurements.ext_high_heel_dx
                  ? order.footmeasurements.ext_high_heel_dx
                  : '',
                4
              ),
            ],
            [
              this.field(
                order.footmeasurements && order.footmeasurements.ext_high_pla_sx
                  ? order.footmeasurements.ext_high_pla_sx
                  : '',
                4
              ),
              this.fieldLabel('ext_high_pla', 4),
              this.field(
                order.footmeasurements && order.footmeasurements.ext_high_pla_dx
                  ? order.footmeasurements.ext_high_pla_dx
                  : '',
                4
              ),
            ],
            [
              this.field(
                order.footmeasurements && order.footmeasurements.ext_high_poi_sx
                  ? order.footmeasurements.ext_high_poi_sx
                  : '',
                4
              ),
              this.fieldLabel('ext_high_poi', 4),
              this.field(
                order.footmeasurements && order.footmeasurements.ext_high_poi_dx
                  ? order.footmeasurements.ext_high_poi_dx
                  : '',
                4
              ),
            ],
            [
              this.fieldLabel('medial', 2),
              this.fieldLabel('sidal', 2),
              this.fieldLabel('spe_heel', 4, 2),
              this.fieldLabel('medial', 2),
              this.fieldLabel('sidal', 2),
            ],
            [
              this.field(
                order.footmeasurements && order.footmeasurements.spe_heel_sx > 0
                  ? order.footmeasurements.spe_heel_sx
                  : '',
                2
              ),
              this.field(
                order.footmeasurements && order.footmeasurements.spe_heel_sx < 0
                  ? -order.footmeasurements.spe_heel_sx
                  : '',
                2
              ),
              this.field(
                order.footmeasurements && order.footmeasurements.spe_heel_dx > 0
                  ? order.footmeasurements.spe_heel_dx
                  : '',
                2
              ),
              this.field(
                order.footmeasurements && order.footmeasurements.spe_heel_dx < 0
                  ? -order.footmeasurements.spe_heel_dx
                  : '',
                2
              ),
            ],
            [
              this.fieldLabel('medial', 2),
              this.fieldLabel('sidal', 2),
              this.fieldLabel('spe_poi', 4, 2),
              this.fieldLabel('medial', 2),
              this.fieldLabel('sidal', 2),
            ],
            [
              this.field(
                order.footmeasurements && order.footmeasurements.spe_poi_sx > 0
                  ? order.footmeasurements.spe_poi_sx
                  : '',
                2
              ),
              this.field(
                order.footmeasurements && order.footmeasurements.spe_poi_sx < 0
                  ? -order.footmeasurements.spe_poi_sx
                  : '',
                2
              ),
              this.field(
                order.footmeasurements && order.footmeasurements.spe_poi_dx > 0
                  ? order.footmeasurements.spe_poi_dx
                  : '',
                2
              ),
              this.field(
                order.footmeasurements && order.footmeasurements.spe_poi_dx < 0
                  ? -order.footmeasurements.spe_poi_dx
                  : '',
                2
              ),
            ],
            // Hotfix: Syntax error corrected for footmeasurements crimpheel
            [
              this.field(
                order.footmeasurements && order.footmeasurements.crimp_heel_sx
                  ? order.footmeasurements.crimp_heel_sx
                  : '',
                4
              ),
              this.fieldLabel('crimp_heel', 4),
              this.field(
                order.footmeasurements && order.footmeasurements.crimp_heel_dx
                  ? order.footmeasurements.crimp_heel_dx
                  : '',
                4
              ),
            ],
            [this.hrForTable()],
            [
              {
                content: '',
                styles: {
                  halign: 'center',
                  valign: 'middle',
                },
              },
              this.titleRow('rifinituraFinalePlantare', 1),
            ],
            [this.hrForTable()],
            [this.fieldLabel('left', 4), this.fieldLabel('', 4), this.fieldLabel('right', 4)],
            [
              this.field(
                this.printMaterialComplete(
                  this.availablepelo,
                  order.footmeasurements.pelotte_sx,
                  order.footmeasurements.pelottevar_sx
                ),
                4
              ),
              this.fieldLabel('Pelo', 4),
              this.field(
                this.printMaterialComplete(
                  this.availablepelo,
                  order.footmeasurements.pelotte_dx,
                  order.footmeasurements.pelottevar_dx
                ),
                4
              ),
            ],
            [
              this.field(
                this.printMaterialComplete(
                  this.availablerivplan,
                  order.footmeasurements.fin_dess_sx,
                  order.footmeasurements.fin_dessvar_sx
                ),

                4
              ),
              this.fieldLabel('Riv_plan', 4),
              this.field(
                this.printMaterialComplete(
                  this.availablerivplan,
                  order.footmeasurements.fin_dess_dx,
                  order.footmeasurements.fin_dessvar_dx
                ),
                4
              ),
            ],
            [
              this.field(
                this.printMaterialComplete(
                  this.availablepelo,
                  order.footmeasurements.pelotte_sx2,
                  order.footmeasurements.pelottevar_sx2
                ),
                4
              ),
              this.fieldLabel('Pelo', 4),
              this.field(
                this.printMaterialComplete(
                  this.availablepelo,
                  order.footmeasurements.pelotte_dx2,
                  order.footmeasurements.pelottevar_dx2
                ),
                4
              ),
            ],
            [
              this.field(
                this.printMaterialComplete(
                  this.availablerivplan,
                  order.footmeasurements.fin_dess_sx2,
                  order.footmeasurements.fin_dessvar_sx2
                ),

                4
              ),
              this.fieldLabel('Riv_plan', 4),
              this.field(
                this.printMaterialComplete(
                  this.availablerivplan,
                  order.footmeasurements.fin_dess_dx2,
                  order.footmeasurements.fin_dessvar_dx2
                ),
                4
              ),
            ],
          ]),
      })

      //console.log(doc.getNumberOfPages())
      // HOTFIX: the add of page on even pages is out of the method with a specific handler in the foreach loop of print
      // if (doc.getNumberOfPages() % 2 !== 0) doc.addPage()

      let bodyClaim = []
      //console.log(order.claims)
      //console.log(order.claims.length)
      if (order.claims && order.claims.length != undefined) {
        order.claims.forEach(claim => {
          if (claim.primaryCode) {
            bodyClaim.push([
              this.fieldColor(
                claim.primaryCode,
                3,
                2,
                claim.inadequate ? '#ff3860' : claim.status == 'confirmed' ? '#008a6b' : '#000000'
              ),
              this.fieldLabel('creation_date', 2),
              this.field(new Date(claim.creationDate).toLocaleDateString(), 2),
              this.fieldLabel('reception_date', 2),
              this.field(claim.answercreationDate ? new Date(claim.answercreationDate).toLocaleDateString() : '', 2),
            ])
            bodyClaim.push([
              this.fieldLabel('tec', 2),
              this.field(claim.tec, 2),
              this.fieldLabel('user', 2),
              this.field(claim.answertec, 2),
            ])

            if (claim.generalInfo) {
              bodyClaim.push([
                this.fieldLabel(this.$translate('generalInfotext'), 3, 2),
                this.field(claim.generalInfotext, 8),
              ])
              bodyClaim.push([this.field(claim.generalInfoanswer ? claim.generalInfoanswer : '', 8)])
            }

            if (claim.orderTypetext) {
              bodyClaim.push([
                this.fieldLabel(this.$translate('orderTypetext'), 3, 2),
                this.field(claim.orderTypetext, 8),
              ])
              bodyClaim.push([this.field(claim.orderTypeanswer ? claim.orderTypeanswer : '', 8)])
            }
            if (claim.model) {
              bodyClaim.push([this.fieldLabel(this.$translate('modeltext'), 3, 2), this.field(claim.modeltext, 8)])
              bodyClaim.push([this.field(claim.modelanswer ? claim.modelanswer : '', 8)])
            }
            if (claim.footmeasurements) {
              bodyClaim.push([
                this.fieldLabel(this.$translate('footmeasurementstext'), 3, 2),
                this.field(claim.footmeasurementstext, 8),
              ])
              bodyClaim.push([this.field(claim.footmeasurementsanswer ? claim.footmeasurementsanswer : '', 8)])
            }

            if (claim.prod_details) {
              bodyClaim.push([
                this.fieldLabel(this.$translate('prod_detailstext'), 3, 2),
                this.field(claim.prod_detailstext, 8),
              ])
              bodyClaim.push([this.field(claim.prod_detailsanswer ? claim.prod_detailsanswer : '', 8)])
            }
          }
        })

        if (bodyClaim.length != 0) {
          doc.addPage()

          autoTable(doc, {
            theme: 'grid',
            margin: { top: 100 },
            styles: { fillColor: [255, 255, 255] },
            bodyStyles: { cellPadding: 3 },
            rowPageBreak: 'avoid',

            columnStyles: {
              0: { cellWidth: 40 },
              1: { cellWidth: 40 },
              2: { cellWidth: 40 },
              3: { cellWidth: 40 },
              4: { cellWidth: 40 },
              5: { cellWidth: 40 },
              6: { cellWidth: 40 },
              7: { cellWidth: 40 },
              8: { cellWidth: 40 },
              9: { cellWidth: 40 },
              10: { cellWidth: 40 },
              11: { cellWidth: 40 },
            },
            didDrawPage: data => {
              this.AddHeader(doc, order)

              var str = doc.internal.getNumberOfPages()
              if (typeof doc.putTotalPages === 'function') {
                str = str + '/' + totalPagesExp
              }
              doc.setFontSize(10)

              var pageSize = doc.internal.pageSize
              var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
              doc.text(str, data.settings.margin.left, pageHeight - 10)
            },
            body: bodyClaim,
          })
        }
      } else if (order.claims) {
        let claim = order.claims.undefined
        if (claim && claim.primaryCode) {
          bodyClaim.push([
            this.fieldColor(
              claim.primaryCode,
              3,
              2,
              claim.inadequate ? '#ff3860' : claim.status == 'confirmed' ? '#008a6b' : '#000000'
            ),
            this.fieldLabel('creation_date', 2),
            this.field(new Date(claim.creationDate).toLocaleDateString(), 2),
            this.fieldLabel('reception_date', 2),
            this.field(claim.answercreationDate ? new Date(claim.answercreationDate).toLocaleDateString() : '', 2),
          ])
          bodyClaim.push([
            this.fieldLabel('tec', 2),
            this.field(claim.tec, 2),
            this.fieldLabel('user', 2),
            this.field(claim.answertec, 2),
          ])

          if (claim.generalInfo) {
            bodyClaim.push([
              this.fieldLabel(this.$translate('generalInfotext'), 3, 2),
              this.field(claim.generalInfotext, 8),
            ])
            bodyClaim.push([this.field(claim.generalInfoanswer ? claim.generalInfoanswer : '', 8)])
          }

          if (claim.orderTypetext) {
            bodyClaim.push([
              this.fieldLabel(this.$translate('orderTypetext'), 3, 2),
              this.field(claim.orderTypetext, 8),
            ])
            bodyClaim.push([this.field(claim.orderTypeanswer ? claim.orderTypeanswer : '', 8)])
          }
          if (claim.model) {
            bodyClaim.push([this.fieldLabel(this.$translate('modeltext'), 3, 2), this.field(claim.modeltext, 8)])
            bodyClaim.push([this.field(claim.modelanswer ? claim.modelanswer : '', 8)])
          }
          if (claim.footmeasurements) {
            bodyClaim.push([
              this.fieldLabel(this.$translate('footmeasurementstext'), 3, 2),
              this.field(claim.footmeasurementstext, 8),
            ])
            bodyClaim.push([this.field(claim.footmeasurementsanswer ? claim.footmeasurementsanswer : '', 8)])
          }

          if (claim.prod_details) {
            bodyClaim.push([
              this.fieldLabel(this.$translate('prod_detailstext'), 3, 2),
              this.field(claim.prod_detailstext, 8),
            ])
            bodyClaim.push([this.field(claim.prod_detailsanswer ? claim.prod_detailsanswer : '', 8)])
          }
        }

        if (bodyClaim.length != 0) {
          doc.addPage()

          autoTable(doc, {
            theme: 'grid',
            margin: { top: 100 },
            styles: { fillColor: [255, 255, 255] },
            bodyStyles: { cellPadding: 3 },
            rowPageBreak: 'avoid',

            columnStyles: {
              0: { cellWidth: 40 },
              1: { cellWidth: 40 },
              2: { cellWidth: 40 },
              3: { cellWidth: 40 },
              4: { cellWidth: 40 },
              5: { cellWidth: 40 },
              6: { cellWidth: 40 },
              7: { cellWidth: 40 },
              8: { cellWidth: 40 },
              9: { cellWidth: 40 },
              10: { cellWidth: 40 },
              11: { cellWidth: 40 },
            },
            didDrawPage: data => {
              this.AddHeader(doc, order)

              var str = doc.internal.getNumberOfPages()
              if (typeof doc.putTotalPages === 'function') {
                str = str + '/' + totalPagesExp
              }
              doc.setFontSize(10)

              var pageSize = doc.internal.pageSize
              var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
              doc.text(str, data.settings.margin.left, pageHeight - 10)
            },
            body: bodyClaim,
          })
        }
      }
    },
    printOrderFitsModular(order, index, firstPage, doc, totalPagesExp) {
      const config = this.$moduleConfiguration[order.module]
      this.setOrderAddress(order)
      this.falseCheck = []
      this.trueCheck = []
      this.predispoCheck = []
      let provisional = false
      let printDate = ''
      if (order.history) {
        const sendordEntry = order.history.find(el => el.newStatus === 'sendord')
        if (sendordEntry) {
          printDate = new Date(sendordEntry.date).toLocaleDateString()
        }
      }

      if (order.statusOrder == 'compord' || order.statusOrder == 'invord' || order.statusOrder == 'sendord') {
        provisional = true
      }
      if (firstPage) {
        firstPage = false
      } else {
        doc.addPage()
      }

      doc.rect(350, 10, 204, 71)
      doc.addImage(this.getLogo(), 50, 10, 285, 71)
      if (provisional) {
        doc.text(398, 50, this.$translate('provisional'))
      } else {
        if (order.id_mercury) {
          doc.text(398, 50, order.id_mercury)
        }
      }

      const body = [
        [this.titleRow('order')],
        [this.hrForTable()],
        [
          this.fieldLabel('orderType', 2),
          this.field(this.$options.filters.capitalize(this.$translate(order.orderType)), 6),
          this.fieldLabel('date', 2),
          this.field(printDate, 2),
        ],
        [this.hrForTableNoWidth()],
        [
          this.fieldLabel('orderTypeMain', 2),
          this.field(this.$options.filters.capitalize(this.$translate(order.orderType)), 6),
          this.fieldLabel('deliverySelected', 2),
          this.field(
            this.$options.filters.capitalize(this.$translate(order.deliverySelected)) +
              (order.deliverySelectedSub
                ? '\n' + this.$options.filters.capitalize(this.$translate(order.deliverySelectedSub))
                : ''),

            2
          ),
        ],
        [this.hrForTableNoWidth()],
        [
          {
            content: '',
            styles: {
              halign: 'center',
              valign: 'middle',
            },
          },
          this.titleRow('generalInfo', 1),
        ],
        [this.hrForTable()],
        [
          this.fieldLabel('cod', 1),
          this.field(order.company.mercurio_id ? order.company.mercurio_id : '', 1),
          this.fieldLabel('customer', 1),
          this.field(order.company.name, 5),
          this.fieldLabel('shop', 1),
          this.field(order.shop.name, 3),
        ],
        [
          this.fieldLabel('delivery_address', 2),
          this.field(
            this.deliveryAddress.street +
              ' ' +
              this.deliveryAddress.city +
              ' ' +
              this.deliveryAddress.postalCode +
              ' ' +
              this.$translate(this.deliveryAddress.country),
            6
          ),
          this.fieldLabel('tec', 1),
          this.field(order.tec, 3),
        ],
        [
          this.fieldLabel('primaryCode', 2),
          this.field(order.primaryCode, 4),
          this.fieldLabel('secondaryCode', 2),
          this.field(order.secondaryCode ? order.secondaryCode : '', 4),
        ],
      ]

      // digital archive segment
      if (config.orderHasDigitalArchive) {
        body.push([
          this.fieldLabel('digital_archive', 8),
          this.field(order.hasDigitalArchive ? this.$translate('yes') : this.$translate('no'), 4),
        ])
      }

      body.push(
        [this.hrForTableNoWidth()],
        // patient title
        [
          {
            content: '',
            styles: { halign: 'center', valign: 'middle' },
          },
          this.titleRow('patient', 1),
        ],

        [this.hrForTable()],

        // patient basic info row
        [
          this.fieldLabel('sex', 1),
          this.field(this.$translate(order.patient.gender), 1),
          this.fieldLabel('patient', 1),
          this.field(order.patient.name + ' ' + order.patient.surname, 5),
          this.fieldLabel('alias', 1),
          this.field(order.patient.alias, 3),
        ],

        // authorization / prec_pair / rif_history row
        [
          this.fieldLabel('authorization', 2),
          this.field(order.ASLprotocol != null ? order.ASLprotocol : '', 2),
          this.fieldLabel('prec_pair', 2),
          this.field(order.prec_pair != null ? order.prec_pair : '', 2),
          this.fieldLabel('rif_history', 2),
          this.field('', 2),
        ]
      )

      if (config.orderHasPatologies) {
        body.push(
          [this.hrForTable()],

          // left / right headings
          [
            this.field(this.$options.filters.capitalize(this.$translate('left')), 6),
            this.field(this.$options.filters.capitalize(this.$translate('right')), 6),
          ],

          // pathologies left / right
          [
            this.fieldLabel('pathologies', 3),
            this.field(
              order.pathologiesLeft && order.pathologiesLeft.length !== 0 ? order.pathologiesLeft.join(',') : '',
              3,
              3
            ),
            this.fieldLabel('pathologies', 3),
            this.field(
              order.pathologiesRight && order.pathologiesRight.length !== 0 ? order.pathologiesRight.join(',') : '',
              3,
              3
            ),
          ],

          // spacer row
          [this.field('', 3), this.field('', 3)]
        )
      }

      body.push(
        [this.hrForTableNoWidth()],

        // attach title
        [
          {
            content: '',
            styles: { halign: 'center', valign: 'middle' },
          },
          this.titleRow('attach', 1),
        ],

        // attach left/right header
        [
          this.field(this.$options.filters.capitalize(this.$translate('left')), 6),
          this.field(this.$options.filters.capitalize(this.$translate('right')), 6),
        ],

        // attach rows (scan_stl)
        [
          this.fieldLabel(order.attachment && order.attachment.scan_stl_sx ? 'V' : 'X', 1),
          this.fieldLabel('scan_duna', 2),
          this.field(
            order.attachment && order.attachment.scan_stl_sx
              ? order.id_mercury
                ? order.id_mercury + '_scan_stl_sx'
                : order.id + '_scan_stl_sx'
              : '',
            3
          ),
          this.fieldLabel(order.attachment && order.attachment.scan_stl_dx ? 'V' : 'X', 1),
          this.fieldLabel('scan_duna', 2),
          this.field(
            order.attachment && order.attachment.scan_stl_dx
              ? order.id_mercury
                ? order.id_mercury + '_scan_stl_dx'
                : order.id + '_scan_stl_dx'
              : '',
            3
          ),
        ],

        // attach rows (scan_pln)
        [
          this.fieldLabel(order.attachment && order.attachment.scan_pln_sx ? 'V' : 'X', 1),
          this.fieldLabel('plan', 2),
          this.field(
            order.attachment && order.attachment.scan_pln_sx
              ? order.id_mercury
                ? order.id_mercury + '_scan_pln_sx'
                : order.id + '_scan_pln_sx'
              : '',
            3
          ),
          this.fieldLabel(order.attachment && order.attachment.scan_pln_dx ? 'V' : 'X', 1),
          this.fieldLabel('plan', 2),
          this.field(
            order.attachment && order.attachment.scan_pln_dx
              ? order.id_mercury
                ? order.id_mercury + '_scan_pln_dx'
                : order.id + '_scan_pln_dx'
              : '',
            3
          ),
        ],

        // attach rows (scan_fms)
        [
          this.fieldLabel(order.attachment && order.attachment.scan_fms_sx ? 'V' : 'X', 1),
          this.fieldLabel('mesu', 2),
          this.field(
            order.attachment && order.attachment.scan_fms_sx
              ? order.id_mercury
                ? order.id_mercury + '_scan_fms_sx'
                : order.id + '_scan_fms_sx'
              : '',
            3
          ),
          this.fieldLabel(order.attachment && order.attachment.scan_fms_dx ? 'V' : 'X', 1),
          this.fieldLabel('mesu', 2),
          this.field(
            order.attachment && order.attachment.scan_fms_dx
              ? order.id_mercury
                ? order.id_mercury + '_scan_fms_dx'
                : order.id + '_scan_fms_dx'
              : '',
            3
          ),
        ],

        // attach rows (scan_no_duna)
        [
          this.fieldLabel(order.attachment && order.attachment.scan_no_duna_sx ? 'V' : 'X', 1),
          this.fieldLabel('scan', 2),
          this.field(
            order.attachment && order.attachment.scan_no_duna_sx
              ? order.id_mercury
                ? order.id_mercury + '_scan_no_duna_sx'
                : order.id + '_scan_no_duna_sx'
              : '',
            3
          ),
          this.fieldLabel(order.attachment && order.attachment.scan_no_duna_dx ? 'V' : 'X', 1),
          this.fieldLabel('scan', 2),
          this.field(
            order.attachment && order.attachment.scan_no_duna_dx
              ? order.id_mercury
                ? order.id_mercury + '_scan_no_duna_dx'
                : order.id + '_scan_no_duna_dx'
              : '',
            3
          ),
        ],

        // grap rows
        [
          this.fieldLabel(order.attachment && order.attachment.grap_sx ? 'V' : 'X', 1),
          this.fieldLabel('grap', 2),
          this.field(
            order.attachment && order.attachment.grap_sx
              ? order.id_mercury
                ? order.id_mercury + '_grap_sx'
                : order.id + '_grap_sx'
              : '',
            3
          ),
          this.fieldLabel(order.attachment && order.attachment.grap_dx ? 'V' : 'X', 1),
          this.fieldLabel('scan_duna', 2),
          this.field(
            order.attachment && order.attachment.grap_dx
              ? order.id_mercury
                ? order.id_mercury + '_grap_dx'
                : order.id + '_grap_dx'
              : '',
            3
          ),
        ],

        // attach rows (attach_sx / attach_dx)
        [
          this.fieldLabel(order.attachment && order.attachment.attach_sx ? 'V' : 'X', 1),
          this.fieldLabel('attach', 2),
          this.field(
            order.attachment && order.attachment.attach_sx
              ? order.id_mercury
                ? order.id_mercury + '_attach_sx'
                : order.id + '_attach_sx'
              : '',
            3
          ),
          this.fieldLabel(order.attachment && order.attachment.attach_dx ? 'V' : 'X', 1),
          this.fieldLabel('attach', 2),
          this.field(
            order.attachment && order.attachment.attach_dx
              ? order.id_mercury
                ? order.id_mercury + '_attach_dx'
                : order.id + '_attach_dx'
              : '',
            3
          ),
        ],

        [this.hrForTableNoWidth()],

        // shoe title
        [
          {
            content: '',
            styles: { halign: 'center', valign: 'middle' },
          },
          this.titleRow('shoe', 1),
        ],

        // shoe info rows
        [
          this.field('', 6, 8),
          this.fieldLabel('shoeType', 3),
          this.field(
            order.mod && order.mod.shoeType
              ? this.$options.filters.capitalize(this.$translate(order.mod.shoeType))
              : '',
            3
          ),
        ],

        [
          this.fieldLabel('catalogType', 3),
          this.field(
            order.mod && order.mod.catalogType
              ? this.$options.filters.capitalize(this.$translate(order.mod.catalogType))
              : '',
            3
          ),
        ],

        [this.fieldLabel('model', 3), this.field(this.getModel(order), 3)],

        [this.hrForTable()],

        [
          this.fieldLabel('note', 2),
          this.field(
            order.module === 'modular'
              ? order.note || ''
              : order.footmeasurements && order.footmeasurements.notes
              ? order.footmeasurements.notes
              : '',
            4,
            2
          ),
        ],

        // final spacer
        [this.field('', 2)]
      )

      autoTable(doc, {
        theme: 'grid',
        margin: { top: 100 },
        styles: { fillColor: [255, 255, 255] },
        bodyStyles: { cellPadding: 3 },
        rowPageBreak: 'avoid',

        columnStyles: {
          0: { cellWidth: 40 },
          1: { cellWidth: 40 },
          2: { cellWidth: 40 },
          3: { cellWidth: 40 },
          4: { cellWidth: 40 },
          5: { cellWidth: 40 },
          6: { cellWidth: 40 },
          7: { cellWidth: 40 },
          8: { cellWidth: 40 },
          9: { cellWidth: 40 },
          10: { cellWidth: 40 },
          11: { cellWidth: 40 },
        },
        didDrawPage: data => {
          if (data.pageNumber != 1) {
            this.AddHeader(doc, order)
          }

          // Footer
          var str = doc.internal.getNumberOfPages()
          if (typeof doc.putTotalPages === 'function') {
            str = str + '/' + totalPagesExp
          }

          doc.setFontSize(10)

          // jsPDF 1.4+ uses getWidth, <1.4 uses .width
          var pageSize = doc.internal.pageSize
          var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
          doc.text(str, data.settings.margin.left, pageHeight - 10)
        },
        willDrawCell: data => {
          let Cell = data.column.index + ':' + data.row.index

          if (data.cell && data.cell.text && data.cell.text[0] == 'X') {
            data.cell.text = []
            this.falseCheck.push(Cell)
          }
          if (data.cell && data.cell.text && data.cell.text[0] == 'V') {
            data.cell.text = []
            this.trueCheck.push(Cell)
          }
        },
        didDrawCell: data => {
          var dim = 0
          var textPos = {}
          let Cell = data.column.index + ':' + data.row.index

          if (this.falseCheck.includes(Cell)) {
            dim = data.cell.height - data.cell.padding('vertical')
            textPos = data.cell
            this.falseCheck.splice(this.falseCheck.indexOf(Cell), 1)
            doc.addImage(
              this.getCheckFalse(),
              textPos.x + data.cell.width / 2 - dim / 2,
              textPos.y + data.cell.height / 2 - dim / 2,
              10,
              10
            )
          }
          if (this.trueCheck.includes(Cell)) {
            dim = data.cell.height - data.cell.padding('vertical')
            textPos = data.cell
            this.trueCheck.splice(this.trueCheck.indexOf(Cell), 1)
            doc.addImage(
              this.getCheckTrue(),
              textPos.x + data.cell.width / 2 - dim / 2,
              textPos.y + data.cell.height / 2 - dim / 2,
              10,
              10
            )
          }

          if (data.column.index === 0 && data.row.index === 6 && data.cell.section === 'body') {
            // console.log(data);
            dim = data.cell.height - data.cell.padding('vertical')
            textPos = data.cell
            doc.addImage(
              this.getInfo(),
              textPos.x + data.cell.width / 2 - dim / 2,
              textPos.y + data.cell.height / 2 - dim / 2,
              dim,
              dim
            )
          }
          if (
            data.column.index === 0 &&
            data.row.index === (order.module === 'fits' ? 12 : 13) &&
            data.cell.section === 'body'
          ) {
            dim = data.cell.height - data.cell.padding('vertical')
            textPos = data.cell
            doc.addImage(
              this.getUser(),
              textPos.x + data.cell.width / 2 - dim / 2,
              textPos.y + data.cell.height / 2 - dim / 2,
              dim,
              dim
            )
          }
          if (
            data.column.index === 0 &&
            data.row.index === (order.module === 'fits' ? 21 : 18) &&
            data.cell.section === 'body'
          ) {
            dim = data.cell.height - data.cell.padding('vertical')
            textPos = data.cell
            doc.addImage(
              this.getAttach(),
              textPos.x + data.cell.width / 2 - dim / 2,
              textPos.y + data.cell.height / 2 - dim / 2,
              dim,
              dim
            )
          }
          if (
            data.column.index === 0 &&
            data.row.index === (order.module === 'fits' ? 30 : 27) &&
            data.cell.section === 'body'
          ) {
            dim = data.cell.height - data.cell.padding('vertical')
            textPos = data.cell
            doc.addImage(
              this.getShoe(),
              textPos.x + data.cell.width / 2 - dim / 2,
              textPos.y + data.cell.height / 2 - dim / 2,
              dim,
              dim
            )
          }

          if (
            data.column.index === 0 &&
            data.row.index === (order.module === 'fits' ? 31 : 28) &&
            data.cell.section === 'body'
          ) {
            if (this.arrayImageModel[this.modelCounter] !== false) {
              dim = data.cell.height - data.cell.padding('vertical')
              textPos = data.cell
              doc.addImage(
                this.arrayImageModel[this.modelCounter],
                textPos.x +
                  data.cell.width / 2 -
                  (this.arrayImageModel[this.modelCounter].width *
                    (dim / this.arrayImageModel[this.modelCounter].height)) /
                    2,
                textPos.y + data.cell.height / 2 - dim / 2,
                this.arrayImageModel[this.modelCounter].width * (dim / this.arrayImageModel[this.modelCounter].height),
                dim
              )
            }
            this.modelCounter++
          }
        },
        body,
      })
      doc.addPage()
      let addonTable
      if (order.module === 'fits') {
        addonTable = [
          [this.hrForTableNoWidth()],
          [
            this.field('', 3),
            this.fieldLabel('SX', 2),
            this.fieldLabel('Add-On', 2),
            this.fieldLabel('DX', 2),
            this.field('', 3),
          ],
          [
            this.field('', 3, 4),
            this.field(
              order.footmeasurements && order.footmeasurements.left && order.footmeasurements.left.add_instep
                ? order.footmeasurements.left.add_instep
                : this.$translate('Noone'),
              2
            ),
            this.fieldLabel('instep', 2),
            this.field(
              order.footmeasurements && order.footmeasurements.right && order.footmeasurements.right.add_instep
                ? order.footmeasurements.right.add_instep
                : this.$translate('Noone'),
              2
            ),
            this.field('', 3, 4),
          ],
          [
            this.field(
              order.footmeasurements && order.footmeasurements.left && order.footmeasurements.left.add_fifthMeta
                ? order.footmeasurements.left.add_fifthMeta
                : this.$translate('Noone'),
              2
            ),
            this.fieldLabel('add_fifthMeta', 2),
            this.field(
              order.footmeasurements && order.footmeasurements.right && order.footmeasurements.right.add_fifthMeta
                ? order.footmeasurements.right.add_fifthMeta
                : this.$translate('Noone'),
              2
            ),
          ],
          [
            this.field(
              order.footmeasurements && order.footmeasurements.left && order.footmeasurements.left.add_toe
                ? order.footmeasurements.left.add_toe
                : this.$translate('Noone'),
              2
            ),
            this.fieldLabel('toe', 2),
            this.field(
              order.footmeasurements && order.footmeasurements.right && order.footmeasurements.right.add_toe
                ? order.footmeasurements.right.add_toe
                : this.$translate('Noone'),
              2
            ),
          ],
          [
            this.field(
              order.footmeasurements && order.footmeasurements.left && order.footmeasurements.left.add_firstMeta
                ? order.footmeasurements.left.add_firstMeta
                : this.$translate('Noone'),
              2
            ),
            this.fieldLabel('add_firstMeta', 2),
            this.field(
              order.footmeasurements && order.footmeasurements.right && order.footmeasurements.right.add_firstMeta
                ? order.footmeasurements.right.add_firstMeta
                : this.$translate('Noone'),
              2
            ),
          ],
          [
            this.field('', 3, 2),
            this.field(
              order.footmeasurements && order.footmeasurements.left && order.footmeasurements.left.add_extraTotal
                ? order.footmeasurements.left.add_extraTotal
                : this.$translate('Noone'),
              2
            ),
            this.fieldLabel('add_extraTotal', 2),
            this.field(
              order.footmeasurements && order.footmeasurements.right && order.footmeasurements.right.add_extraTotal
                ? order.footmeasurements.right.add_extraTotal
                : this.$translate('Noone'),
              2
            ),
            this.field('', 3, 2),
          ],
          [
            this.field(
              order.footmeasurements && order.footmeasurements.left && order.footmeasurements.left.add_extraHeel
                ? order.footmeasurements.left.add_extraHeel
                : this.$translate('Noone'),
              2
            ),
            this.fieldLabel('add_extraHeel', 2),
            this.field(
              order.footmeasurements && order.footmeasurements.right && order.footmeasurements.right.add_extraHeel
                ? order.footmeasurements.right.add_extraHeel
                : this.$translate('Noone'),
              2
            ),
          ],
        ]
      } else if (order.module === 'modular') {
        addonTable = [
          [this.hrForTableNoWidth()],
          [
            this.field('', 3),
            this.fieldLabel('SX', 2),
            this.fieldLabel('Add-On', 2),
            this.fieldLabel('DX', 2),
            this.field('', 3),
          ],
          [
            this.field('', 3, 4),
            this.field(
              order.footmeasurements && order.footmeasurements.left && order.footmeasurements.left.add_instep
                ? order.footmeasurements.left.add_instep
                : this.$translate('Noone'),
              2
            ),
            this.fieldLabel('instep', 2),
            this.field(
              order.footmeasurements && order.footmeasurements.right && order.footmeasurements.right.add_instep
                ? order.footmeasurements.right.add_instep
                : this.$translate('Noone'),
              2
            ),
            this.field('', 3, 4),
          ],
          [
            this.field(
              order.footmeasurements && order.footmeasurements.left && order.footmeasurements.left.add_fifthMeta
                ? order.footmeasurements.left.add_fifthMeta
                : this.$translate('Noone'),
              2
            ),
            this.fieldLabel('add_fifthMeta', 2),
            this.field(
              order.footmeasurements && order.footmeasurements.right && order.footmeasurements.right.add_fifthMeta
                ? order.footmeasurements.right.add_fifthMeta
                : this.$translate('Noone'),
              2
            ),
          ],
          [
            this.field(
              order.footmeasurements && order.footmeasurements.left && order.footmeasurements.left.add_toe
                ? order.footmeasurements.left.add_toe
                : this.$translate('Noone'),
              2
            ),
            this.fieldLabel('toe', 2),
            this.field(
              order.footmeasurements && order.footmeasurements.right && order.footmeasurements.right.add_toe
                ? order.footmeasurements.right.add_toe
                : this.$translate('Noone'),
              2
            ),
          ],
          [
            this.field(
              order.footmeasurements && order.footmeasurements.left && order.footmeasurements.left.add_firstMeta
                ? order.footmeasurements.left.add_firstMeta
                : this.$translate('Noone'),
              2
            ),
            this.fieldLabel('add_firstMeta', 2),
            this.field(
              order.footmeasurements && order.footmeasurements.right && order.footmeasurements.right.add_firstMeta
                ? order.footmeasurements.right.add_firstMeta
                : this.$translate('Noone'),
              2
            ),
          ],
          [
            this.field('', 3, 2),
            this.field(
              order.footmeasurements && order.footmeasurements.left && order.footmeasurements.left.add_extraTotal
                ? order.footmeasurements.left.add_extraTotal
                : this.$translate('Noone'),
              2,
              2
            ),
            this.fieldLabel('add_extraTotal', 2),
            this.field(
              order.footmeasurements && order.footmeasurements.right && order.footmeasurements.right.add_extraTotal
                ? order.footmeasurements.right.add_extraTotal
                : this.$translate('Noone'),
              2,
              2
            ),
            this.field('', 3, 2),
          ],
        ]
      }
      autoTable(doc, {
        theme: 'grid',
        margin: { top: 100 },
        styles: { fillColor: [255, 255, 255] },
        bodyStyles: { cellPadding: 3 },
        rowPageBreak: 'avoid',

        columnStyles: {
          0: { cellWidth: 40 },
          1: { cellWidth: 40 },
          2: { cellWidth: 40 },
          3: { cellWidth: 40 },
          4: { cellWidth: 40 },
          5: { cellWidth: 40 },
          6: { cellWidth: 40 },
          7: { cellWidth: 40 },
          8: { cellWidth: 40 },
          9: { cellWidth: 40 },
          10: { cellWidth: 40 },
          11: { cellWidth: 40 },
        },
        didDrawPage: data => {
          this.AddHeader(doc, order)

          // Footer
          var str = doc.internal.getNumberOfPages()
          if (typeof doc.putTotalPages === 'function') {
            str = str + '/' + totalPagesExp
          }
          doc.setFontSize(10)

          // jsPDF 1.4+ uses getWidth, <1.4 uses .width
          var pageSize = doc.internal.pageSize
          var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
          doc.text(str, data.settings.margin.left, pageHeight - 10)
        },
        willDrawCell: data => {
          let Cell = data.column.index + ':' + data.row.index

          if (data.cell && data.cell.text && data.cell.text[0] == 'X') {
            data.cell.text = []
            this.falseCheck.push(Cell)
          }
          if (data.cell && data.cell.text && data.cell.text[0] == 'V') {
            data.cell.text = []
            this.trueCheck.push(Cell)
          }
          if (data.cell && data.cell.text && data.cell.text[0] == 'P') {
            data.cell.text = []
            this.predispoCheck.push(Cell)
          }

          if (
            (data.row.index === 7 ||
              data.row.index === 8 ||
              data.row.index === 9 ||
              data.row.index === 10 ||
              data.row.index === 11 ||
              data.row.index === 12 ||
              data.row.index === 13 ||
              data.row.index === 14 ||
              data.row.index === 15 ||
              data.row.index === 16) &&
            data.cell.section === 'body'
          ) {
            let diff = data.cell.height - 30
            data.cell.minCellHeight = 30
            data.cell.height = 30
            data.row.height = 30
            data.cell.y -= diff / 2
          }
        },
        didDrawCell: data => {
          var dim = 0
          var textPos = {}
          let Cell = data.column.index + ':' + data.row.index

          if (this.falseCheck.includes(Cell)) {
            dim = data.cell.height - data.cell.padding('vertical')
            textPos = data.cell
            this.falseCheck.splice(this.falseCheck.indexOf(Cell), 1)
            doc.addImage(
              this.getCheckFalse(),
              textPos.x + data.cell.width / 2 - dim / 2,
              textPos.y + data.cell.height / 2 - dim / 2,
              10,
              10
            )
          }
          if (this.trueCheck.includes(Cell)) {
            dim = data.cell.height - data.cell.padding('vertical')
            textPos = data.cell
            this.trueCheck.splice(this.trueCheck.indexOf(Cell), 1)
            doc.addImage(
              this.getCheckTrue(),
              textPos.x + data.cell.width - dim / 2,
              textPos.y + data.cell.height / 2 - dim / 2,
              10,
              10
            )
          }

          if (this.predispoCheck.includes(Cell)) {
            dim = data.cell.height - data.cell.padding('vertical')
            textPos = data.cell
            this.predispoCheck.splice(this.predispoCheck.indexOf(Cell), 1)
            doc.addImage(
              this.getPredisspo(),
              textPos.x + data.cell.width / 2 - dim / 2,
              textPos.y + data.cell.height / 2 - dim / 2,
              dim * 2,
              dim
            )
          }

          if (data.column.index === 0 && data.row.index === 0 && data.cell.section === 'body') {
            dim = data.cell.height - data.cell.padding('vertical')
            textPos = data.cell
            doc.addImage(
              this.getMesaurement(),
              textPos.x + data.cell.width / 2 - dim / 2,
              textPos.y + data.cell.height / 2 - dim / 2,
              dim,
              dim
            )
          }
          if (
            (data.column.index === 3 || data.column.index === 7) &&
            data.row.index === 8 &&
            data.cell.section === 'body'
          ) {
            textPos = data.cell

            doc.addImage(
              this.getLongImage(),
              textPos.x + data.cell.width / 2 - 60.84 / 2,
              textPos.y + data.cell.height / 2 - 18,
              60.84,
              24
            )
          }
          if (
            (data.column.index === 3 || data.column.index === 7) &&
            data.row.index === 9 &&
            data.cell.section === 'body'
          ) {
            textPos = data.cell

            doc.addImage(
              this.getLargeImage(),
              textPos.x + data.cell.width / 2 - 60.84 / 2,
              textPos.y + data.cell.height / 2 - 18,
              60.84,
              24
            )
          }
          if (
            (data.column.index === 3 || data.column.index === 7) &&
            data.row.index === 10 &&
            data.cell.section === 'body'
          ) {
            textPos = data.cell

            doc.addImage(
              this.getCircRetroMetaImage(),
              textPos.x + data.cell.width / 2 - 60.84 / 2,
              textPos.y + data.cell.height / 2 - 18,
              60.84,
              24
            )
          }

          if (
            (data.column.index === 3 || data.column.index === 7) &&
            (data.row.index === 11 || (data.row.index === 12 && order.module === 'fits')) &&
            data.cell.section === 'body'
          ) {
            textPos = data.cell

            doc.addImage(
              this.getCircColloImage(),
              textPos.x + data.cell.width / 2 - 43.2 / 2,
              textPos.y + data.cell.height / 2 - 18,
              43.2,
              24
            )
          }
          if (
            (data.column.index === 3 || data.column.index === 7) &&
            data.row.index === (order.module === 'fits' ? 13 : 12) &&
            data.cell.section === 'body'
          ) {
            textPos = data.cell

            doc.addImage(
              this.getPassataImage(),
              textPos.x + data.cell.width / 2 - 43.2 / 2,
              textPos.y + data.cell.height / 2 - 18,
              43.2,
              24
            )
          }
          if (order.shoeType === 'high' && order.module === 'fits') {
            if (
              (data.column.index === 3 || data.column.index === 7) &&
              data.row.index === 14 &&
              data.cell.section === 'body'
            ) {
              textPos = data.cell

              doc.addImage(
                this.getTermineTomaiaImage(),
                textPos.x + data.cell.width / 2 - 43.2 / 2,
                textPos.y + data.cell.height / 2 - 18,
                43.2,
                24
              )
            }
            if (
              (data.column.index === 3 || data.column.index === 7) &&
              data.row.index === 15 &&
              data.cell.section === 'body'
            ) {
              textPos = data.cell

              doc.addImage(
                this.getHighPointImage(),
                textPos.x + data.cell.width / 2 - 60.84 / 2,
                textPos.y + data.cell.height / 2 - 18,
                60.84,
                24
              )
            }
            if (
              (data.column.index === 3 || data.column.index === 7) &&
              data.row.index === 16 &&
              data.cell.section === 'body'
            ) {
              textPos = data.cell

              doc.addImage(
                this.getAltezzaTermineTomaiaImage(),
                textPos.x + data.cell.width / 2 - 43.2 / 2,
                textPos.y + data.cell.height / 2 - 18,
                43.2,
                24
              )
            }
            if (
              (data.column.index === 0 || data.column.index === 9) &&
              data.row.index === 19 &&
              data.cell.section === 'body'
            ) {
              textPos = data.cell

              doc.addImage(
                this.getAddon1(),
                textPos.x + data.cell.width / 2 - 121.68 / 2,
                textPos.y + data.cell.height / 2 - 18,
                121.68,
                48
              )
            }
            if (
              (data.column.index === 0 || data.column.index === 9) &&
              data.row.index === 23 &&
              data.cell.section === 'body'
            ) {
              textPos = data.cell

              doc.addImage(
                this.getAddon2(),
                textPos.x + data.cell.width / 2 - 91.26 / 2,
                textPos.y + data.cell.height / 2 - 16,
                91.26,
                36
              )
            }
          } else {
            if (
              (data.column.index === 3 || data.column.index === 7) &&
              data.row.index === (order.module === 'fits' ? 14 : 13) &&
              data.cell.section === 'body'
            ) {
              textPos = data.cell

              doc.addImage(
                this.getHighPointImage(),
                textPos.x + data.cell.width / 2 - 60.84 / 2,
                textPos.y + data.cell.height / 2 - 18,
                60.84,
                24
              )
            }
            if (
              (data.column.index === 3 || data.column.index === 7) &&
              data.row.index === 15 &&
              data.cell.section === 'body' &&
              order.module === 'fits'
            ) {
              textPos = data.cell

              doc.addImage(
                this.getAltezzaTermineTomaiaImage(),
                textPos.x + data.cell.width / 2 - 43.2 / 2,
                textPos.y + data.cell.height / 2 - 18,
                43.2,
                24
              )
            }
            if (
              (data.column.index === 0 || data.column.index === 9) &&
              data.row.index === (order.module === 'fits' ? 18 : 17) &&
              data.cell.section === 'body'
            ) {
              textPos = data.cell

              doc.addImage(
                this.getAddon1(),
                textPos.x + data.cell.width / 2 - 121.68 / 2,
                textPos.y + data.cell.height / 2 - 9,
                121.68,
                48
              )
            }
            if (
              (data.column.index === 0 || data.column.index === 9) &&
              data.row.index === (order.module === 'fits' ? 22 : 21) &&
              data.cell.section === 'body'
            ) {
              textPos = data.cell

              doc.addImage(
                this.getAddon2(),
                textPos.x + data.cell.width / 2 - 60.84 / 2,
                textPos.y + data.cell.height / 2 - 9,
                60.84,
                24
              )
            }
          }
        },

        body: [
          [
            {
              content: '',
              styles: {
                halign: 'center',
                valign: 'middle',
              },
            },
            this.titleRow('forma', 1),
          ],

          [this.hrForTable()],
          [this.fieldLabel('forma', 3), this.field(order.mod && order.mod.sole ? this.getShapeName(order) : '', 9)],
          [this.hrForTable()],
          [this.fieldLabel('SX', 6), this.fieldLabel('DX', 6)],
          [
            this.fieldLabel('size', 3),
            this.fieldLabel('fit_code', 3),
            this.fieldLabel('size', 3),
            this.fieldLabel('fit_code', 3),
          ],
          [
            this.field(
              order.footmeasurements && order.footmeasurements.left ? order.footmeasurements.left.size : '',
              3
            ),
            this.field(
              order.footmeasurements && order.footmeasurements.left ? order.footmeasurements.left.fit_code : '',
              3
            ),
            this.field(
              order.footmeasurements && order.footmeasurements.right ? order.footmeasurements.right.size : '',
              3
            ),
            this.field(
              order.footmeasurements && order.footmeasurements.right ? order.footmeasurements.right.fit_code : '',
              3
            ),
          ],
          [
            this.fieldLabel('last', 1),
            this.fieldLabel('foot', 2),
            this.fieldLabel('image', 2),
            this.fieldLabel('mesu', 2),
            this.fieldLabel('image', 2),
            this.fieldLabel('foot', 2),
            this.fieldLabel('last', 1),
          ],
        ]
          .concat(this.shapeTable(order))
          .concat([[this.hrForTableNoWidth()]])
          .concat(addonTable),
      })
      doc.addPage()
      autoTable(doc, {
        theme: 'grid',
        margin: { top: 100 },
        styles: { fillColor: [255, 255, 255] },
        bodyStyles: { cellPadding: 3 },
        rowPageBreak: 'avoid',

        columnStyles: {
          0: { cellWidth: 40 },
          1: { cellWidth: 40 },
          2: { cellWidth: 40 },
          3: { cellWidth: 40 },
          4: { cellWidth: 40 },
          5: { cellWidth: 40 },
          6: { cellWidth: 40 },
          7: { cellWidth: 40 },
          8: { cellWidth: 40 },
          9: { cellWidth: 40 },
          10: { cellWidth: 40 },
          11: { cellWidth: 40 },
        },
        didDrawPage: data => {
          this.AddHeader(doc, order)

          var str = doc.internal.getNumberOfPages()
          if (typeof doc.putTotalPages === 'function') {
            str = str + '/' + totalPagesExp
          }
          doc.setFontSize(10)

          var pageSize = doc.internal.pageSize
          var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
          doc.text(str, data.settings.margin.left, pageHeight - 10)
        },
        didParseCell: data => {
          if (
            data.column.index === 0 &&
            data.row.index === 17 + 21 + this.arrayrowCounterAllacciatura[this.allacciaCounter] &&
            data.cell.section === 'body'
          ) {
            if (this.arrayrowCounterAllacciatura[this.allacciaCounter] === 8) {
              data.cell.styles.minCellHeight = 30
            }
          }
        },
        willDrawCell: data => {
          let Cell = data.column.index + ':' + data.row.index

          if (data.cell && data.cell.text && data.cell.text[0] == 'X') {
            data.cell.text = []
            this.falseCheck.push(Cell)
          }
          if (data.cell && data.cell.text && data.cell.text[0] == 'V') {
            data.cell.text = []
            this.trueCheck.push(Cell)
          }
        },
        didDrawCell: data => {
          var dim = 0
          var textPos = {}
          let Cell = data.column.index + ':' + data.row.index

          if (this.falseCheck.includes(Cell)) {
            dim = data.cell.height - data.cell.padding('vertical')
            textPos = data.cell
            this.falseCheck.splice(this.falseCheck.indexOf(Cell), 1)
            doc.addImage(
              this.getCheckFalse(),
              textPos.x + data.cell.width / 2 - dim / 2,
              textPos.y + data.cell.height / 2 - dim / 2,
              10,
              10
            )
          }
          if (this.trueCheck.includes(Cell)) {
            dim = data.cell.height - data.cell.padding('vertical')
            textPos = data.cell
            this.trueCheck.splice(this.trueCheck.indexOf(Cell), 1)
            doc.addImage(
              this.getCheckTrue(),
              textPos.x + data.cell.width / 2 - dim / 2,
              textPos.y + data.cell.height / 2 - dim / 2,
              10,
              10
            )
          }

          if (data.column.index === 0 && data.row.index === 97 - 97 && data.cell.section === 'body') {
            dim = data.cell.height - data.cell.padding('vertical')
            textPos = data.cell
            doc.addImage(
              this.getMesaurement(),
              textPos.x + data.cell.width / 2 - dim / 2,
              textPos.y + data.cell.height / 2 - dim / 2,
              dim,
              dim
            )
          }

          if (data.column.index === 0 && data.row.index === 20 && data.cell.section === 'body') {
            dim = data.cell.height - data.cell.padding('vertical')
            textPos = data.cell
            doc.addImage(
              this.getCaratteristicheTecniche(),
              textPos.x + data.cell.width / 2 - dim / 2,
              textPos.y + data.cell.height / 2 - dim / 2,
              dim,
              dim
            )
          }

          if (
            data.column.index === 0 &&
            data.row.index === 46 + 6 + 3 + this.arrayrowCounterAllacciatura[this.allacciaCounter] &&
            data.cell.section === 'body'
          ) {
            dim = data.cell.height - data.cell.padding('vertical')
            textPos = data.cell
            doc.addImage(
              this.getGuardolo(),
              textPos.x + data.cell.width / 2 - dim / 2,
              textPos.y + data.cell.height / 2 - dim / 2,
              dim,
              dim
            )
          }

          if (
            data.column.index === 0 &&
            data.row.index === 50 + 6 + 3 + this.arrayrowCounterAllacciatura[this.allacciaCounter] &&
            data.cell.section === 'body'
          ) {
            dim = data.cell.height - data.cell.padding('vertical')
            textPos = data.cell
            doc.addImage(
              this.getMesaurement(),
              textPos.x + data.cell.width / 2 - dim / 2,
              textPos.y + data.cell.height / 2 - dim / 2,
              dim,
              dim
            )
          }

          if (
            data.column.index === 0 &&
            data.row.index === 50 + 28 + 6 + 3 + 1 + this.arrayrowCounterAllacciatura[this.allacciaCounter] &&
            data.cell.section === 'body'
          ) {
            this.allacciaCounter++
            dim = data.cell.height - data.cell.padding('vertical')
            textPos = data.cell
            doc.addImage(
              this.getMesaurement(),
              textPos.x + data.cell.width / 2 - dim / 2,
              textPos.y + data.cell.height / 2 - dim / 2,
              dim,
              dim
            )
          }
        },

        body: [
          [
            {
              content: '',
              styles: { halign: 'center', valign: 'middle' },
            },
            this.titleRow('model_details', 1),
          ],
          [this.hrForTable()],
        ]
          .concat(this.pellAndFoderaTable(order))
          .concat(this.allacciaturaTableFitsModular(order))
          .concat([
            [this.hrForTable()],
            [this.fieldLabel(['fondo'], 12, 1, true)],
            [this.fieldLabel(['sole'], 4), this.field(order.mod && order.mod.sole ? order.mod.sole.CUI : undefined, 8)],
            [
              this.fieldLabel(['foggia'], 4),
              this.field(
                order.mod && order.mod.sole && order.mod.sole.foggia
                  ? order.mod.sole.foggia.CUI + ' ' + order.mod.sole.foggia.commercial_name
                  : undefined,
                8
              ),
            ],
            [
              this.fieldLabel(['tread'], 4),
              this.field(
                order.mod && order.mod.sole && order.mod.sole.tread
                  ? order.mod.sole.tread.CUI + ' ' + order.mod.sole.tread.commercial_name
                  : undefined,
                8
              ),
            ],
            [
              this.fieldLabel(['color'], 4),
              this.field(
                order.mod && order.mod.sole && order.mod.sole.color
                  ? order.mod.sole.color.CUI + ' ' + order.mod.sole.color.commercial_name
                  : undefined,
                8
              ),
            ],
          ])
          .concat(this.contraffortiTable(order))
          .concat(this.sottopiedeTable(order))
          .concat([
            [this.hrForTable()],
            [this.fieldLabel('ext_rise', 12, 1, true)],
            [this.fieldLabel('left', 4), this.fieldLabel('', 4), this.fieldLabel('right', 4)],
            [
              this.field(
                order.prod_details &&
                  order.prod_details.left &&
                  order.prod_details.left.extRise &&
                  order.prod_details.left.extRise.heel_rise
                  ? order.prod_details.left.extRise.heel_rise
                  : '',
                4
              ),
              this.fieldLabel('heel_rise', 4),
              this.field(
                order.prod_details &&
                  order.prod_details.right &&
                  order.prod_details.right.extRise &&
                  order.prod_details.right.extRise.heel_rise
                  ? order.prod_details.right.extRise.heel_rise
                  : '',
                4
              ),
            ],
            [
              this.field(
                order.prod_details &&
                  order.prod_details.left &&
                  order.prod_details.left.extRise &&
                  order.prod_details.left.extRise.ball_rise
                  ? order.prod_details.left.extRise.ball_rise
                  : '',
                4
              ),
              this.fieldLabel('ball_rise', 4),
              this.field(
                order.prod_details &&
                  order.prod_details.right &&
                  order.prod_details.right.extRise &&
                  order.prod_details.right.extRise.ball_rise
                  ? order.prod_details.right.extRise.ball_rise
                  : '',
                4
              ),
            ],
            [
              this.field(
                order.prod_details &&
                  order.prod_details.left &&
                  order.prod_details.left.extRise &&
                  order.prod_details.left.extRise.fings_rise
                  ? order.prod_details.left.extRise.fings_rise
                  : '',
                4
              ),
              this.fieldLabel('fings_rise', 4),
              this.field(
                order.prod_details &&
                  order.prod_details.right &&
                  order.prod_details.right.extRise &&
                  order.prod_details.right.extRise.fings_rise
                  ? order.prod_details.right.extRise.fings_rise
                  : '',
                4
              ),
            ],
            [this.hrForTable()],
            [this.fieldLabel('camber', 12, 1, true)],
            [this.fieldLabel('left', 4), this.fieldLabel('', 4), this.fieldLabel('right', 4)],
            [
              this.field(
                order.prod_details &&
                  order.prod_details.left &&
                  order.prod_details.left.camber &&
                  order.prod_details.left.camber.medial
                  ? order.prod_details.left.camber.medial
                  : '',
                4
              ),
              this.fieldLabel('medial_camber', 4),
              this.field(
                order.prod_details &&
                  order.prod_details.right &&
                  order.prod_details.right.camber &&
                  order.prod_details.right.camber.medial
                  ? order.prod_details.right.camber.medial
                  : '',
                4
              ),
            ],
            [
              this.field(
                order.prod_details &&
                  order.prod_details.left &&
                  order.prod_details.left.camber &&
                  order.prod_details.left.camber.side
                  ? order.prod_details.left.camber.side
                  : '',
                4
              ),
              this.fieldLabel('side_camber', 4),
              this.field(
                order.prod_details &&
                  order.prod_details.right &&
                  order.prod_details.right.camber &&
                  order.prod_details.right.camber.side
                  ? order.prod_details.right.camber.side
                  : '',
                4
              ),
            ],
            [this.hrForTable()],
            [this.fieldLabel('speronatura', 12, 1, true)],
            [this.fieldLabel('left', 4), this.fieldLabel('', 4), this.fieldLabel('right', 4)],
            [
              this.field(
                order.prod_details &&
                  order.prod_details.left &&
                  order.prod_details.left.speronatura &&
                  order.prod_details.left.speronatura.medial_heel
                  ? order.prod_details.left.speronatura.medial_heel
                  : '',
                4
              ),
              this.fieldLabel('spe_medial_heel', 4),
              this.field(
                order.prod_details &&
                  order.prod_details.right &&
                  order.prod_details.right.speronatura &&
                  order.prod_details.right.speronatura.medial_heel
                  ? order.prod_details.right.speronatura.medial_heel
                  : '',
                4
              ),
            ],
            [
              this.field(
                order.prod_details &&
                  order.prod_details.left &&
                  order.prod_details.left.speronatura &&
                  order.prod_details.left.speronatura.side_heel
                  ? order.prod_details.left.speronatura.side_heel
                  : '',
                4
              ),
              this.fieldLabel('spe_side_heel', 4),
              this.field(
                order.prod_details &&
                  order.prod_details.right &&
                  order.prod_details.right.speronatura &&
                  order.prod_details.right.speronatura.side_heel
                  ? order.prod_details.right.speronatura.side_heel
                  : '',
                4
              ),
            ],
            [
              this.field(
                order.prod_details &&
                  order.prod_details.left &&
                  order.prod_details.left.speronatura &&
                  order.prod_details.left.speronatura.medial_plant
                  ? order.prod_details.left.speronatura.medial_plant
                  : '',
                4
              ),
              this.fieldLabel('spe_medial_plant', 4),
              this.field(
                order.prod_details &&
                  order.prod_details.right &&
                  order.prod_details.right.speronatura &&
                  order.prod_details.right.speronatura.medial_plant
                  ? order.prod_details.right.speronatura.medial_plant
                  : '',
                4
              ),
            ],
            [
              this.field(
                order.prod_details &&
                  order.prod_details.left &&
                  order.prod_details.left.speronatura &&
                  order.prod_details.left.speronatura.side_plant
                  ? order.prod_details.left.speronatura.side_plant
                  : '',
                4
              ),
              this.fieldLabel('spe_side_plant', 4),
              this.field(
                order.prod_details &&
                  order.prod_details.right &&
                  order.prod_details.right.speronatura &&
                  order.prod_details.right.speronatura.side_plant
                  ? order.prod_details.right.speronatura.side_plant
                  : '',
                4
              ),
            ],
          ]),
      })

      // HOTFIX: the add of page on even pages is out of the method with a specific handler in the foreach loop of print
      // if (doc.getNumberOfPages() % 2 !== 0) doc.addPage()
      //console.log(doc.getNumberOfPages())
      // if (doc.getNumberOfPages() % 2 !== 0) {
      //   doc.addPage()
      // }

      let bodyClaim = []
      //console.log(order.claims)
      //console.log(order.claims.length)
      if (order.claims && order.claims.length !== undefined) {
        order.claims.forEach(claim => {
          if (claim.primaryCode) {
            bodyClaim.push([
              this.fieldColor(
                claim.primaryCode,
                3,
                2,
                claim.inadequate ? '#ff3860' : claim.status === 'confirmed' ? '#008a6b' : '#000000'
              ),
              this.fieldLabel('creation_date', 2),
              this.field(new Date(claim.creationDate).toLocaleDateString(), 2),
              this.fieldLabel('reception_date', 2),
              this.field(claim.answercreationDate ? new Date(claim.answercreationDate).toLocaleDateString() : '', 2),
            ])
            bodyClaim.push([
              this.fieldLabel('tec', 2),
              this.field(claim.tec, 2),
              this.fieldLabel('user', 2),
              this.field(claim.answertec, 2),
            ])

            if (claim.generalInfo) {
              bodyClaim.push([
                this.fieldLabel(this.$translate('generalInfotext'), 3, 2),
                this.field(claim.generalInfotext, 8),
              ])
              bodyClaim.push([this.field(claim.generalInfoanswer ? claim.generalInfoanswer : '', 8)])
            }

            if (claim.orderTypetext) {
              bodyClaim.push([
                this.fieldLabel(this.$translate('orderTypetext'), 3, 2),
                this.field(claim.orderTypetext, 8),
              ])
              bodyClaim.push([this.field(claim.orderTypeanswer ? claim.orderTypeanswer : '', 8)])
            }
            if (claim.model) {
              bodyClaim.push([this.fieldLabel(this.$translate('modeltext'), 3, 2), this.field(claim.modeltext, 8)])
              bodyClaim.push([this.field(claim.modelanswer ? claim.modelanswer : '', 8)])
            }
            if (claim.footmeasurements) {
              bodyClaim.push([
                this.fieldLabel(this.$translate('footmeasurementstext'), 3, 2),
                this.field(claim.footmeasurementstext, 8),
              ])
              bodyClaim.push([this.field(claim.footmeasurementsanswer ? claim.footmeasurementsanswer : '', 8)])
            }

            if (claim.prod_details) {
              bodyClaim.push([
                this.fieldLabel(this.$translate('prod_detailstext'), 3, 2),
                this.field(claim.prod_detailstext, 8),
              ])
              bodyClaim.push([this.field(claim.prod_detailsanswer ? claim.prod_detailsanswer : '', 8)])
            }
          }
        })
        if (bodyClaim.length != 0) {
          doc.addPage()

          autoTable(doc, {
            theme: 'grid',
            margin: { top: 100 },
            styles: { fillColor: [255, 255, 255] },
            bodyStyles: { cellPadding: 3 },
            rowPageBreak: 'avoid',

            columnStyles: {
              0: { cellWidth: 40 },
              1: { cellWidth: 40 },
              2: { cellWidth: 40 },
              3: { cellWidth: 40 },
              4: { cellWidth: 40 },
              5: { cellWidth: 40 },
              6: { cellWidth: 40 },
              7: { cellWidth: 40 },
              8: { cellWidth: 40 },
              9: { cellWidth: 40 },
              10: { cellWidth: 40 },
              11: { cellWidth: 40 },
            },
            didDrawPage: data => {
              this.AddHeader(doc, order)

              var str = doc.internal.getNumberOfPages()
              if (typeof doc.putTotalPages === 'function') {
                str = str + '/' + totalPagesExp
              }
              doc.setFontSize(10)

              var pageSize = doc.internal.pageSize
              var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
              doc.text(str, data.settings.margin.left, pageHeight - 10)
            },
            body: bodyClaim,
          })
        }
      } else if (order.claims) {
        let claim = order.claims.undefined
        if (claim && claim.primaryCode) {
          bodyClaim.push([
            this.fieldColor(
              claim.primaryCode,
              3,
              2,
              claim.inadequate ? '#ff3860' : claim.status == 'confirmed' ? '#008a6b' : '#000000'
            ),
            this.fieldLabel('creation_date', 2),
            this.field(new Date(claim.creationDate).toLocaleDateString(), 2),
            this.fieldLabel('reception_date', 2),
            this.field(claim.answercreationDate ? new Date(claim.answercreationDate).toLocaleDateString() : '', 2),
          ])
          bodyClaim.push([
            this.fieldLabel('tec', 2),
            this.field(claim.tec, 2),
            this.fieldLabel('user', 2),
            this.field(claim.answertec, 2),
          ])

          if (claim.generalInfo) {
            bodyClaim.push([
              this.fieldLabel(this.$translate('generalInfotext'), 3, 2),
              this.field(claim.generalInfotext, 8),
            ])
            bodyClaim.push([this.field(claim.generalInfoanswer ? claim.generalInfoanswer : '', 8)])
          }

          if (claim.orderTypetext) {
            bodyClaim.push([
              this.fieldLabel(this.$translate('orderTypetext'), 3, 2),
              this.field(claim.orderTypetext, 8),
            ])
            bodyClaim.push([this.field(claim.orderTypeanswer ? claim.orderTypeanswer : '', 8)])
          }
          if (claim.model) {
            bodyClaim.push([this.fieldLabel(this.$translate('modeltext'), 3, 2), this.field(claim.modeltext, 8)])
            bodyClaim.push([this.field(claim.modelanswer ? claim.modelanswer : '', 8)])
          }
          if (claim.footmeasurements) {
            bodyClaim.push([
              this.fieldLabel(this.$translate('footmeasurementstext'), 3, 2),
              this.field(claim.footmeasurementstext, 8),
            ])
            bodyClaim.push([this.field(claim.footmeasurementsanswer ? claim.footmeasurementsanswer : '', 8)])
          }

          if (claim.prod_details) {
            bodyClaim.push([
              this.fieldLabel(this.$translate('prod_detailstext'), 3, 2),
              this.field(claim.prod_detailstext, 8),
            ])
            bodyClaim.push([this.field(claim.prod_detailsanswer ? claim.prod_detailsanswer : '', 8)])
          }
        }
        if (bodyClaim.length != 0) {
          doc.addPage()

          autoTable(doc, {
            theme: 'grid',
            margin: { top: 100 },
            styles: { fillColor: [255, 255, 255] },
            bodyStyles: { cellPadding: 3 },
            rowPageBreak: 'avoid',

            columnStyles: {
              0: { cellWidth: 40 },
              1: { cellWidth: 40 },
              2: { cellWidth: 40 },
              3: { cellWidth: 40 },
              4: { cellWidth: 40 },
              5: { cellWidth: 40 },
              6: { cellWidth: 40 },
              7: { cellWidth: 40 },
              8: { cellWidth: 40 },
              9: { cellWidth: 40 },
              10: { cellWidth: 40 },
              11: { cellWidth: 40 },
            },
            didDrawPage: data => {
              this.AddHeader(doc, order)

              var str = doc.internal.getNumberOfPages()
              if (typeof doc.putTotalPages === 'function') {
                str = str + '/' + totalPagesExp
              }
              doc.setFontSize(10)

              var pageSize = doc.internal.pageSize
              var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
              doc.text(str, data.settings.margin.left, pageHeight - 10)
            },
            body: bodyClaim,
          })
        }
      }
    },
    printOrderModular(order, index, firstPage, doc, totalPagesExp) {
      this.setOrderAddress(order)
      this.falseCheck = []
      this.trueCheck = []
      this.predispoCheck = []
      let provisional = false
      let printDate = ''
      if (order.history) {
        const sendordEntry = order.history.find(el => el.newStatus === 'sendord')
        if (sendordEntry) {
          printDate = new Date(sendordEntry.date).toLocaleDateString()
        }
      }

      if (order.statusOrder == 'compord' || order.statusOrder == 'invord' || order.statusOrder == 'sendord') {
        provisional = true
      }
      if (firstPage) {
        firstPage = false
      } else {
        doc.addPage()
      }

      doc.rect(350, 10, 204, 71)
      doc.addImage(this.getLogo(), 50, 10, 285, 71)
      if (provisional) {
        doc.text(398, 50, this.$translate('provisional'))
      } else {
        if (order.id_mercury) {
          doc.text(398, 50, order.id_mercury)
        }
      }

      const addonTable = [
        [...this.titleRowSplit('SX', 'shape_edit', 'DX')],
        [
          this.field(
            order.footmeasurements && order.footmeasurements.left && order.footmeasurements.left.add_fingers
              ? order.footmeasurements.left.add_fingers
              : this.$translate('Noone'),
            4
          ),
          this.fieldLabel('add_fingers', 4),
          this.field(
            order.footmeasurements && order.footmeasurements.right && order.footmeasurements.right.add_fingers
              ? order.footmeasurements.right.add_fingers
              : this.$translate('Noone'),
            4
          ),
        ],
        [
          this.field(
            order.footmeasurements && order.footmeasurements.left && order.footmeasurements.left.add_firstMeta
              ? order.footmeasurements.left.add_firstMeta
              : this.$translate('Noone'),
            4
          ),
          this.fieldLabel('add_firstMeta', 4),
          this.field(
            order.footmeasurements && order.footmeasurements.right && order.footmeasurements.right.add_firstMeta
              ? order.footmeasurements.right.add_firstMeta
              : this.$translate('Noone'),
            4
          ),
        ],
        [
          this.field(
            order.footmeasurements && order.footmeasurements.left && order.footmeasurements.left.add_fifthMeta
              ? order.footmeasurements.left.add_fifthMeta
              : this.$translate('Noone'),
            4
          ),
          this.fieldLabel('add_fifthMeta', 4),
          this.field(
            order.footmeasurements && order.footmeasurements.right && order.footmeasurements.right.add_fifthMeta
              ? order.footmeasurements.right.add_fifthMeta
              : this.$translate('Noone'),
            4
          ),
        ],
        [
          this.field(
            order.footmeasurements && order.footmeasurements.left && order.footmeasurements.left.add_instep
              ? order.footmeasurements.left.add_instep
              : this.$translate('Noone'),
            4
          ),
          this.fieldLabel('instep_italy', 4),
          this.field(
            order.footmeasurements && order.footmeasurements.right && order.footmeasurements.right.add_instep
              ? order.footmeasurements.right.add_instep
              : this.$translate('Noone'),
            4
          ),
        ],
        [
          this.field(
            order.footmeasurements && order.footmeasurements.left && order.footmeasurements.left.add_extraTotal
              ? order.footmeasurements.left.add_extraTotal
              : this.$translate('Noone'),
            4
          ),
          this.fieldLabel('add_extraTotal', 4),
          this.field(
            order.footmeasurements && order.footmeasurements.right && order.footmeasurements.right.add_extraTotal
              ? order.footmeasurements.right.add_extraTotal
              : this.$translate('Noone'),
            4
          ),
        ],
      ]

      const body = [
        [this.titleRow('order_modular')],
        [
          this.fieldLabel('orderType', 2),
          this.field(this.$options.filters.capitalize(this.$translate(order.orderType)), 4),
          this.fieldLabel('date', 2),
          this.field(printDate, 4),
        ],
        [
          this.fieldLabel('orderTypeMain', 2),
          this.field(this.$options.filters.capitalize(this.$translate(order.orderType)), 4),
          this.fieldLabel('deliverySelected', 2),
          this.field(
            this.$options.filters.capitalize(this.$translate(order.deliverySelected)) +
              (order.deliverySelectedSub
                ? '\n' + this.$options.filters.capitalize(this.$translate(order.deliverySelectedSub))
                : ''),

            4
          ),
        ],
        [this.hrForTableNoWidth()],
        [this.titleRow('generalInfo')],
        [
          this.fieldLabel('primaryCode', 2),
          this.field(order.primaryCode, 4),
          this.fieldLabel('cod', 2),
          this.field(order.company.mercurio_id ? order.company.mercurio_id : '', 4),
        ],
        [
          this.fieldLabel('customer', 2),
          this.field(order.company.name, 4),
          this.fieldLabel('shop', 2),
          this.field(order.shop.name, 4),
        ],
        [
          this.fieldLabel('delivery_address', 2),
          this.field(
            this.deliveryAddress.street +
              ' ' +
              this.deliveryAddress.city +
              ' ' +
              this.deliveryAddress.postalCode +
              ' ' +
              this.$translate(this.deliveryAddress.country),
            6
          ),
          this.fieldLabel('tec', 1),
          this.field(order.tec ? order.tec : '', 3),
        ],
      ]
      const shapeHeader = [
        [this.titleRow('forma')],
        [this.fieldLabel('forma', 6), this.field(order.mod && order.mod.sole ? this.getShapeName(order) : '', 6)],
        [
          this.fieldLabel('size_sx', 3),
          this.fieldLabel('fit_sx', 3),
          this.fieldLabel('fit_dx', 3),
          this.fieldLabel('size_dx', 3),
        ],
        [
          this.field(order.footmeasurements && order.footmeasurements.left ? order.footmeasurements.left.size : '', 3),
          this.field(
            order.footmeasurements && order.footmeasurements.left ? order.footmeasurements.left.fit_code : '',
            3
          ),
          this.field(
            order.footmeasurements && order.footmeasurements.right ? order.footmeasurements.right.size : '',
            3
          ),
          this.field(
            order.footmeasurements && order.footmeasurements.right ? order.footmeasurements.right.fit_code : '',
            3
          ),
        ],
      ]
      body.push(
        [this.hrForTableNoWidth()],
        // patient title
        [this.titleRow('patient')],
        // patient basic info row
        [
          this.fieldLabel('patient', 2),
          this.field(order.patient.name + ' ' + order.patient.surname, 4),
          this.fieldLabel('alias', 2),
          this.field(order.patient.alias, 4),
        ],
        [
          this.fieldLabel('digital_archive', 2),
          this.field(order.hasDigitalArchive ? this.$translate('yes') : this.$translate('no'), 4),
          this.fieldLabel('authorization', 2),
          this.field(order.ASLprotocol != null ? order.ASLprotocol : '', 4),
        ]
      )
      body.push(
        [this.hrForTableNoWidth()],

        // attach title
        [this.titleRow('attach')],

        // attach left/right header
        [
          this.field(this.$options.filters.capitalize(this.$translate('left')), 6),
          this.field(this.$options.filters.capitalize(this.$translate('right')), 6),
        ],
        // attach rows (scan_fms)
        [
          this.fieldLabel(order.attachment && order.attachment.scan_fms_sx ? 'V' : 'X', 1),
          this.fieldLabel('mesu', 2),
          this.field(
            order.attachment && order.attachment.scan_fms_sx
              ? order.id_mercury
                ? order.id_mercury + '_scan_fms_sx'
                : order.id + '_scan_fms_sx'
              : '',
            3
          ),
          this.fieldLabel(order.attachment && order.attachment.scan_fms_dx ? 'V' : 'X', 1),
          this.fieldLabel('mesu', 2),
          this.field(
            order.attachment && order.attachment.scan_fms_dx
              ? order.id_mercury
                ? order.id_mercury + '_scan_fms_dx'
                : order.id + '_scan_fms_dx'
              : '',
            3
          ),
        ],
        // grap rows
        [
          this.fieldLabel(order.attachment && order.attachment.grap_sx ? 'V' : 'X', 1),
          this.fieldLabel('blueprint', 2),
          this.field(
            order.attachment && order.attachment.grap_sx
              ? order.id_mercury
                ? order.id_mercury + '_grap_sx'
                : order.id + '_grap_sx'
              : '',
            3
          ),
          this.fieldLabel(order.attachment && order.attachment.grap_dx ? 'V' : 'X', 1),
          this.fieldLabel('blueprint', 2),
          this.field(
            order.attachment && order.attachment.grap_dx
              ? order.id_mercury
                ? order.id_mercury + '_grap_dx'
                : order.id + '_grap_dx'
              : '',
            3
          ),
        ],

        // attach rows (attach_sx / attach_dx)
        [
          this.fieldLabel(order.attachment && order.attachment.attach_sx ? 'V' : 'X', 1),
          this.fieldLabel('additional', 2),
          this.field(
            order.attachment && order.attachment.attach_sx
              ? order.id_mercury
                ? order.id_mercury + '_attach_sx'
                : order.id + '_attach_sx'
              : '',
            3
          ),
          this.fieldLabel(order.attachment && order.attachment.attach_dx ? 'V' : 'X', 1),
          this.fieldLabel('additional', 2),
          this.field(
            order.attachment && order.attachment.attach_dx
              ? order.id_mercury
                ? order.id_mercury + '_attach_dx'
                : order.id + '_attach_dx'
              : '',
            3
          ),
        ],

        [this.hrForTableNoWidth()],

        // shoe title
        [this.titleRow('shoe')],

        // shoe info rows
        [
          this.field('', 6, 6),
          this.fieldLabel('shoeType', 3),
          this.field(
            order.mod && order.mod.shoeType
              ? this.$options.filters.capitalize(this.$translate(order.mod.shoeType))
              : '',
            3
          ),
        ],
        [
          this.fieldLabel('catalogType', 3),
          this.field(
            order.mod && order.mod.catalogType
              ? this.$options.filters.capitalize(this.$translate(order.mod.catalogType))
              : '',
            3
          ),
        ],
        [this.fieldLabel('model', 3), this.field(this.getModel(order), 3)],
        [
          this.fieldLabel('secondary_prevention', 3),
          this.field(order.mod && order.mod.hasSecondaryPrev ? this.$translate('yes') : this.$translate('no'), 3),
        ],
        [
          this.fieldLabel('note', 2),
          this.field(
            order.module === 'modular'
              ? order.note || ''
              : order.footmeasurements && order.footmeasurements.notes
              ? order.footmeasurements.notes
              : '',
            4,
            2
          ),
        ],

        // final spacer
        [this.field('', 2)]
      )
      body.push([this.hrForTableNoWidth()])
      body.push(...shapeHeader)
      body.push([this.hrForTableNoWidth()])
      body.push(...addonTable)

      autoTable(doc, {
        theme: 'grid',
        margin: { top: 100 },
        styles: { fillColor: [255, 255, 255] },
        bodyStyles: { cellPadding: 3 },
        rowPageBreak: 'avoid',
        columnStyles: {
          0: { cellWidth: 40 },
          1: { cellWidth: 40 },
          2: { cellWidth: 40 },
          3: { cellWidth: 40 },
          4: { cellWidth: 40 },
          5: { cellWidth: 40 },
          6: { cellWidth: 40 },
          7: { cellWidth: 40 },
          8: { cellWidth: 40 },
          9: { cellWidth: 40 },
          10: { cellWidth: 40 },
          11: { cellWidth: 40 },
        },
        didDrawPage: data => {
          if (data.pageNumber != 1) {
            this.AddHeader(doc, order)
          }
          var str = doc.internal.getNumberOfPages()
          if (typeof doc.putTotalPages === 'function') {
            str = str + '/' + totalPagesExp
          }
          doc.setFontSize(10)
          var pageSize = doc.internal.pageSize
          var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
          doc.text(str, data.settings.margin.left, pageHeight - 10)
        },
        willDrawCell: data => {
          let Cell = data.column.index + ':' + data.row.index
          if (data.cell && data.cell.text && data.cell.text[0] == 'X') {
            data.cell.text = []
            this.falseCheck.push(Cell)
          }
          if (data.cell && data.cell.text && data.cell.text[0] == 'V') {
            data.cell.text = []
            this.trueCheck.push(Cell)
          }
        },
        didDrawCell: data => {
          var dim = 0
          var textPos = {}
          let Cell = data.column.index + ':' + data.row.index
          if (this.falseCheck.includes(Cell)) {
            dim = data.cell.height - data.cell.padding('vertical')
            textPos = data.cell
            this.falseCheck.splice(this.falseCheck.indexOf(Cell), 1)
            doc.addImage(
              this.getCheckFalse(),
              textPos.x + data.cell.width / 2 - dim / 2,
              textPos.y + data.cell.height / 2 - dim / 2,
              10,
              10
            )
          }
          if (this.trueCheck.includes(Cell)) {
            dim = data.cell.height - data.cell.padding('vertical')
            textPos = data.cell
            this.trueCheck.splice(this.trueCheck.indexOf(Cell), 1)
            doc.addImage(
              this.getCheckTrue(),
              textPos.x + data.cell.width / 2 - dim / 2,
              textPos.y + data.cell.height / 2 - dim / 2,
              10,
              10
            )
          }
          if (data.column.index === 0 && data.row.index === 20 && data.cell.section === 'body') {
            if (this.arrayImageModel[this.modelCounter] !== false) {
              dim = data.cell.height - data.cell.padding('vertical')
              textPos = data.cell
              doc.addImage(
                this.arrayImageModel[this.modelCounter],
                textPos.x +
                  data.cell.width / 2 -
                  (this.arrayImageModel[this.modelCounter].width *
                    (dim / this.arrayImageModel[this.modelCounter].height)) /
                    2,
                textPos.y + data.cell.height / 2 - dim / 2,
                this.arrayImageModel[this.modelCounter].width * (dim / this.arrayImageModel[this.modelCounter].height),
                dim
              )
            }
            this.modelCounter++
          }
        },
        body,
      })

      doc.addPage()
      autoTable(doc, {
        theme: 'grid',
        margin: { top: 100 },
        styles: { fillColor: [255, 255, 255] },
        bodyStyles: { cellPadding: 3 },
        rowPageBreak: 'avoid',

        columnStyles: {
          0: { cellWidth: 40 },
          1: { cellWidth: 40 },
          2: { cellWidth: 40 },
          3: { cellWidth: 40 },
          4: { cellWidth: 40 },
          5: { cellWidth: 40 },
          6: { cellWidth: 40 },
          7: { cellWidth: 40 },
          8: { cellWidth: 40 },
          9: { cellWidth: 40 },
          10: { cellWidth: 40 },
          11: { cellWidth: 40 },
        },
        didDrawPage: data => {
          this.AddHeader(doc, order)

          var str = doc.internal.getNumberOfPages()
          if (typeof doc.putTotalPages === 'function') {
            str = str + '/' + totalPagesExp
          }
          doc.setFontSize(10)

          var pageSize = doc.internal.pageSize
          var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
          doc.text(str, data.settings.margin.left, pageHeight - 10)
        },
        didParseCell: data => {
          if (
            data.column.index === 0 &&
            data.row.index === 17 + 21 + this.arrayrowCounterAllacciatura[this.allacciaCounter] &&
            data.cell.section === 'body'
          ) {
            if (this.arrayrowCounterAllacciatura[this.allacciaCounter] === 8) {
              data.cell.styles.minCellHeight = 30
            }
          }
        },
        willDrawCell: data => {
          let Cell = data.column.index + ':' + data.row.index

          if (data.cell && data.cell.text && data.cell.text[0] == 'X') {
            data.cell.text = []
            this.falseCheck.push(Cell)
          }
          if (data.cell && data.cell.text && data.cell.text[0] == 'V') {
            data.cell.text = []
            this.trueCheck.push(Cell)
          }
        },
        didDrawCell: data => {
          var dim = 0
          var textPos = {}
          let Cell = data.column.index + ':' + data.row.index

          if (this.falseCheck.includes(Cell)) {
            dim = data.cell.height - data.cell.padding('vertical')
            textPos = data.cell
            this.falseCheck.splice(this.falseCheck.indexOf(Cell), 1)
            doc.addImage(
              this.getCheckFalse(),
              textPos.x + data.cell.width / 2 - dim / 2,
              textPos.y + data.cell.height / 2 - dim / 2,
              10,
              10
            )
          }
          if (this.trueCheck.includes(Cell)) {
            dim = data.cell.height - data.cell.padding('vertical')
            textPos = data.cell
            this.trueCheck.splice(this.trueCheck.indexOf(Cell), 1)
            doc.addImage(
              this.getCheckTrue(),
              textPos.x + data.cell.width / 2 - dim / 2,
              textPos.y + data.cell.height / 2 - dim / 2,
              10,
              10
            )
          }
        },

        body: [[this.titleRow('model_details')]]
          .concat(this.pellAndFoderaTable(order))
          .concat(this.allacciaturaTableFitsModular(order))
          .concat([
            [this.fieldLabel(['fondo'], 12, 1, true)],
            [this.fieldLabel(['sole'], 4), this.field(order.mod && order.mod.sole ? order.mod.sole.CUI : undefined, 8)],
            [
              this.fieldLabel(['foggia'], 4),
              this.field(
                order.mod && order.mod.sole && order.mod.sole.foggia
                  ? order.mod.sole.foggia.CUI + ' ' + order.mod.sole.foggia.commercial_name
                  : undefined,
                8
              ),
            ],
            [
              this.fieldLabel(['tread'], 4),
              this.field(
                order.mod && order.mod.sole && order.mod.sole.tread
                  ? order.mod.sole.tread.CUI + ' ' + order.mod.sole.tread.commercial_name
                  : undefined,
                8
              ),
            ],
            [
              this.fieldLabel(['color'], 4),
              this.field(
                order.mod && order.mod.sole && order.mod.sole.color
                  ? order.mod.sole.color.CUI + ' ' + order.mod.sole.color.commercial_name
                  : undefined,
                8
              ),
            ],
          ])
          .concat(this.contraffortiTable(order))
          .concat(this.sottopiedeTable(order))
          .concat([
            [
              this.fieldLabel('SX', 4, 1, true),
              this.fieldLabel('ext_rise', 4, 1, true),
              this.fieldLabel('DX', 4, 1, true),
            ],
            [
              this.field(
                order.prod_details &&
                  order.prod_details.left &&
                  order.prod_details.left.extRise &&
                  order.prod_details.left.extRise.heel_rise
                  ? order.prod_details.left.extRise.heel_rise
                  : '',
                4
              ),
              this.fieldLabel('heel_rise', 4),
              this.field(
                order.prod_details &&
                  order.prod_details.right &&
                  order.prod_details.right.extRise &&
                  order.prod_details.right.extRise.heel_rise
                  ? order.prod_details.right.extRise.heel_rise
                  : '',
                4
              ),
            ],
            [
              this.field(
                order.prod_details &&
                  order.prod_details.left &&
                  order.prod_details.left.extRise &&
                  order.prod_details.left.extRise.ball_rise
                  ? order.prod_details.left.extRise.ball_rise
                  : '',
                4
              ),
              this.fieldLabel('ball_rise', 4),
              this.field(
                order.prod_details &&
                  order.prod_details.right &&
                  order.prod_details.right.extRise &&
                  order.prod_details.right.extRise.ball_rise
                  ? order.prod_details.right.extRise.ball_rise
                  : '',
                4
              ),
            ],
            [
              this.field(
                order.prod_details &&
                  order.prod_details.left &&
                  order.prod_details.left.extRise &&
                  order.prod_details.left.extRise.fings_rise
                  ? order.prod_details.left.extRise.fings_rise
                  : '',
                4
              ),
              this.fieldLabel('fings_rise', 4),
              this.field(
                order.prod_details &&
                  order.prod_details.right &&
                  order.prod_details.right.extRise &&
                  order.prod_details.right.extRise.fings_rise
                  ? order.prod_details.right.extRise.fings_rise
                  : '',
                4
              ),
            ],
            [
              this.fieldLabel('SX', 4, 1, true),
              this.fieldLabel('camber', 4, 1, true),
              this.fieldLabel('DX', 4, 1, true),
            ],
            [
              this.field(
                order.prod_details &&
                  order.prod_details.left &&
                  order.prod_details.left.camber &&
                  order.prod_details.left.camber.medial
                  ? order.prod_details.left.camber.medial
                  : '',
                4
              ),
              this.fieldLabel('medial_camber', 4),
              this.field(
                order.prod_details &&
                  order.prod_details.right &&
                  order.prod_details.right.camber &&
                  order.prod_details.right.camber.medial
                  ? order.prod_details.right.camber.medial
                  : '',
                4
              ),
            ],
            [
              this.field(
                order.prod_details &&
                  order.prod_details.left &&
                  order.prod_details.left.camber &&
                  order.prod_details.left.camber.side
                  ? order.prod_details.left.camber.side
                  : '',
                4
              ),
              this.fieldLabel('side_camber', 4),
              this.field(
                order.prod_details &&
                  order.prod_details.right &&
                  order.prod_details.right.camber &&
                  order.prod_details.right.camber.side
                  ? order.prod_details.right.camber.side
                  : '',
                4
              ),
            ],
            [
              this.fieldLabel('SX', 4, 1, true),
              this.fieldLabel('speronatura', 4, 1, true),
              this.fieldLabel('DX', 4, 1, true),
            ],
            [
              this.field(
                order.prod_details &&
                  order.prod_details.left &&
                  order.prod_details.left.speronatura &&
                  order.prod_details.left.speronatura.medial_heel
                  ? order.prod_details.left.speronatura.medial_heel
                  : '',
                4
              ),
              this.fieldLabel('spe_medial_heel', 4),
              this.field(
                order.prod_details &&
                  order.prod_details.right &&
                  order.prod_details.right.speronatura &&
                  order.prod_details.right.speronatura.medial_heel
                  ? order.prod_details.right.speronatura.medial_heel
                  : '',
                4
              ),
            ],
            [
              this.field(
                order.prod_details &&
                  order.prod_details.left &&
                  order.prod_details.left.speronatura &&
                  order.prod_details.left.speronatura.side_heel
                  ? order.prod_details.left.speronatura.side_heel
                  : '',
                4
              ),
              this.fieldLabel('spe_side_heel', 4),
              this.field(
                order.prod_details &&
                  order.prod_details.right &&
                  order.prod_details.right.speronatura &&
                  order.prod_details.right.speronatura.side_heel
                  ? order.prod_details.right.speronatura.side_heel
                  : '',
                4
              ),
            ],
            [
              this.field(
                order.prod_details &&
                  order.prod_details.left &&
                  order.prod_details.left.speronatura &&
                  order.prod_details.left.speronatura.medial_plant
                  ? order.prod_details.left.speronatura.medial_plant
                  : '',
                4
              ),
              this.fieldLabel('spe_medial_plant', 4),
              this.field(
                order.prod_details &&
                  order.prod_details.right &&
                  order.prod_details.right.speronatura &&
                  order.prod_details.right.speronatura.medial_plant
                  ? order.prod_details.right.speronatura.medial_plant
                  : '',
                4
              ),
            ],
            [
              this.field(
                order.prod_details &&
                  order.prod_details.left &&
                  order.prod_details.left.speronatura &&
                  order.prod_details.left.speronatura.side_plant
                  ? order.prod_details.left.speronatura.side_plant
                  : '',
                4
              ),
              this.fieldLabel('spe_side_plant', 4),
              this.field(
                order.prod_details &&
                  order.prod_details.right &&
                  order.prod_details.right.speronatura &&
                  order.prod_details.right.speronatura.side_plant
                  ? order.prod_details.right.speronatura.side_plant
                  : '',
                4
              ),
            ],
          ])
          .concat(this.hrForTableNoWidth())
          .concat(this.measurementsTable(order)),
      })

      // HOTFIX: the add of page on even pages is out of the method with a specific handler in the foreach loop of print
      // if (doc.getNumberOfPages() % 2 !== 0) doc.addPage()
      //console.log(doc.getNumberOfPages())
      // if (doc.getNumberOfPages() % 2 !== 0) {
      //   doc.addPage()
      // }

      let bodyClaim = []
      //console.log(order.claims)
      //console.log(order.claims.length)
      if (order.claims && order.claims.length !== undefined) {
        order.claims.forEach(claim => {
          if (claim.primaryCode) {
            bodyClaim.push([
              this.fieldColor(
                claim.primaryCode,
                3,
                2,
                claim.inadequate ? '#ff3860' : claim.status === 'confirmed' ? '#008a6b' : '#000000'
              ),
              this.fieldLabel('creation_date', 2),
              this.field(new Date(claim.creationDate).toLocaleDateString(), 2),
              this.fieldLabel('reception_date', 2),
              this.field(claim.answercreationDate ? new Date(claim.answercreationDate).toLocaleDateString() : '', 2),
            ])
            bodyClaim.push([
              this.fieldLabel('tec', 2),
              this.field(claim.tec, 2),
              this.fieldLabel('user', 2),
              this.field(claim.answertec, 2),
            ])

            if (claim.generalInfo) {
              bodyClaim.push([
                this.fieldLabel(this.$translate('generalInfotext'), 3, 2),
                this.field(claim.generalInfotext, 8),
              ])
              bodyClaim.push([this.field(claim.generalInfoanswer ? claim.generalInfoanswer : '', 8)])
            }

            if (claim.orderTypetext) {
              bodyClaim.push([
                this.fieldLabel(this.$translate('orderTypetext'), 3, 2),
                this.field(claim.orderTypetext, 8),
              ])
              bodyClaim.push([this.field(claim.orderTypeanswer ? claim.orderTypeanswer : '', 8)])
            }
            if (claim.model) {
              bodyClaim.push([this.fieldLabel(this.$translate('modeltext'), 3, 2), this.field(claim.modeltext, 8)])
              bodyClaim.push([this.field(claim.modelanswer ? claim.modelanswer : '', 8)])
            }
            if (claim.footmeasurements) {
              bodyClaim.push([
                this.fieldLabel(this.$translate('footmeasurementstext'), 3, 2),
                this.field(claim.footmeasurementstext, 8),
              ])
              bodyClaim.push([this.field(claim.footmeasurementsanswer ? claim.footmeasurementsanswer : '', 8)])
            }

            if (claim.prod_details) {
              bodyClaim.push([
                this.fieldLabel(this.$translate('prod_detailstext'), 3, 2),
                this.field(claim.prod_detailstext, 8),
              ])
              bodyClaim.push([this.field(claim.prod_detailsanswer ? claim.prod_detailsanswer : '', 8)])
            }
          }
        })
        if (bodyClaim.length != 0) {
          doc.addPage()

          autoTable(doc, {
            theme: 'grid',
            margin: { top: 100 },
            styles: { fillColor: [255, 255, 255] },
            bodyStyles: { cellPadding: 3 },
            rowPageBreak: 'avoid',

            columnStyles: {
              0: { cellWidth: 40 },
              1: { cellWidth: 40 },
              2: { cellWidth: 40 },
              3: { cellWidth: 40 },
              4: { cellWidth: 40 },
              5: { cellWidth: 40 },
              6: { cellWidth: 40 },
              7: { cellWidth: 40 },
              8: { cellWidth: 40 },
              9: { cellWidth: 40 },
              10: { cellWidth: 40 },
              11: { cellWidth: 40 },
            },
            didDrawPage: data => {
              this.AddHeader(doc, order)

              var str = doc.internal.getNumberOfPages()
              if (typeof doc.putTotalPages === 'function') {
                str = str + '/' + totalPagesExp
              }
              doc.setFontSize(10)

              var pageSize = doc.internal.pageSize
              var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
              doc.text(str, data.settings.margin.left, pageHeight - 10)
            },
            body: bodyClaim,
          })
        }
      } else if (order.claims) {
        let claim = order.claims.undefined
        if (claim && claim.primaryCode) {
          bodyClaim.push([
            this.fieldColor(
              claim.primaryCode,
              3,
              2,
              claim.inadequate ? '#ff3860' : claim.status == 'confirmed' ? '#008a6b' : '#000000'
            ),
            this.fieldLabel('creation_date', 2),
            this.field(new Date(claim.creationDate).toLocaleDateString(), 2),
            this.fieldLabel('reception_date', 2),
            this.field(claim.answercreationDate ? new Date(claim.answercreationDate).toLocaleDateString() : '', 2),
          ])
          bodyClaim.push([
            this.fieldLabel('tec', 2),
            this.field(claim.tec, 2),
            this.fieldLabel('user', 2),
            this.field(claim.answertec, 2),
          ])

          if (claim.generalInfo) {
            bodyClaim.push([
              this.fieldLabel(this.$translate('generalInfotext'), 3, 2),
              this.field(claim.generalInfotext, 8),
            ])
            bodyClaim.push([this.field(claim.generalInfoanswer ? claim.generalInfoanswer : '', 8)])
          }

          if (claim.orderTypetext) {
            bodyClaim.push([
              this.fieldLabel(this.$translate('orderTypetext'), 3, 2),
              this.field(claim.orderTypetext, 8),
            ])
            bodyClaim.push([this.field(claim.orderTypeanswer ? claim.orderTypeanswer : '', 8)])
          }
          if (claim.model) {
            bodyClaim.push([this.fieldLabel(this.$translate('modeltext'), 3, 2), this.field(claim.modeltext, 8)])
            bodyClaim.push([this.field(claim.modelanswer ? claim.modelanswer : '', 8)])
          }
          if (claim.footmeasurements) {
            bodyClaim.push([
              this.fieldLabel(this.$translate('footmeasurementstext'), 3, 2),
              this.field(claim.footmeasurementstext, 8),
            ])
            bodyClaim.push([this.field(claim.footmeasurementsanswer ? claim.footmeasurementsanswer : '', 8)])
          }

          if (claim.prod_details) {
            bodyClaim.push([
              this.fieldLabel(this.$translate('prod_detailstext'), 3, 2),
              this.field(claim.prod_detailstext, 8),
            ])
            bodyClaim.push([this.field(claim.prod_detailsanswer ? claim.prod_detailsanswer : '', 8)])
          }
        }
        if (bodyClaim.length != 0) {
          doc.addPage()

          autoTable(doc, {
            theme: 'grid',
            margin: { top: 100 },
            styles: { fillColor: [255, 255, 255] },
            bodyStyles: { cellPadding: 3 },
            rowPageBreak: 'avoid',

            columnStyles: {
              0: { cellWidth: 40 },
              1: { cellWidth: 40 },
              2: { cellWidth: 40 },
              3: { cellWidth: 40 },
              4: { cellWidth: 40 },
              5: { cellWidth: 40 },
              6: { cellWidth: 40 },
              7: { cellWidth: 40 },
              8: { cellWidth: 40 },
              9: { cellWidth: 40 },
              10: { cellWidth: 40 },
              11: { cellWidth: 40 },
            },
            didDrawPage: data => {
              this.AddHeader(doc, order)

              var str = doc.internal.getNumberOfPages()
              if (typeof doc.putTotalPages === 'function') {
                str = str + '/' + totalPagesExp
              }
              doc.setFontSize(10)

              var pageSize = doc.internal.pageSize
              var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
              doc.text(str, data.settings.margin.left, pageHeight - 10)
            },
            body: bodyClaim,
          })
        }
      }
    },
    printOrderInsole(order, index, firstPage, doc, totalPagesExp) {
      this.setOrderAddress(order)
      this.falseCheck = []
      this.trueCheck = []
      let provisional = false
      let printDate = ''
      if (order.history) {
        const sendordEntry = order.history.find(el => el.newStatus === 'sendord')
        if (sendordEntry) {
          printDate = new Date(sendordEntry.date).toLocaleDateString()
        }
      }

      if (order.statusOrder == 'compord' || order.statusOrder == 'invord' || order.statusOrder == 'sendord') {
        provisional = true
      }
      if (firstPage) {
        firstPage = false
      } else {
        doc.addPage()
      }

      doc.rect(350, 10, 204, 71)
      doc.addImage(this.getLogo(), 50, 10, 285, 71)
      if (provisional) {
        doc.text(398, 50, this.$translate('provisional'))
      } else {
        if (order.id_mercury) {
          doc.text(398, 50, order.id_mercury)
        }
      }

      const fm = order.footmeasurements ? order.footmeasurements : {}
      const sxEnabled = order.pair !== 'right'
      const dxEnabled = order.pair !== 'left'
      const sideValue = key => {
        const sx = fm[`${key}_sx`] != null && fm[`${key}_sx`] !== '' ? fm[`${key}_sx`] + ' mm' : '-'
        const dx = fm[`${key}_dx`] != null && fm[`${key}_dx`] !== '' ? fm[`${key}_dx`] + ' mm' : '-'
        return sx + ' / ' + dx
      }
      const attachmentFileName = key =>
        order.attachment && order.attachment[key] ? (order.id_mercury ? order.id_mercury : order.id) + '_' + key : ''
      const attachmentRow = (labelKey, attachmentKey) => [
        this.fieldLabel(order.attachment && order.attachment[`${attachmentKey}_sx`] ? 'V' : 'X', 1),
        this.fieldLabel(labelKey, 2),
        this.field(attachmentFileName(`${attachmentKey}_sx`), 3),
        this.fieldLabel(order.attachment && order.attachment[`${attachmentKey}_dx`] ? 'V' : 'X', 1),
        this.fieldLabel(labelKey, 2),
        this.field(attachmentFileName(`${attachmentKey}_dx`), 3),
      ]
      const modSx = order.mod_sx && Object.keys(order.mod_sx).length !== 0 ? order.mod_sx : order.mod ? order.mod : null
      const modDx = order.mod_dx && Object.keys(order.mod_dx).length !== 0 ? order.mod_dx : order.mod ? order.mod : null
      const modMaterials = modSx && modSx.insoleBaseMat != null ? modSx : modDx
      const modelNameFor = mod => (mod && mod.name ? this.$options.filters.capitalize(mod.name) : '')
      const dimeTextFor = mod =>
        mod && mod.dime
          ? this.$options.filters.capitalize(this.$translate(mod.dime)) +
            (mod.dime === 'dunadime' && mod.dime_description ? ' - ' + mod.dime_description : '')
          : ''
      const fondoTextFor = mod =>
        mod && mod.dime_fondo ? this.$options.filters.capitalize(this.$translate(mod.dime_fondo)) : ''
      const cambraturaTextFor = mod =>
        mod && mod.cambratura_fondo != null && mod.cambratura_fondo !== '' ? mod.cambratura_fondo : ''
      const insoleRow = (labelKey, sxValue, dxValue) => [
        this.fieldLabel(labelKey, 4),
        this.field(sxEnabled ? sxValue : '', 4),
        this.field(dxEnabled ? dxValue : '', 4),
      ]

      const body = [
        [this.titleRow('order_insole')],
        [
          this.fieldLabel('orderType', 2),
          this.field(order.orderType ? this.$options.filters.capitalize(this.$translate(order.orderType)) : '', 4),
          this.fieldLabel('date', 2),
          this.field(printDate, 4),
        ],
        [
          this.fieldLabel('orderTypeMain', 2),
          this.field(
            order.orderTypeMain
              ? this.$options.filters.capitalize(this.$translate(order.orderTypeMain)) +
                  (order.orderTypeMainRifMat ? '\n' + this.$translate('rifMat') + ': ' + order.orderTypeMainRifMat : '')
              : '',
            4
          ),
          this.fieldLabel('deliverySelected', 2),
          this.field(
            order.deliverySelected
              ? this.$options.filters.capitalize(this.$translate(order.deliverySelected)) +
                  (order.deliverySelectedSub
                    ? '\n' + this.$options.filters.capitalize(this.$translate(order.deliverySelectedSub))
                    : '')
              : '',
            4
          ),
        ],
        [
          this.fieldLabel('pairSelected', 2),
          this.field(
            order.pair === 'left'
              ? this.$options.filters.capitalize(this.$translate('pairLeft'))
              : order.pair === 'right'
              ? this.$options.filters.capitalize(this.$translate('pairRight'))
              : this.$options.filters.capitalize(this.$translate('pairBoth')),
            10
          ),
        ],
        [this.hrForTableNoWidth()],
        [this.titleRow('generalInfo')],
        [
          this.fieldLabel('primaryCode', 2),
          this.field(order.primaryCode, 4),
          this.fieldLabel('cod', 2),
          this.field(order.company.mercurio_id ? order.company.mercurio_id : '', 4),
        ],
        [
          this.fieldLabel('customer', 2),
          this.field(order.company.name, 4),
          this.fieldLabel('shop', 2),
          this.field(order.shop.name, 4),
        ],
        [
          this.fieldLabel('delivery_address', 2),
          this.field(
            this.deliveryAddress.street +
              ' ' +
              this.deliveryAddress.city +
              ' ' +
              this.deliveryAddress.postalCode +
              ' ' +
              this.$translate(this.deliveryAddress.country),
            10
          ),
        ],
        [
          this.fieldLabel('prec_pair_print', 2),
          this.field(order.prec_pair ? order.prec_pair : '', 4),
          this.fieldLabel('prec_order_print', 2),
          this.field(order.prec_order ? order.prec_order : '', 4),
        ],
        [this.fieldLabel('technician', 2), this.field(order.tec ? order.tec : '', 10)],
        [this.hrForTableNoWidth()],
        [this.titleRow('patient')],
        [
          this.fieldLabel('patient', 2),
          this.field(order.patient.name + ' ' + order.patient.surname, 4),
          this.fieldLabel('alias', 2),
          this.field(order.patient.alias, 4),
        ],
        [this.fieldLabel('authorization', 2), this.field(order.ASLprotocol != null ? order.ASLprotocol : '', 10)],
        [
          this.fieldLabelMultipleString(['pathologies', 'SX'], 2, 1, ' '),
          this.field(
            order.pathologiesLeft && order.pathologiesLeft.length !== 0 ? order.pathologiesLeft.join(',') : '',
            4
          ),
          this.fieldLabelMultipleString(['pathologies', 'DX'], 2, 1, ' '),
          this.field(
            order.pathologiesRight && order.pathologiesRight.length !== 0 ? order.pathologiesRight.join(',') : '',
            4
          ),
        ],
        [this.hrForTableNoWidth()],
        [this.titleRow('attach')],
        [
          this.field(this.$options.filters.capitalize(this.$translate('left')), 6),
          this.field(this.$options.filters.capitalize(this.$translate('right')), 6),
        ],
        attachmentRow('duna', 'scan_fms'),
        attachmentRow('scan', 'scan_stl'),
        attachmentRow('grap', 'grap'),
        attachmentRow('attach', 'attach'),
        [this.hrForTableNoWidth()],
        [this.titleRow('measure_patient')],
        [
          this.fieldLabel('foot_long', 2),
          this.field(sideValue('length'), 4),
          this.fieldLabel('foot_width', 2),
          this.field(sideValue('width'), 4),
        ],
        [
          this.fieldLabel('foot_crimp', 2),
          this.field(sideValue('crimp'), 4),
          this.fieldLabel('pat_weight', 2),
          this.field(fm.pat_weight != null && fm.pat_weight !== '' ? fm.pat_weight : '', 4),
        ],
        [this.hrForTableNoWidth()],
        [this.titleRow('insoles')],
        [this.field('', 4), this.fieldLabel('Sx', 4, 1, true), this.fieldLabel('Dx', 4, 1, true)],
        insoleRow('model', modelNameFor(modSx), modelNameFor(modDx)),
        insoleRow('dime', dimeTextFor(modSx), dimeTextFor(modDx)),
        ...(fondoTextFor(modSx) || fondoTextFor(modDx)
          ? [insoleRow('fondo', fondoTextFor(modSx), fondoTextFor(modDx))]
          : []),
        ...(cambraturaTextFor(modSx) !== '' || cambraturaTextFor(modDx) !== ''
          ? [insoleRow('cambratura_fondo', cambraturaTextFor(modSx), cambraturaTextFor(modDx))]
          : []),
        insoleRow(
          'size',
          fm.size_sx != null && fm.size_sx !== '' ? fm.size_sx : '',
          fm.size_dx != null && fm.size_dx !== '' ? fm.size_dx : ''
        ),
        insoleRow(
          'heel_height',
          fm.heel_height_sx != null ? fm.heel_height_sx : '',
          fm.heel_height_dx != null ? fm.heel_height_dx : ''
        ),
        insoleRow(
          'ball_height',
          fm.ball_height_sx != null ? fm.ball_height_sx : '',
          fm.ball_height_dx != null ? fm.ball_height_dx : ''
        ),
        insoleRow(
          'fings_height',
          fm.fings_height_sx != null ? fm.fings_height_sx : '',
          fm.fings_height_dx != null ? fm.fings_height_dx : ''
        ),
        insoleRow(
          'sup_col_med',
          fm.sup_col_med_sx != null ? fm.sup_col_med_sx : '',
          fm.sup_col_med_dx != null ? fm.sup_col_med_dx : ''
        ),
        insoleRow(
          'avvolgenza_mediale',
          fm.avvolgenza_mediale_sx != null ? fm.avvolgenza_mediale_sx : '',
          fm.avvolgenza_mediale_dx != null ? fm.avvolgenza_mediale_dx : ''
        ),
        [this.hrForTableNoWidth()],
        [this.titleRow('materials')],
        [
          this.fieldLabel('insoleBaseMat', 2),
          this.field(
            this.printMaterialComplete(
              this.availableMoiInsole,
              modMaterials ? modMaterials.insoleBaseMat : undefined,
              modMaterials ? modMaterials.insoleBaseVar : undefined
            ),
            4
          ),
          this.fieldLabel('insoleCoverMat', 2),
          this.field(
            this.printMaterialComplete(
              this.availableRicInsole,
              modMaterials ? modMaterials.insoleCoverMat : undefined,
              modMaterials ? modMaterials.insoleCoverVar : undefined
            ),
            4
          ),
        ],
        [
          this.fieldLabel('insoleFillMat', 2),
          this.field(
            this.printMaterialComplete(
              this.availableRieInsole,
              modMaterials ? modMaterials.insoleFillMat : undefined,
              modMaterials ? modMaterials.insoleFillVar : undefined
            ),
            10
          ),
        ],
        [
          this.fieldLabel('note', 2),
          this.field(order.footmeasurements && order.footmeasurements.notes ? order.footmeasurements.notes : '', 10, 2),
        ],
      ]

      autoTable(doc, {
        theme: 'grid',
        margin: { top: 100 },
        styles: { fillColor: [255, 255, 255] },
        bodyStyles: { cellPadding: 3 },
        rowPageBreak: 'avoid',
        columnStyles: {
          0: { cellWidth: 40 },
          1: { cellWidth: 40 },
          2: { cellWidth: 40 },
          3: { cellWidth: 40 },
          4: { cellWidth: 40 },
          5: { cellWidth: 40 },
          6: { cellWidth: 40 },
          7: { cellWidth: 40 },
          8: { cellWidth: 40 },
          9: { cellWidth: 40 },
          10: { cellWidth: 40 },
          11: { cellWidth: 40 },
        },
        didDrawPage: data => {
          if (data.pageNumber != 1) {
            this.AddHeader(doc, order)
          }
          var str = doc.internal.getNumberOfPages()
          if (typeof doc.putTotalPages === 'function') {
            str = str + '/' + totalPagesExp
          }
          doc.setFontSize(10)
          var pageSize = doc.internal.pageSize
          var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
          doc.text(str, data.settings.margin.left, pageHeight - 10)
        },
        willDrawCell: data => {
          let Cell = data.column.index + ':' + data.row.index
          if (data.cell && data.cell.text && data.cell.text[0] == 'X') {
            data.cell.text = []
            this.falseCheck.push(Cell)
          }
          if (data.cell && data.cell.text && data.cell.text[0] == 'V') {
            data.cell.text = []
            this.trueCheck.push(Cell)
          }
        },
        didDrawCell: data => {
          var dim = 0
          var textPos = {}
          let Cell = data.column.index + ':' + data.row.index
          if (this.falseCheck.includes(Cell)) {
            dim = data.cell.height - data.cell.padding('vertical')
            textPos = data.cell
            this.falseCheck.splice(this.falseCheck.indexOf(Cell), 1)
            doc.addImage(
              this.getCheckFalse(),
              textPos.x + data.cell.width / 2 - dim / 2,
              textPos.y + data.cell.height / 2 - dim / 2,
              10,
              10
            )
          }
          if (this.trueCheck.includes(Cell)) {
            dim = data.cell.height - data.cell.padding('vertical')
            textPos = data.cell
            this.trueCheck.splice(this.trueCheck.indexOf(Cell), 1)
            doc.addImage(
              this.getCheckTrue(),
              textPos.x + data.cell.width / 2 - dim / 2,
              textPos.y + data.cell.height / 2 - dim / 2,
              10,
              10
            )
          }
        },
        body,
      })

      this.modelCounter++

      const insertRows = []
      const insertSections = ['avampiede', 'mesopiede', 'retropiede', 'piani_inclinati']
      insertSections.forEach(section => {
        insertRows.push([this.fieldLabel(section, 12, 1, true)])
        let sectionCount = 0
        const insertSides = []
        if (sxEnabled) insertSides.push(['sx', modSx])
        if (dxEnabled) insertSides.push(['dx', modDx])
        insertSides.forEach(([side, sideMod]) => {
          const slots =
            sideMod && sideMod.inserts && Array.isArray(sideMod.inserts[`${section}_${side}`])
              ? sideMod.inserts[`${section}_${side}`]
              : []
          slots.forEach(slot => {
            if (slot && slot.material != null && slot.variant != null) {
              sectionCount++
              const insertMat = this.availableInsInsole.find(el => el.id === slot.material)
              const insertVar =
                insertMat && insertMat.variants ? insertMat.variants.find(el => el.id === slot.variant) : undefined
              insertRows.push([
                this.field(
                  side.toUpperCase() +
                    ' - ' +
                    (insertMat ? (insertMat.CUI ? insertMat.CUI + ' ' : '') + this.$translateMaterial(insertMat) : ''),
                  6
                ),
                this.field(insertVar ? insertVar.name : '', 3),
                this.field(slot.thickness != null ? slot.thickness + ' mm' : '', 3),
              ])
            }
          })
        })
        if (sectionCount === 0) {
          insertRows.push([this.field('', 6), this.field('', 3), this.field('', 3)])
        }
      })

      doc.addPage()
      autoTable(doc, {
        theme: 'grid',
        margin: { top: 100 },
        styles: { fillColor: [255, 255, 255] },
        bodyStyles: { cellPadding: 3 },
        rowPageBreak: 'avoid',
        columnStyles: {
          0: { cellWidth: 40 },
          1: { cellWidth: 40 },
          2: { cellWidth: 40 },
          3: { cellWidth: 40 },
          4: { cellWidth: 40 },
          5: { cellWidth: 40 },
          6: { cellWidth: 40 },
          7: { cellWidth: 40 },
          8: { cellWidth: 40 },
          9: { cellWidth: 40 },
          10: { cellWidth: 40 },
          11: { cellWidth: 40 },
        },
        didDrawPage: data => {
          this.AddHeader(doc, order)

          var str = doc.internal.getNumberOfPages()
          if (typeof doc.putTotalPages === 'function') {
            str = str + '/' + totalPagesExp
          }
          doc.setFontSize(10)

          var pageSize = doc.internal.pageSize
          var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
          doc.text(str, data.settings.margin.left, pageHeight - 10)
        },
        body: [
          [this.titleRow('Ins_I')],
          [
            this.fieldLabel('insert', 6, 1, true),
            this.fieldLabel('insert_variant', 3, 1, true),
            this.fieldLabel('thickness', 3, 1, true),
          ],
        ].concat(insertRows),
      })

      let bodyClaim = []
      if (order.claims && order.claims.length !== undefined) {
        order.claims.forEach(claim => {
          if (claim.primaryCode) {
            bodyClaim.push([
              this.fieldColor(
                claim.primaryCode,
                3,
                2,
                claim.inadequate ? '#ff3860' : claim.status === 'confirmed' ? '#008a6b' : '#000000'
              ),
              this.fieldLabel('creation_date', 2),
              this.field(new Date(claim.creationDate).toLocaleDateString(), 2),
              this.fieldLabel('reception_date', 2),
              this.field(claim.answercreationDate ? new Date(claim.answercreationDate).toLocaleDateString() : '', 2),
            ])
            bodyClaim.push([
              this.fieldLabel('tec', 2),
              this.field(claim.tec, 2),
              this.fieldLabel('user', 2),
              this.field(claim.answertec, 2),
            ])

            if (claim.generalInfo) {
              bodyClaim.push([
                this.fieldLabel(this.$translate('generalInfotext'), 3, 2),
                this.field(claim.generalInfotext, 8),
              ])
              bodyClaim.push([this.field(claim.generalInfoanswer ? claim.generalInfoanswer : '', 8)])
            }

            if (claim.model) {
              bodyClaim.push([this.fieldLabel(this.$translate('modeltext'), 3, 2), this.field(claim.modeltext, 8)])
              bodyClaim.push([this.field(claim.modelanswer ? claim.modelanswer : '', 8)])
            }
            if (claim.footmeasurements) {
              bodyClaim.push([
                this.fieldLabel(this.$translate('footmeasurementstext'), 3, 2),
                this.field(claim.footmeasurementstext, 8),
              ])
              bodyClaim.push([this.field(claim.footmeasurementsanswer ? claim.footmeasurementsanswer : '', 8)])
            }
          }
        })
        if (bodyClaim.length != 0) {
          doc.addPage()

          autoTable(doc, {
            theme: 'grid',
            margin: { top: 100 },
            styles: { fillColor: [255, 255, 255] },
            bodyStyles: { cellPadding: 3 },
            rowPageBreak: 'avoid',

            columnStyles: {
              0: { cellWidth: 40 },
              1: { cellWidth: 40 },
              2: { cellWidth: 40 },
              3: { cellWidth: 40 },
              4: { cellWidth: 40 },
              5: { cellWidth: 40 },
              6: { cellWidth: 40 },
              7: { cellWidth: 40 },
              8: { cellWidth: 40 },
              9: { cellWidth: 40 },
              10: { cellWidth: 40 },
              11: { cellWidth: 40 },
            },
            didDrawPage: data => {
              this.AddHeader(doc, order)

              var str = doc.internal.getNumberOfPages()
              if (typeof doc.putTotalPages === 'function') {
                str = str + '/' + totalPagesExp
              }
              doc.setFontSize(10)

              var pageSize = doc.internal.pageSize
              var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
              doc.text(str, data.settings.margin.left, pageHeight - 10)
            },
            body: bodyClaim,
          })
        }
      }
    },
    handleNewPageBetweenOrders(orderIndex, doc) {
      if (orderIndex < this.orders.length - 1) {
        doc.addPage()
        if (doc.getNumberOfPages() % 2 === 0 && orderIndex < this.orders.length - 1) {
          doc.addPage()
        }
      }
    },
    getShapeName(order) {
      return order.mod && order.mod.sole && order.mod.sole.shapes && order.mod.sole.shapes.length > 0
        ? order.mod.sole.shapes[0].commercial_name.split(' ')[0]
        : ''
    },
    getModel(order) {
      if (order.mod) {
        if (order.mod.name) {
          return this.$options.filters.capitalize(order.mod.name)
        } else if (order.mod.custom) {
          return this.$options.filters.capitalize(this.$translate('custom_model'))
        } else {
          return ''
        }
      } else {
        return ''
      }
    },
    setOrderAddress(order) {
      const addressInfo = order.shop.useForShipping ? order.shop.address : order.company.address
      const address = {}
      address.street = addressInfo.street || ''
      address.city = addressInfo.city || ''
      address.postalCode = addressInfo.postalCode || ''
      address.country = addressInfo.country || ''
      this.deliveryAddress = address
    },
    allacciatureTable(order) {
      let allacciarow = []
      if (order.mod && order.mod.allacci && order.mod.allacci.length > 0) {
        for (let allac in order.mod.allacci) {
          allacciarow.push([this.field('', 10), this.field('SX', 1), this.field('DX', 1)])
          if (order.mod.allacci[allac].allprim == 'allacciatura0') {
            allacciarow.push([
              this.fieldLabel('allprim', 3),
              this.field(this.$translate('allacciatura0'), 3),
              this.fieldLabel('number_occh', 4),
              this.field(order.mod.allacci[allac].occh_sx ? order.mod.allacci[allac].occh_sx : '', 1),
              this.field(order.mod.allacci[allac].occh_dx ? order.mod.allacci[allac].occh_dx : '', 1),
            ])
            if (order.mod.allacci[allac].allvar == 'allacciatura0var4') {
              allacciarow.push([
                this.fieldLabel('allvar', 3),
                this.field(this.$translate('allacciatura0var4'), 3),
                this.fieldLabel('number_ganc', 4),
                this.field(order.mod.allacci[allac].gan_sx ? order.mod.allacci[allac].gan_sx : '', 1),
                this.field(order.mod.allacci[allac].gan_dx ? order.mod.allacci[allac].gan_dx : '', 1),
              ])
            } else {
              allacciarow.push([
                this.fieldLabel('allvar', 3),
                this.field(this.$translate(order.mod.allacci[allac].allvar), 3),
                this.field('', 6),
              ])
            }
          } else if (order.mod.allacci[allac].allprim == 'allacciatura1') {
            allacciarow.push([
              this.fieldLabel('allprim', 3),
              this.field(this.$translate('allacciatura1'), 3),
              this.fieldLabel('number_velc', 4),
              this.field(order.mod.allacci[allac].vel_sx ? order.mod.allacci[allac].vel_sx : '', 1),
              this.field(order.mod.allacci[allac].vel_dx ? order.mod.allacci[allac].vel_dx : '', 1),
            ])
            allacciarow.push([
              this.fieldLabel('allvar', 3),
              this.field(this.$translate(order.mod.allacci[allac].allvar), 3),
              this.fieldLabel('long_velc', 4),
              this.field(order.mod.allacci[allac].longvel_sx ? order.mod.allacci[allac].longvel_sx : '', 1),
              this.field(order.mod.allacci[allac].longvel_dx ? order.mod.allacci[allac].longvel_dx : '', 1),
            ])
            allacciarow.push([
              this.field('', 6),
              this.fieldLabel('lar_velc', 4),
              this.field(order.mod.allacci[allac].larvel_sx ? order.mod.allacci[allac].larvel_sx : '', 1),
              this.field(order.mod.allacci[allac].larvel_dx ? order.mod.allacci[allac].larvel_dx : '', 1),
            ])
            allacciarow.push([
              this.field('', 6),
              this.fieldLabel('al_contrario', 4),
              this.field(order.mod.allacci[allac].inv_vel_sx ? 'V' : 'X', 1),
              this.field(order.mod.allacci[allac].inv_vel_dx ? 'V' : 'X', 1),
            ])
          } else {
            allacciarow.push([
              this.fieldLabel('allprim', 3),
              this.field(this.$translate(order.mod.allacci[allac].allprim), 3),
              this.field('', 6),
            ])
            allacciarow.push([
              this.fieldLabel('allvar', 3),
              this.field(this.$translate(order.mod.allacci[allac].allvar), 3),
              this.field('', 6),
            ])
          }
        }
      }
      this.arrayrowCounterAllacciatura.push(allacciarow.length)

      //console.log(this.arrayrowCounterAllacciatura);
      return allacciarow
    },
    shapeTable(order) {
      if (
        order.footmeasurements &&
        order.footmeasurements.left &&
        order.footmeasurements.left.height &&
        order.footmeasurements.left.circumference
      ) {
        order.footmeasurements.left.end_tomaia = order.footmeasurements.left.circumference
      }
      if (
        order.footmeasurements &&
        order.footmeasurements.right &&
        order.footmeasurements.right.height &&
        order.footmeasurements.right.circumference
      ) {
        order.footmeasurements.right.end_tomaia = order.footmeasurements.right.circumference
      }
      let shapeRow = []
      const orderHasLeftShape =
        order.mod &&
        order.mod.sole &&
        order.footmeasurements &&
        order.footmeasurements.left &&
        order.footmeasurements.left.fit_code
      const orderHasRightShape =
        order.mod &&
        order.mod.sole &&
        order.footmeasurements &&
        order.footmeasurements.right &&
        order.footmeasurements.right.fit_code

      const leftShape = orderHasLeftShape
        ? order.mod.sole.shapes.find(
            shape => shape.fit_code === order.footmeasurements.left.fit_code && order.shoeType === shape.type
          )
        : {}
      const leftShapeSizes = leftShape.sizes
        ? leftShape.sizes.find(size => size.size === order.footmeasurements.left.size)
        : {}

      const rightShape = orderHasRightShape
        ? order.mod.sole.shapes.find(
            shape => shape.fit_code === order.footmeasurements.right.fit_code && order.shoeType === shape.type
          )
        : {}
      const rightShapeSizes = rightShape.sizes
        ? rightShape.sizes.find(size => size.size === order.footmeasurements.right.size)
        : {}

      const shapeTableHeaders =
        order.shoeType === 'low'
          ? this.$shapeTableHeadersLow[order.module].filter(header => header !== 'size')
          : this.$shapeTableHeadersHigh[order.module].filter(header => header !== 'size')

      for (let header of shapeTableHeaders) {
        shapeRow.push([
          this.field(leftShapeSizes[header], 1),
          this.field(
            order.footmeasurements && order.footmeasurements.left && order.footmeasurements.left[header]
              ? order.footmeasurements.left[header]
              : '',
            2
          ),
          this.field('', 2),
          this.fieldLabel(header, 2),
          this.field('', 2),
          this.field(
            order.footmeasurements && order.footmeasurements.right && order.footmeasurements.right[header]
              ? order.footmeasurements.right[header]
              : '',
            2
          ),
          this.field(rightShapeSizes[header], 1),
        ])
      }
      if (order.module === 'fits') {
        shapeRow.push([
          this.field('', 1),
          this.field(
            order.footmeasurements && order.footmeasurements.left && order.footmeasurements.left.height
              ? order.footmeasurements.left.height
              : '',
            2
          ),
          this.field('', 2),
          this.fieldLabel('height_tomaia', 2),
          this.field('', 2),
          this.field(
            order.footmeasurements && order.footmeasurements.right && order.footmeasurements.right.height
              ? order.footmeasurements.right.height
              : '',
            2
          ),
          this.field('', 1),
        ])
      }

      return shapeRow
    },
    measurementsTable(order) {
      if (
        order.footmeasurements &&
        order.footmeasurements.left &&
        order.footmeasurements.left.height &&
        order.footmeasurements.left.circumference
      ) {
        order.footmeasurements.left.end_tomaia = order.footmeasurements.left.circumference
      }
      if (
        order.footmeasurements &&
        order.footmeasurements.right &&
        order.footmeasurements.right.height &&
        order.footmeasurements.right.circumference
      ) {
        order.footmeasurements.right.end_tomaia = order.footmeasurements.right.circumference
      }
      let shapeRow = [this.titleRowSplitFive('shape_sx', 'foot_sx', 'measurements', 'foot_dx', 'shape_dx')]
      const orderHasLeftShape =
        order.mod &&
        order.mod.sole &&
        order.footmeasurements &&
        order.footmeasurements.left &&
        order.footmeasurements.left.fit_code
      const orderHasRightShape =
        order.mod &&
        order.mod.sole &&
        order.footmeasurements &&
        order.footmeasurements.right &&
        order.footmeasurements.right.fit_code

      const leftShape = orderHasLeftShape
        ? order.mod.sole.shapes.find(
            shape => shape.fit_code === order.footmeasurements.left.fit_code && order.shoeType === shape.type
          )
        : {}
      const leftShapeSizes = leftShape.sizes
        ? leftShape.sizes.find(size => size.size === order.footmeasurements.left.size)
        : {}

      const rightShape = orderHasRightShape
        ? order.mod.sole.shapes.find(
            shape => shape.fit_code === order.footmeasurements.right.fit_code && order.shoeType === shape.type
          )
        : {}
      const rightShapeSizes = rightShape.sizes
        ? rightShape.sizes.find(size => size.size === order.footmeasurements.right.size)
        : {}

      const headers = (order.shoeType === 'low'
        ? this.$shapeTableHeadersLow[order.module]
        : this.$shapeTableHeadersHigh[order.module]
      ).filter(header => header !== 'size')
      const shapeTableHeaders = ['length'].concat(headers.filter(header => header !== 'length'))

      for (let header of shapeTableHeaders) {
        shapeRow.push([
          this.field(leftShapeSizes[header], 2),
          this.field(
            order.footmeasurements && order.footmeasurements.left && order.footmeasurements.left[header]
              ? order.footmeasurements.left[header]
              : '',
            2
          ),
          this.fieldLabel(header, 4),
          this.field(
            order.footmeasurements && order.footmeasurements.right && order.footmeasurements.right[header]
              ? order.footmeasurements.right[header]
              : '',
            2
          ),
          this.field(rightShapeSizes[header], 2),
        ])
      }
      return shapeRow
    },
    pellAndFoderaTable(order) {
      const config = this.$moduleConfiguration[order.module ? order.module : 'tailored']
      const pellami = order.module === 'fits' ? this.availablepelFits : this.availablepelModular
      const pellAndFoderaTable = [[this.fieldLabel(['tomaio_fodera'], 12, 1, true)], [this.fieldLabel('materials', 12)]]
      const [pelCount, ripCount] = this.getModelAndRipCount(order)
      for (let i = 1; i <= pelCount; i++) {
        pellAndFoderaTable.push([
          this.fieldLabelMultipleString(['pelltitle', i], 4, 1, ' '),
          this.field(
            this.printMaterialComplete(
              pellami,
              order.mod ? order.mod[`pell${i}mat`] : undefined,
              order.mod ? order.mod[`pell${i}var`] : undefined
            ),
            8
          ),
        ])
      }
      if (ripCount) {
        for (let i = 1; i <= ripCount; i++) {
          pellAndFoderaTable.push([
            this.fieldLabelMultipleString(['riptitle', i], 4, 1, ' '),
            this.field(
              this.printMaterialComplete(
                this.availableripModular,
                order.mod ? order.mod[`rip${i}mat`] : undefined,
                order.mod ? order.mod[`rip${i}var`] : undefined
              ),
              8
            ),
          ])
        }
      }

      if (order.module === 'modular') {
        pellAndFoderaTable.push([
          this.fieldLabel('puncture', 4),
          this.field(order.mod.puncture ? this.$translate('yes') : this.$translate('no'), 8),
        ])
      }

      if (order.model && !config.hasCustomTomaiaDrills) {
        pellAndFoderaTable.push(
          [
            this.fieldLabel('drilled_tomaio', 4, 1),
            this.field(order.mod.puncture ? this.$translate('yes') : this.$translate('no'), 2),
          ],
          [
            this.fieldLabel('drilled_fodera', 4, 1),
            this.field(order.mod.hasDrilledFodera ? this.$translate('yes') : this.$translate('no'), 2),
          ]
        )
      }

      if (config.modelHasFodera) {
        pellAndFoderaTable.push(
          [
            this.fieldLabel('fodanttitle', 4),
            this.field(
              this.printMaterialComplete(
                this.availablefodeFits,
                order.mod ? order.mod.fodantmat : undefined,
                order.mod ? order.mod.fodantvar : undefined
              ),
              8
            ),
          ],

          [
            this.fieldLabel('fodpostitle', 4),
            this.field(
              this.printMaterialComplete(
                this.availablefodeFits,
                order.mod ? order.mod.fodposmat : undefined,
                order.mod ? order.mod.fodposvar : undefined
              ),
              8
            ),
          ]
        )
      }

      return pellAndFoderaTable
    },
    allacciaturaTableFitsModular(order) {
      if (order.module === 'fits') {
        return [
          [this.hrForTable()],
          [this.fieldLabel(['allacciaturatitle'], 12, 1, true)],
          [
            this.fieldLabel(['allacciaturatitle'], 4),
            this.field(
              this.printNoVariantsMaterialComplete(
                this.availableallacc,
                order.mod ? order.mod.allacciatura : undefined
              ),
              8
            ),
          ],
        ]
      } else {
        return [
          [this.hrForTable()],
          [this.fieldLabel(['allacciaturaandfoderatitle'], 12, 1, true)],
          [
            this.fieldLabel('drilled_fodera', 4),
            this.field(order.mod.hasDrilledFodera ? this.$translate('yes') : this.$translate('no'), 8),
          ],
          [
            this.fieldLabel(['velcri_length'], 4),
            this.field(order.mod.velcri_length ? order.mod.velcri_length : '', 8),
          ],
        ]
      }
    },
    contraffortiTable(order) {
      let table = [
        [this.hrForTableNoWidth()],
        [
          {
            content: '',
            styles: { halign: 'center', valign: 'middle' },
          },
          this.titleRow('caratteristiche_tecniche', 1),
        ],
        [this.hrForTable()],
        [this.fieldLabel('PaS', 12, 1, true)],
        [
          this.field('', 2, 4),
          this.field(order.typecontr_sx ? this.$translate(order.typecontr_sx) : '', 3),
          this.fieldLabel('type', 2),
          this.field(order.typecontr_dx ? this.$translate(order.typecontr_dx) : '', 3),
          this.field('', 2, 4),
        ],
      ]
      if (order.module === 'modular') {
        table = [
          [this.titleRow('caratteristiche_tecniche')],
          [this.fieldLabel('SX', 4, 1, true), this.fieldLabel('PaS', 4, 1, true), this.fieldLabel('DX', 4, 1, true)],
          [
            this.field(order.typecontr_sx ? this.$translate(order.typecontr_sx) : '', 4),
            this.fieldLabel('type', 4),
            this.field(order.typecontr_dx ? this.$translate(order.typecontr_dx) : '', 4),
          ],
        ]
      }
      if (order.module === 'fits') {
        table.push(
          [
            this.field(
              order.typecontr_sx == 'Noone'
                ? ''
                : this.printMaterialComplete(this.availablepasFits, order.tipocontr_sx, order.tipocontr_var_sx),
              3
            ),
            this.fieldLabel('contrmat', 2),
            this.field(
              order.typecontr_dx == 'Noone'
                ? ''
                : this.printMaterialComplete(this.availablepasFits, order.tipocontr_dx, order.tipocontr_var_dx),
              3
            ),
          ],
          [
            this.field(
              order.typecontr_sx == 'Noone'
                ? ''
                : order.tiporinfcontr_sx
                ? this.$translate(order.tiporinfcontr_sx)
                : '',
              3
            ),
            this.fieldLabel('rinfcontr', 2),
            this.field(
              order.typecontr_dx == 'Noone'
                ? ''
                : order.tiporinfcontr_dx
                ? this.$translate(order.tiporinfcontr_dx)
                : '',
              3
            ),
          ]
        )
      }
      return table
    },
    sottopiedeTable(order) {
      switch (order.module) {
        case 'fits':
          return this.sottopiedeTableFits(order)
        case 'modular':
          return this.sottopiedeTableModular(order)
      }
    },
    sottopiedeTableModular(order) {
      const table = [
        [this.fieldLabel('SX', 4, 1, true), this.fieldLabel('Pat', 4, 1, true), this.fieldLabel('DX', 4, 1, true)],
        [
          this.field(order.tiporinfsott_sx ? this.$translate(order.tiporinfsott_sx) : '', 4),
          this.fieldLabel('rinfsotto', 4),
          this.field(order.tiporinfsott_dx ? this.$translate(order.tiporinfsott_dx) : '', 4),
        ],
      ]
      return table
    },
    sottopiedeTableFits(order) {
      const table = [
        [this.fieldLabel('Pat', 12, 1, true)],
        [this.fieldLabel('left', 4), this.fieldLabel('', 4), this.fieldLabel('right', 4)],
        [
          this.field(order.tiporinfsott_sx ? this.$translate(order.tiporinfsott_sx) : '', 4),
          this.fieldLabel('rinfsotto', 4),
          this.field(order.tiporinfsott_dx ? this.$translate(order.tiporinfsott_dx) : '', 4),
        ],
      ]
      table.push(
        [
          this.field(
            order.prod_details &&
              order.prod_details.left &&
              (order.prod_details.left.rockerSole && Object.keys(order.prod_details.left.rockerSole).length > 0)
              ? 'V'
              : 'X',
            4
          ),
          this.fieldLabel('Rocker sole', 4),
          this.field(
            order.prod_details &&
              order.prod_details.right &&
              (order.prod_details.right.rockerSole && Object.keys(order.prod_details.right.rockerSole).length > 0)
              ? 'V'
              : 'X',
            4
          ),
        ],
        [
          this.field(
            order.prod_details &&
              order.prod_details.left &&
              order.prod_details.left.rockerSole &&
              order.prod_details.left.rockerSole.heel_height
              ? order.prod_details.left.rockerSole.heel_height
              : '',
            4
          ),
          this.fieldLabel('heel_height', 4),
          this.field(
            order.prod_details &&
              order.prod_details.right &&
              order.prod_details.right.rockerSole &&
              order.prod_details.right.rockerSole.heel_height
              ? order.prod_details.right.rockerSole.heel_height
              : '',
            4
          ),
        ],
        [
          this.field(
            order.prod_details &&
              order.prod_details.left &&
              order.prod_details.left.rockerSole &&
              order.prod_details.left.rockerSole.ball_height
              ? order.prod_details.left.rockerSole.ball_height
              : '',
            4
          ),
          this.fieldLabel('ball_height', 4),
          this.field(
            order.prod_details &&
              order.prod_details.right &&
              order.prod_details.right.rockerSole &&
              order.prod_details.right.rockerSole.ball_height
              ? order.prod_details.right.rockerSole.ball_height
              : '',
            4
          ),
        ],
        [
          this.field(
            order.prod_details &&
              order.prod_details.left &&
              order.prod_details.left.rockerSole &&
              order.prod_details.left.rockerSole.fings_height
              ? order.prod_details.left.rockerSole.fings_height
              : '',
            4
          ),
          this.fieldLabel('fings_height', 4),
          this.field(
            order.prod_details &&
              order.prod_details.right &&
              order.prod_details.right.rockerSole &&
              order.prod_details.right.rockerSole.fings_height
              ? order.prod_details.right.rockerSole.fings_height
              : '',
            4
          ),
        ]
      )
      return table
    },
    getModelAndRipCount(order) {
      let pelCount = 0
      let ripCount = 0
      const { minPel, maxPel, minRip, maxRip } = this.$moduleConfiguration[order.module ? order.module : 'tailored']
      if (minPel === maxPel) {
        pelCount = maxPel
      } else {
        for (let i = 1; i <= maxPel; i++) {
          if (order.mod[`pell${i}mat`]) pelCount = i
        }
      }
      if (minRip === maxRip) {
        ripCount = maxRip || 0
      } else {
        for (let i = 1; i <= maxRip; i++) {
          if (order.mod[`rip${i}mat`]) ripCount = i
        }
      }
      return [pelCount, ripCount]
    },
    printMaterialComplete(arrayMat, matid, varid) {
      if (matid != undefined) {
        if (varid != undefined) {
          let realMaterial = arrayMat.find(el => el.id == matid)
          if (realMaterial != undefined) {
            if (realMaterial.variants.find(el => el.id == varid) != undefined) {
              if (realMaterial.variants.find(el => el.id == varid).CUI_optionalbool) {
                return (
                  realMaterial.variants.find(el => el.id == varid).CUI_optional +
                  ' ' +
                  realMaterial.variants.find(el => el.id == varid).CUIV +
                  ' ' +
                  this.$translateMaterial(realMaterial) +
                  ' ' +
                  realMaterial.variants.find(el => el.id == varid).name
                )
              } else {
                return (
                  realMaterial.CUI +
                  ' ' +
                  realMaterial.variants.find(el => el.id == varid).CUIV +
                  ' ' +
                  this.$translateMaterial(realMaterial) +
                  ' ' +
                  realMaterial.variants.find(el => el.id == varid).name
                )
              }
            } else {
              return ''
            }
          } else {
            return ''
          }
        } else {
          if (arrayMat.find(el => el.id == matid) != undefined) {
            return arrayMat.find(el => el.id == matid).CUI + ' ' + arrayMat.find(el => el.id == matid).name
          } else {
            return ''
          }
        }
      } else {
        return ''
      }
    },
    printNoVariantsMaterialComplete(arrayMat, matid) {
      if (matid != undefined) {
        let realMaterial = arrayMat.find(el => el.id == matid)
        if (realMaterial != undefined) {
          return realMaterial.CUI + ' ' + this.$translateMaterial(realMaterial)
        } else {
          return ''
        }
      } else {
        return ''
      }
    },
    fieldLabel(stringToTranslate, colSpanNumber, rowSpanNumber = 1, bigger = false) {
      return {
        content: this.$options.filters.capitalize(this.$translate(stringToTranslate)),
        colSpan: colSpanNumber,
        rowSpan: rowSpanNumber,
        styles: {
          font: 'Calibri',
          fillColor: '#E0E0E0',
          fontSize: bigger ? this.defaultFontSize + 6 : this.defaultFontSize + 3,
          fontStyle: bigger ? 'bold' : 'normal',
          halign: 'center',
          valign: 'middle',
        },
      }
    },
    fieldLabelMultipleString(strings, colSpanNumber, rowSpanNumber = 1, separator = '/', bigger = false) {
      let content = ''
      let i = 0
      strings.forEach(contentPart => {
        if (i != 0) {
          content += separator
        }
        content += this.$options.filters.capitalize(this.$translate(contentPart))
        i++
      })
      return {
        content: content,
        colSpan: colSpanNumber,
        rowSpan: rowSpanNumber,
        styles: {
          font: 'Calibri',
          fillColor: '#E0E0E0',
          fontSize: bigger ? this.defaultFontSize + 6 : this.defaultFontSize + 3,
          fontStyle: bigger ? 'bold' : 'normal',
          halign: 'center',
          valign: 'middle',
        },
      }
    },
    field(stringFieldOrder, colSpanNumber, rowSpanNumber = 1) {
      return {
        content: stringFieldOrder,

        colSpan: colSpanNumber,
        rowSpan: rowSpanNumber,
        styles: {
          font: 'Calibri',
          fillColor: '#FFFFFF',
          fontSize: this.defaultFontSize + 3,
          halign: 'center',
          valign: 'middle',
          fontStyle: 'bold',
        },
      }
    },
    fieldColor(stringFieldOrder, colSpanNumber, rowSpanNumber = 1, colorField) {
      return {
        content: stringFieldOrder,

        colSpan: colSpanNumber,
        rowSpan: rowSpanNumber,
        styles: {
          font: 'Calibri',
          textColor: colorField,
          fillColor: '#FFFFFF',
          fontSize: this.defaultFontSize + 3,
          halign: 'center',
          valign: 'middle',
          fontStyle: 'bold',
        },
      }
    },

    hrForTableNoWidth() {
      return {
        content: '',
        colSpan: 12,
        styles: {
          minCellHeight: -10,
          fontSize: 0.5,
        },
      }
    },
    hrForTable() {
      return {
        content: '',
        colSpan: 12,
        styles: { minCellHeight: -10, fontSize: 0.5 },
      }
    },
    titleRowMultipleString(strings, separator = '/', icon = null) {
      let content = ''
      let i = 0
      strings.forEach(contentPart => {
        if (i != 0) {
          content += separator
        }
        content += this.$options.filters.uppercase(this.$translate(contentPart))
        i++
      })
      if (icon) {
        return {
          content: content,
          colSpan: 11,
          styles: {
            font: 'Calibri',
            halign: 'center',
            valign: 'middle',
            fillColor: '#008a6b',
            textColor: '#FFFFFF',
            fontStyle: 'normal',
            fontSize: this.defaultFontSize + 7,
          },
        }
      } else {
        return {
          content: content,
          colSpan: 12,
          styles: {
            font: 'Calibri',
            halign: 'center',
            valign: 'middle',
            fillColor: '#008a6b',
            textColor: '#FFFFFF',
            fontStyle: 'normal',
            fontSize: this.defaultFontSize + 7,
          },
        }
      }
    },
    titleRowSplit(title1, title2, title3) {
      const titleStyle = {
        font: 'Calibri',
        halign: 'center',
        valign: 'middle',
        fillColor: '#008a6b',
        textColor: '#FFFFFF',
        fontStyle: 'normal',
        fontSize: this.defaultFontSize + 7,
        overflow: 'hidden',
      }
      return [
        { content: this.$options.filters.uppercase(this.$translate(title1)), colSpan: 4, styles: titleStyle },
        { content: this.$options.filters.uppercase(this.$translate(title2)), colSpan: 4, styles: titleStyle },
        { content: this.$options.filters.uppercase(this.$translate(title3)), colSpan: 4, styles: titleStyle },
      ]
    },
    titleRowSplitFive(title1, title2, title3, title4, title5) {
      const titleStyle = {
        font: 'Calibri',
        halign: 'center',
        valign: 'middle',
        fillColor: '#008a6b',
        textColor: '#FFFFFF',
        fontStyle: 'normal',
        fontSize: this.defaultFontSize + 7,
        overflow: 'hidden',
      }
      return [
        { content: this.$options.filters.uppercase(this.$translate(title1)), colSpan: 2, styles: titleStyle },
        { content: this.$options.filters.uppercase(this.$translate(title2)), colSpan: 2, styles: titleStyle },
        { content: this.$options.filters.uppercase(this.$translate(title3)), colSpan: 4, styles: titleStyle },
        { content: this.$options.filters.uppercase(this.$translate(title4)), colSpan: 2, styles: titleStyle },
        { content: this.$options.filters.uppercase(this.$translate(title5)), colSpan: 2, styles: titleStyle },
      ]
    },
    titleRow(stringToTranslate, icon = null) {
      if (icon) {
        return {
          content: this.$options.filters.uppercase(this.$translate(stringToTranslate)),
          colSpan: 11,
          styles: {
            font: 'Calibri',

            halign: 'center',
            valign: 'middle',
            fillColor: '#008a6b',
            textColor: '#FFFFFF',
            fontStyle: 'normal',
            fontSize: this.defaultFontSize + 7,
          },
        }
      } else {
        return {
          content: this.$options.filters.uppercase(this.$translate(stringToTranslate)),
          colSpan: 12,
          styles: {
            font: 'Calibri',

            halign: 'center',
            valign: 'middle',
            fillColor: '#008a6b',
            textColor: '#FFFFFF',
            fontStyle: 'normal',

            fontSize: this.defaultFontSize + 7,
          },
        }
      }
    },
    prepareMaterial() {
      //console.log("prepareMaterial");

      this.getMaterialsArray([
        'Moi',
        'Sup_plan',
        'Pel',
        'Acc',
        'PaS',
        'Mez',
        'Pat',
        'Mat',
        'Sug',
        'Pun',
        'Mor',
        'Pelo',
        'Riv_plan',
        'reinforcement',
        'Pel_F',
        'All_F',
        'Acc_F',
        'PaS_F',
        'Pat_F',
        'Pel_M',
        'Rip_M',
        'Moi_I',
        'Ric_plan_I',
        'Rie_plan_I',
        'Ins_I',
      ]).then(arraysresponse => {
        this.availablemoi = arraysresponse[0]
        this.availablesupplan = arraysresponse[1]
        this.availablepel = arraysresponse[2]
        this.availablefode = arraysresponse[3]
        this.availablepas = arraysresponse[4]
        this.availablemez = arraysresponse[5]
        this.availablepat = arraysresponse[6]
        this.availablemat = arraysresponse[7]
        this.availablesug = arraysresponse[8]
        this.availablepun = arraysresponse[9]
        this.availablemor = arraysresponse[10]
        this.availablepelo = arraysresponse[11]
        this.availablerivplan = arraysresponse[12]
        this.availablereinf = arraysresponse[13]
        this.availablepelFits = arraysresponse[14]
        this.availableallacc = arraysresponse[15]
        this.availablefodeFits = arraysresponse[16]
        this.availablepasFits = arraysresponse[17]
        this.availablepatFits = arraysresponse[18]
        this.availablepelModular = arraysresponse[19]
        this.availableripModular = arraysresponse[20]
        this.availableMoiInsole = arraysresponse[21]
        this.availableRicInsole = arraysresponse[22]
        this.availableRieInsole = arraysresponse[23]
        this.availableInsInsole = arraysresponse[24]
        this.prepareModelImages()
        //console.log(this.availablerivplan)
      })
    },
    async prepareModelImages() {
      let counter = 0
      this.arrayImageModel = []
      this.arrayrowCounterAllacciatura = []
      this.checkModel = true
      for (const order of this.orders) {
        if (order.mod && order.mod.image && !order.mod.custom) {
          counter++
          let img = new Image()
          this.arrayImageModel.push(img)
          img.onload = () => {
            this.checkToPrint()
          }
          img.onerror = () => {
            this.checkToPrint()
          }
          // Fetch fresh download URL to avoid stale token 403 errors
          if (order.mod.id) {
            try {
              const storageRef = this.$storage.ref('image/model/' + order.mod.id + '/image')
              const freshUrl = await storageRef.getDownloadURL()
              img.src = freshUrl
            } catch (e) {
              img.src = order.mod.image
            }
          } else {
            img.src = order.mod.image
          }
        } else if (order.mod && order.mod.image) {
          counter++
          let img = new Image()
          this.arrayImageModel.push(img)
          img.onload = () => {
            this.checkToPrint()
          }
          img.onerror = () => {
            this.checkToPrint()
          }
          img.crossOrigin = 'anonymous'
          img.src = order.mod.image
        } else {
          this.arrayImageModel.push(false)
          counter = 0
        }
      }
      if (counter === 0) {
        this.checkToPrint()
      }
    },
    AddHeader(doc, order) {
      autoTable(doc, {
        theme: 'grid',
        styles: { fillColor: [255, 255, 255] },
        bodyStyles: { cellPadding: 3 },
        rowPageBreak: 'avoid',
        columnStyles: {
          0: { cellWidth: 40 },
          1: { cellWidth: 40 },
          2: { cellWidth: 40 },
          3: { cellWidth: 40 },
          4: { cellWidth: 40 },
          5: { cellWidth: 40 },
          6: { cellWidth: 40 },
          7: { cellWidth: 40 },
          8: { cellWidth: 40 },
          9: { cellWidth: 40 },
          10: { cellWidth: 40 },
          11: { cellWidth: 40 },
        },
        body: [
          [
            this.fieldLabel('id_mercury', 2),
            this.field(order.id_mercury ? order.id_mercury : '', 1),
            this.fieldLabel('customer', 1),
            this.field(order.company.name, 2),
            this.fieldLabel('primaryCode', 2),
            this.field(order.primaryCode, 4),
          ],
          [this.hrForTable()],
          [
            this.fieldLabel('patient', 3),
            this.field(order.patient.name + ' ' + order.patient.surname, 3),
            this.fieldLabel('alias', 3),
            this.field(order.patient.alias, 3),
          ],
        ],
      })
    },

    checkToPrint() {
      //console.log("checkToPrint");
      if (this.checkModel) {
        let check = true
        let counter = 0
        this.orders.forEach(order => {
          if (this.arrayImageModel.length > counter) {
            if (order.mod && order.mod.image && !order.mod.custom) {
              if (!this.arrayImageModel[counter].complete) {
                check = false
              }
            }
          } else {
            check = false
          }
          counter++
        })

        if (check) {
          this.checkModel = false
          this.realPrint()
        }
      }
    },
    realPrint() {
      this.modelCounter = 0
      this.allacciaCounter = 0
      var doc = new jsPDF('p', 'pt')
      doc.addFileToVFS('Calibri.ttf', this.getFont())
      doc.addFileToVFS('CalibriBold.ttf', this.getFontBold())
      doc.addFont('Calibri.ttf', 'Calibri', 'normal')
      doc.addFont('CalibriBold.ttf', 'Calibri', 'bold')
      doc.setFont('Calibri')

      var totalPagesExp = '{total_pages_count_string}'

      let firstPage = true
      this.orders.forEach((order, index) => {
        if (order.module === 'fits') {
          this.printOrderFitsModular(order, index, firstPage, doc, totalPagesExp)
        } else if (order.module === 'modular') {
          this.printOrderModular(order, index, firstPage, doc, totalPagesExp)
        } else if (order.module === 'insole') {
          this.printOrderInsole(order, index, firstPage, doc, totalPagesExp)
        } else {
          this.printOrderTailored(order, index, firstPage, doc, totalPagesExp)
        }
        this.handleNewPageBetweenOrders(index, doc)
      })

      //console.log(doc.getNumberOfPages())

      if (typeof doc.putTotalPages === 'function') {
        doc.putTotalPages(totalPagesExp)
      }

      let filename = ''
      if (this.orders.length == 1) {
        if (this.orders[0].id_mercury) {
          filename = this.orders[0].id_mercury
        } else {
          filename = this.orders[0].primaryCode
          filename += '_'
          if (this.orders[0].patient.alias) {
            filename += this.orders[0].patient.alias
          } else {
            filename += this.orders[0].patient.name + '_' + this.orders[0].patient.surname
          }
        }
        filename += '_'
        filename += new Date().toLocaleDateString()
        filename += '.pdf'
      } else {
        filename = this.$options.filters.capitalize(this.$translate('prints'))
        filename += '_'
        filename += this.$store.getters.user.userInfo.name
        filename += this.$store.getters.user.userInfo.surname
        filename += '_'
        filename += new Date().toLocaleDateString()
        filename += '_'
        filename += new Date().getHours()
        filename += '_'
        filename += new Date().getMinutes()
        filename += '_'
        filename += new Date().getSeconds()
        filename += '.pdf'
      }
      doc.save(filename)
    },
  },
}
</script>
<style scoped>
.container >>> #mytableorders th {
  background-color: #008a6b !important;
  color: white;
}
</style>
<!--<template>
  <section>
    <b-modal :active.sync="isCardModalActive" :width="1000" scroll="keep">
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <p class="modal-card-title">
            {{ $translate("order") | capitalize }} {{ order.primaryCode }}
          </p>
        </header>
        <section class="modal-card-body">
          <table striped="true" style="width: 100%;" :id="'order' + order.id">
            <thead class="greenbg">
              <th colSpan="4" style="text-align:center;color:white;">
                {{ $translate("measure_shoe") | capitalize }}
              </th>
            </thead>
            <tbody>
              <tr>
                <td>{{ $translate("customer") | capitalize }}</td>
                <td v-if="order.patient">
                  {{ order.patient.name }} {{ order.patient.surname }}
                </td>
                <td>{{ $translate("model") | capitalize }}</td>
                <td>
                  {{ $translate(order.shoeType) | capitalize }},
                  {{ $translate(order.catalogType) | capitalize }}
                </td>
              </tr>

              <tr>
                <td>{{ $translate("rif_calzature") | capitalize }}</td>
                <td>{{ order.primaryCode }}</td>
                <td>{{ $translate("allacciaturatitle") | capitalize }}</td>
                <td v-if="order.mod && order.mod.allprim">
                  {{ $translate(this.order.mod.allprim) | capitalize }}
                </td>
                <td v-else></td>
              </tr>

              <tr>
                <td>{{ $translate("order_by") | capitalize }}</td>
                <td>{{ $translate(order.orderType) | capitalize }}</td>
                <td>{{ $translate("allacciaturatitle") | capitalize }}</td>
                <td v-if="order.mod && order.mod.allvar">
                  {{ $translate(order.mod.allvar) | capitalize }}
                </td>
                <td v-else></td>
              </tr>
              <tr>
                <td>{{ $translate("delivery") | capitalize }}</td>
                <td>{{ $translate(order.deliverySelected) | capitalize }}</td>
                <td>{{ $translate("point") | capitalize }}</td>
                <td>{{ $translate(order.c_point) | capitalize }}</td>
              </tr>

              <tr>
                <td>{{ $translate("sendord_in") | capitalize }}</td>
                <td>
                  {{ order.send_date ? new Date(order.send_date).toLocaleDateString() : '' }}
                </td>
                <td>{{ $translate("fondo") | capitalize }}</td>
                <td></td>
              </tr>

              <tr class="greenbg">
                <td colSpan="2">{{ $translate("measure_file") | capitalize }}</td>
                <td colSpan="2">{{ $translate("measure_file") | capitalize }}</td>
              </tr>
              <tr>
                <td
                  colSpan="2"
                  v-if="order.attachment && order.attachment.mesu_sx"
                >
                  <a target="_blank" :href="order.attachment.mesu_sx">link</a>
                </td>
                <td v-else></td>
                <td
                  colSpan="2"
                  v-if="order.attachment && order.attachment.mesu_dx"
                >
                  <a
                    target="_blank"
                    :href="order.attachment.mesu_dx"
                    v-if="order.attachment.mesu_dx"
                    >link</a
                  >
                </td>
                <td v-else></td>
              </tr>

              <tr class="greenbg">
                <td colSpan="2">{{ $translate("grap") | capitalize }}</td>
                <td colSpan="2">{{ $translate("grap") | capitalize }}</td>
              </tr>
              <tr>
                <td
                  colSpan="2"
                  v-if="order.attachment && order.attachment.grap_sx"
                >
                  <a
                    target="_blank"
                    :href="order.attachment.grap_sx"
                    v-if="order.attachment.grap_sx"
                    >link</a
                  >
                </td>
                <td v-else></td>

                <td
                  colSpan="2"
                  v-if="order.attachment && order.attachment.grap_dx"
                >
                  <a
                    target="_blank"
                    :href="order.attachment.grap_dx"
                    v-if="order.attachment.grap_dx"
                    >link</a
                  >
                </td>
                <td v-else></td>
              </tr>

              <tr class="greenbg">
                <td colSpan="2">{{ $translate("form_project") | capitalize }}</td>
                <td colSpan="2">{{ $translate("form_project") | capitalize }}</td>
              </tr>
              <tr>
                <td class="greenbg">
                  {{ $translate("style") | capitalize }}
                </td>
                <td>
                  
                </td>

                <td class="greenbg">
                  {{ $translate("style") | capitalize }}
                </td>
                <td>
                  
                </td>
              </tr>

              <tr>
                <td class="greenbg">
                  {{ $translate("new_form_for") | capitalize }}
                </td>
                <td>
                  
                </td>

                <td class="greenbg">
                  {{ $translate("new_form_for") | capitalize }}
                </td>
                <td>
                  
                </td>
              </tr>
              <tr class="greenbg">
                <td colSpan="4" style="text-align:center;color:white;">
                  {{ $translate("formplusplant") | capitalize }}
                </td>
              </tr>
              <tr class="greenbg">
                <td colSpan="2">{{ $translate("plantaredimont") | capitalize }}</td>
                <td colSpan="2">{{ $translate("plantaredimont") | capitalize }}</td>
              </tr>
              <tr>
                <td>
                  <strong>{{ $translate("type") | capitalize }}</strong>
                </td>
                <td>
                  {{ $translate(order.plantar_type) | capitalize }}
                </td>
                <td>
                  <strong>{{ $translate("type") | capitalize }}</strong>
                </td>
                <td>
                  {{ $translate(order.plantar_type) | capitalize }}
                </td>
              </tr>

              <tr>
                <td>
                  <strong>{{ $translate("base_mat") | capitalize }}</strong>
                </td>
                <td>
                  {{ $translate(order.base_mat) | capitalize }}
                </td>
                <td>
                  <strong>{{ $translate("base_mat") | capitalize }}</strong>
                </td>
                <td>
                  {{ $translate(order.base_mat) | capitalize }}
                </td>
              </tr>

              <tr>
                <td>
                  <strong>{{ $translate("surface_mat") | capitalize }}</strong>
                </td>
                <td>
                  {{ $translate(order.surface_mat) | capitalize }}
                </td>
                <td>
                  <strong>{{ $translate("surface_mat") | capitalize }}</strong>
                </td>
                <td>
                  {{ $translate(order.surface_mat) | capitalize }}
                </td>
              </tr>

              <tr>
                <td>
                  <strong>{{ $translate("fin_dess") | capitalize }}</strong>
                </td>
                <td>
                  {{ $translate(order.fin_dess) | capitalize }}
                </td>
                <td>
                  <strong>{{ $translate("fin_dess") | capitalize }}</strong>
                </td>
                <td>
                  {{ $translate(order.fin_dess) | capitalize }}
                </td>
              </tr>

              <tr>
                <td colSpan="2">
                  <strong>{{ $translate("thick_plant") | capitalize }}</strong>
                </td>
                <td colSpan="2">
                  <strong>{{ $translate("thick_plant") | capitalize }}</strong>
                </td>
              </tr>

              <tr>
                <td>&nbsp;{{ $translate("thick_plant_heel") | capitalize }}</td>
                <td>mm {{ order.footmeasurements.high_int_heel_sx }}</td>
                <td>&nbsp;{{ $translate("thick_plant_heel") | capitalize }}</td>
                <td>mm {{ order.footmeasurements.high_int_heel_dx }}</td>
              </tr>
              <tr>
                <td>&nbsp;{{ $translate("thick_plant_piant") | capitalize }}</td>
                <td>mm {{ order.footmeasurements.high_int_pla_sx }}</td>
                <td>&nbsp;{{ $translate("thick_plant_piant") | capitalize }}</td>
                <td>mm {{ order.footmeasurements.high_int_pla_dx }}</td>
              </tr>
              <tr>
                <td>&nbsp;{{ $translate("thick_plant_punt") | capitalize }}</td>
                <td>mm {{ order.footmeasurements.high_int_poi_sx }}</td>
                <td>&nbsp;{{ $translate("thick_plant_punt") | capitalize }}</td>
                <td>mm {{ order.footmeasurements.high_int_poi_dx }}</td>
              </tr>

              <tr>
                <td colSpan="2">
                  <strong>{{ $translate("pron_sup_plan") | capitalize }}</strong>
                </td>
                <td colSpan="2">
                  <strong>{{ $translate("pron_sup_plan") | capitalize }}</strong>
                </td>
              </tr>

              <tr>
                <td>&nbsp;{{ $translate("thick_plant_avam") | capitalize }}</td>
                <td>
                  mm 
                </td>
                <td>&nbsp;{{ $translate("thick_plant_avam") | capitalize }}</td>
                <td>
                  mm 
                </td>
              </tr>
              <tr>
                <td>&nbsp;{{ $translate("thick_plant_avam1") | capitalize }}</td>
                <td>
                  mm 
                </td>
                <td>&nbsp;{{ $translate("thick_plant_avam1") | capitalize }}</td>
                <td>
                  mm 
                </td>
              </tr>
              <tr>
                <td>&nbsp;{{ $translate("thick_plant_avam2") | capitalize }}</td>
                <td>
                  mm 
                </td>
                <td>&nbsp;{{ $translate("thick_plant_avam2") | capitalize }}</td>
                <td>
                  mm 
                </td>
              </tr>
              <tr>
                <td>&nbsp;{{ $translate("thick_plant_avam3") | capitalize }}</td>
                <td>
                  mm 
                </td>
                <td>&nbsp;{{ $translate("thick_plant_avam3") | capitalize }}</td>
                <td>
                  mm 
                </td>
              </tr>

              <tr>
                <td colSpan="2">
                  <strong>{{ $translate("correction") | capitalize }}</strong>
                </td>
                <td colSpan="2">
                  <strong>{{ $translate("correction") | capitalize }}</strong>
                </td>
              </tr>

              <tr>
                <td colSpan="2">
                  {{ $translate(order.pelotte) | capitalize }}
                </td>
                <td colSpan="2">
                  {{ $translate(order.pelotte) | capitalize }}
                </td>
              </tr>

              <tr>
                <td>
                  <strong>{{ $translate("realize") | capitalize }}</strong>
                </td>
                <td>
                  {{ $translate(order.plan_realization) | capitalize }}
                </td>
                <td>
                  <strong>{{ $translate("realize") | capitalize }}</strong>
                </td>
                <td>
                  {{ $translate(order.plan_realization) | capitalize }}
                </td>
              </tr>

              <tr>
                <td>
                  <strong>{{ $translate("spacepred") | capitalize }}</strong>
                </td>
                <td>
                  mm 
                </td>
                <td>
                  <strong>{{ $translate("spacepred") | capitalize }}</strong>
                </td>
                <td>
                  mm 
                </td>
              </tr>

              <tr>
                <td>
                  <strong>{{ $translate("riempim") | capitalize }}</strong>
                </td>
                <td>
                  mm 
                </td>
                <td>
                  <strong>{{ $translate("riempim") | capitalize }}</strong>
                </td>
                <td>
                  mm 
                </td>
              </tr>
              <tr class="greenbg">
                <td colSpan="4" style="text-align:center;color:white;">
                  {{ $translate("cut_and_orl") | capitalize }}
                </td>
              </tr>
              <tr>
                <td>
                  <strong>01</strong>
                </td>
                <td></td>
                <td>
                  <strong>02</strong>
                </td>
                <td></td>
              </tr>

              <tr>
                <td>
                  <strong>03</strong>
                </td>
                <td></td>
                <td>
                  <strong>04</strong>
                </td>
                <td></td>
              </tr>
              <tr>
                <td>
                  <strong>05</strong>
                </td>
                <td></td>
                <td>
                  <strong>06</strong>
                </td>
                <td></td>
              </tr>
              <tr>
                <td>
                  <strong>07</strong>
                </td>
                <td></td>
                <td>
                  <strong>08</strong>
                </td>
                <td></td>
              </tr>
              <tr>
                <td>
                  <strong>09</strong>
                </td>
                <td></td>
                <td>
                  <strong>10</strong>
                </td>
                <td></td>
              </tr>
              <tr>
                <td>
                  <strong>11</strong>
                </td>
                <td></td>
                <td>
                  <strong>12</strong>
                </td>
                <td></td>
              </tr>
              <tr>
                <td>
                  <strong>13</strong>
                </td>
                <td></td>
                <td>
                  <strong>14</strong>
                </td>
                <td></td>
              </tr>
              <tr>
                <td>
                  <strong>15</strong>
                </td>
                <td></td>
                <td>
                  <strong>16</strong>
                </td>
                <td></td>
              </tr>

              <tr class="greenbg">
                <td colSpan="4" style="text-align:center;color:white;">
                  {{ $translate("mont_and_fix") | capitalize }}
                </td>
              </tr>
            </tbody>
          </table>
        </section>
        <footer class="modal-card-foot">
          <button
            class="button"
            type="button"
            @click="isCardModalActive = false"
          >
            Close
          </button>
          <button class="button is-primary" @click="printOrder()">
            {{ $translate("print") | capitalize }}
          </button>
        </footer>
      </div>
    </b-modal>
  </section>
</template>

<script>
//import jsPDF from "jspdf";
//import "jspdf-autotable";
//import html2canvas from "html2canvas";

export default {
  name: "PrintOrder",
  props: ["order"],
  data() {
    return {
      isCardModalActive: false
    };
  },
  methods: {
    downloadOrder() {
      this.isCardModalActive = true;
    },
    printOrder() {
      //console.log("Da implementare");
      /*
      var doc = new jsPDF();
      jsPDF.autoTableSetDefaults({
        headStyles: {
          fillColor: "008a6b",
          fontStyle: "normal",
          valign: "middle",
          halign: "center"
        }
      });

      var head = [[this.$options.filters.capitalize(this.$translate("measure_shoe"))]];
      var body = [
        [
          this.$options.filters.capitalize(this.$translate("customer")),
          this.order.patient.name + " " + this.order.patient.surname,
          this.$options.filters.capitalize(this.$translate("model")),
          this.$options.filters.capitalize(this.$translate(this.order.shoeType)) +
            "," +
            this.$options.filters.capitalize(this.$translate(this.order.catalogType))
        ],
        [
          this.$options.filters.capitalize(this.$translate("patient")),
          this.order.patient.name,
          this.$options.filters.capitalize(this.$translate("variant_alias")),
          " al momento"
        ],
        [
          this.$translate("rif_calzature"),
          this.order.primaryCode,
          this.$translate("allacciaturatitle"),
          this.$options.filters.capitalize(
            this.$translate("allacciatura" + this.order.mod.allprim)
          )
        ],
        [
          this.$translate("this.order_by"),
          "Ordina per",
          this.$translate("allacciaturatitlevar"),
          this.$options.filters.capitalize(
            this.$translate(
              "allacciatura" +
                this.order.mod.allprim +
                "var" +
                this.order.mod.allvar
            )
          )
        ],
        [
          this.$translate("delivery"),
          this.$options.filters.capitalize(
            this.$translate(this.order.deliverySelected)
          ),
          this.$translate("point"),
          this.$options.filters.capitalize(this.$translate(this.order.c_point))
        ],

        [
          this.$translate("sendord_in"),
          this.order.send_date ? new Date(this.order.send_date).toLocaleDateString() : '',
          this.$translate("fondo"),
          ""
        ]
      ];

      doc.autoTable({ head: head });
      doc.autoTable({ body: body });

      head = [[this.$options.filters.capitalize(this.$translate("measure_shoe"))]];
      doc.autoTable({ head: head });

      body = [
        [
          this.$options.filters.capitalize(this.$translate("measure_file")),
          this.$options.filters.capitalize(this.$translate("measure_file"))
        ],
        [this.order.attachment.mesu_sx, this.order.attachment.mesu_dx]
      ];
      doc.autoTable({ body: body });

      doc.save("sample.pdf");
      */
    }
  }
};
</script>
-->
